export default {
  login: {
    signInWithMicrosoft: 'Sign in with Microsoft',
    singleSignOn: 'Single Sign On',
    entraSigningIn: 'Signing in with Microsoft…',
    entraFailed: 'Microsoft sign-in failed',
    entraTimedOut: 'Microsoft sign-in is taking too long — please try again.',
    entraSlowHint: 'This is taking longer than usual…',
    pendingTitle: 'Access not yet granted',
    pendingSimple: 'No EventHub role has been assigned to your account yet. Please contact your administrator.',
    pendingDismiss: 'Back to sign in',
    resumeAs: 'Resume signed-in session',
    continueWithMicrosoft: 'Continue with Microsoft',
    useDifferentAccount: 'Use a different account',
    signInDifferent: 'Sign in with a different account',
    forgetThisDevice: 'Forget this account on this device',
    resetSession: 'Stuck? Reset session & retry',
    resettingSession: 'Resetting…',
    sessionExpired: 'Your session expired — please log in again.',
    sessionEnded: 'Your session ended — please log in again.',
    serverUnreachableTitle: 'Server not reachable',
    serverUnreachableBody: 'Your sign-in is kept. Check the connection and try again.',
    orEmailPassword: 'or sign in with email',
    emailLoginToggleOpen: 'Sign in with email instead',
    emailLoginToggleClose: 'Hide email login',
    welcomeBack: 'Welcome back',
    signInTitle: 'Sign in to EventHub',
    signInSubtitle: 'Sign in with your ADG account.',
    emailLabel: 'Email',
    emailPlaceholder: "you{'@'}example.com",
    passwordLabel: 'Password',
    signInButton: 'Sign In',
    signingIn: 'Signing in…',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
  },
  reception: {
    runsOn: 'Runs on',
    pmsTitle: 'Property management system',
    pmsIntro: 'Reception runs on your PMS. You only see the features that PMS supports.',
    pmsMore: 'More PMS integrations are on the way. As each adapter ships, its supported features appear here automatically.',
    pmsMewsNote: 'Connected · full reception support',
    pmsNative: 'Native PMS',
    pmsNativeNote: 'Needs activation — contact your admin',
    pmsOther: 'Other PMS (3rd party)',
    pmsOtherNote: 'On request — contact your admin',
    pmsActive: 'Active',
    pmsAdmin: 'Admin',
    pmsOnRequest: 'On request',
    live: 'Live',
    snapshot: 'Snapshot',
    prevDayTitle: 'Previous day (←)',
    prevDay: 'Previous day',
    nextDayTitle: 'Next day (→)',
    nextDay: 'Next day',
    businessDate: 'Business date',
    backToToday: 'Back to today',
    today: 'Today',
    title: 'Reception',
    subtitle: 'Arrivals, in-house and departures for',
    pmsSettings: 'PMS settings',
    openAvailability: 'Open room availability',
    availability: 'Availability',
    openHotelRooms: 'Open the hotel-rooms reservations grid',
    hotelRooms: 'Hotel rooms',
    loading: 'Loading…',
    refresh: 'Refresh',
    findGuestTitle: 'Look up a guest or company',
    findGuest: 'Find guest',
    findReservationTitle: 'Find a reservation by name, room or confirmation number',
    findReservation: 'Find reservation',
    newReservationTitle: 'Create a new reservation',
    newReservation: 'New reservation',
    noAccess: 'You don\'t have permission to view Reception.',
    searchPlaceholder: 'Search guest, room or event…',
    guestScope: 'Guest scope',
    scopeHotel: 'Hotel',
    scopeAll: 'All',
    scopeHotelTitle: 'Overnight hotel guests only',
    scopeAllTitle: 'Include day guests (matches the dashboard total)',
    shown: '{n} shown',
    inspectAndCheckIn: 'Inspect & check in',
    assignInspected: 'Assign an inspected room',
    colGuest: 'Guest',
    colRoom: 'Room',
    colStay: 'Stay',
    colBilling: 'Billing',
    colStatus: 'Status',
    colAction: 'Action',
    nothingFor: 'Nothing here for {date}',
    openGuestProfile: 'Open guest profile',
    changeRoom: 'Change room',
    assignRoom: 'Assign a room',
    noMewsReservation: 'No MEWS reservation to assign against',
    editStay: 'Edit stay dates',
    nights: '{n} night | {n} nights',
    openBalanceTitle: 'Open balance to settle on the MEWS terminal',
    due: '{amount} due',
    companyBilled: 'company-billed',
    guestPays: 'guest pays',
    checkIn: 'Check in',
    checkingIn: 'Checking in…',
    readOnly: 'You have read-only access',
    noShowTitle: 'Mark as no-show (cancels in MEWS)',
    noShow: 'No-show',
    checkOutTitle: 'Check out — settle, invoice, print',
    checkOut: 'Check out',
    noteTitle: 'Note: {note}\n\nClick to edit',
    addNote: 'Add a note',
    noNote: 'No note',
    guestNote: 'Guest note',
    folio: 'Folio',
    cancelTitle: 'Cancel this reservation in MEWS',
    cancelAria: 'Cancel reservation',
    terminalNote: 'Payment and check-out happen on the MEWS terminal. This board reflects MEWS; it does not take money.',
    tabArrivals: 'Arrivals',
    tabInhouse: 'In-house',
    tabDepartures: 'Departures',
    arrivalsSub: '{checkedIn} checked in · {pending} pending',
    noArrivals: 'no arrivals today',
    inhouseSub: 'staying tonight',
    noInhouse: 'nobody in-house',
    departuresSub: 'settle at the terminal',
    noDepartures: 'no departures today',
    statusCheckedIn: 'checked in',
    statusConfirmed: 'confirmed',
    statusUnknown: 'unknown',
    rooms: 'Rooms',
    unavailable: 'Unavailable',
    ready: 'ready',
    dirty: 'dirty',
    blocked: 'blocked',
    occupancy: 'Occupancy',
    freeOf: '{free} of {sellable} free',
    mewsUnreachableTitle: 'Room data comes from MEWS and could not be loaded',
    mewsUnreachable: 'MEWS unreachable',
    attention: 'Attention',
    note: 'Note',
    openBalances: '{n} departure(s) with an open balance',
    outstanding: '{amount} outstanding',
    hide: 'hide',
    show: 'show',
    partial: 'Partial — not every departure was checked. Open a guest\'s folio for the authoritative balance.',
  },
  status: {
    inquiry: 'Inquiry',
    qualify: 'Qualify',
    proposal: 'Proposal',
    tentative: 'Tentative',
    definite: 'Definite',
    closedLost: 'Closed Lost',
    cancelled: 'Cancelled'
  },
  notifications: {
    title: 'Notifications',
    markAllRead: 'Mark all read',
    byAuthor: 'from',
    none: 'No notifications',
    openTaskManager: 'Open task management',
    settings: 'Notification settings',
    tasks: 'Tasks',
    reportsTab: 'Tickets',
    awaitingRetest: 'Awaiting your re-test',
    assignedToYou: 'Assigned to you',
    ticketActivity: 'Activity',
    noReportActivity: 'No tickets need you right now',
    reportDigest: '{count} ticket updates while you were away',
    enableDesktopAlerts: 'Enable desktop alerts',
    desktopAlertsOn: 'Desktop alerts on — turn off',
    event: {
      new_report: 'new ticket',
      comment: 'new comment',
      backlogged: 'moved to backlog',
      blocked: 'blocked',
      picked_up: 'picked up',
      needs_retest: 'ready for your re-test',
      retest_failed: 're-test failed',
      reopened: 'reopened',
      retest_passed: 'confirmed fixed',
      closed: 'closed',
      declined: 'declined',
      assigned: 'assigned',
      escalated: 'raised to critical',
      digest: 'updates',
    },
  },
  inside: {
    deleteBody: '"{title}" will be removed permanently.',
    title: 'Inside EventHub',
    subtitle: 'Short how-to videos — learn EventHub step by step.',
    search: 'Search videos…',
    allCategories: 'All',
    upload: 'Upload video',
    uploadFirst: 'Upload the first video',
    noMatches: 'No videos found.',
    empty: 'No videos yet.',
    draft: 'Draft',
    uploadVideo: 'Upload video',
    editVideo: 'Edit video',
    fieldTitle: 'Title',
    titlePlaceholder: 'e.g. Create an event in 2 minutes',
    fieldCategory: 'Category',
    categoryPlaceholder: 'e.g. Events, Hotel, Reporting',
    fieldDescription: 'Description',
    descriptionPlaceholder: 'What is this video about?',
    fieldVideo: 'Video file',
    keepVideo: 'leave empty = unchanged',
    fieldThumbnail: 'Thumbnail',
    optional: 'optional',
    published: 'Published (visible to everyone)',
    saving: 'Saving…',
    uploadingVideo: 'Uploading video…',
    uploadingThumb: 'Uploading thumbnail…',
    saveFailed: 'Save failed.',
    noFile: 'No video attached.',
    playFailed: 'Could not load the video.',
    deleteTitle: 'Delete video?',
    watched: 'Watched',
    markWatched: 'Mark as watched',
    uploadedBy: 'Uploaded by {who}',
    tooLarge: 'Video too large (max {max} MB). Please compress it.',
    maxSizeHint: 'MP4 recommended · max {max} MB',
    recLinkShort: 'record with Cap',
    viewLibrary: 'Library',
    viewInsights: 'Insights',
    insightsByPerson: 'By person',
    insightsByVideo: 'By video',
    insightsSearchPeople: 'Search name or email…',
    insightsSearchVideos: 'Search video…',
    insightsPeopleLabel: 'people',
    insightsVideosLabel: 'videos',
    insightsPerson: 'Person',
    insightsSortHint: 'Sort by this column',
    insightsWatched: 'Watched',
    insightsProgress: 'Progress',
    insightsStarted: 'Started',
    insightsLastSeen: 'Last seen',
    insightsNever: 'never opened',
    insightsVideo: 'Video',
    insightsOpened: 'Opened',
    insightsFinished: 'Finished',
    insightsReach: 'Reach',
    insightsNoPeople: 'No people found.',
    insightsNoVideos: 'No videos found.',
    insightsFailed: 'Insights could not be loaded. This does NOT mean nobody watched anything.',
    insightsKpiStaff: 'Active users',
    insightsKpiAvg: 'Avg. progress',
    insightsKpiAvgHint: 'of {n} published videos',
    insightsKpiComplete: 'Watched everything',
    insightsKpiNever: 'Never opened',
    insightsPrivacyNote: 'Measured against the published videos — drafts count for nobody. It shows only whether a video was opened or finished, never when someone watched or for how long.',
    recTitle: 'How to record — a short guide for authors',
    recSubtitle: 'The tool, the settings, and the one rule that is not a matter of taste.',
    recToolHeading: 'Tool',
    recTool: 'We record with Cap — open source, for macOS, Windows and Linux (Debian/Ubuntu). Studio Mode records locally with no time limit and exports up to 4K/60fps.',
    recLicence: 'Free for personal use. Recording for work here needs a desktop licence ($29/year) — please ask before your first recording.',
    recSettingsHeading: 'Settings for this library',
    recStudioMode: 'Use Studio Mode, not Instant Mode: we upload the file here, and Cap links are capped at 5 minutes.',
    recExport: 'Export as MP4; 1080p/30fps is enough — the limit here is {max} MB per video.',
    recLength: '2–4 minutes, one topic per video. Two short ones beat one long one.',
    recWindow: 'Browser window at 1920×1080, zoom 100 %, bookmarks bar and private tabs hidden.',
    recAudio: 'Record the microphone on its own track — then the audio can be replaced later without re-recording.',
    recThumbnail: 'Use Screenshot Mode for the thumbnail: an image of the page the video talks about.',
    recNoGuestData: 'Never record real guest data. Names, addresses, phone numbers and invoices from production do not belong in a video every role can watch — use test data, or anonymise before recording.',
    seenOfTotal: 'watched',
    videosCount: 'videos',
    inProgressCount: '{n} in progress',
    fieldSource: 'Source',
    sourceUpload: 'Upload',
    sourceLoom: 'Loom link',
    fieldLoomUrl: 'Loom link',
    loomHint: 'Paste the Loom share link — it is embedded directly (no upload needed).',
    viewsCount: '{n} views',
    viewsCountOne: '{n} view',
    viewsHint: 'Unique views (each user counts once)',
    mostViewed: 'Most viewed',
    filterForYou: 'For you',
    filterNew: 'New',
    filterSeen: 'Already watched',
    copyLink: 'Copy link',
    linkCopied: 'Copied',
    backToLibrary: 'Inside EventHub',
    watchedOfTotal: '{seen}/{total} watched',
    allWatched: 'All watched!',
    openCount: '{n} to go',
  },
  review: {
    changedSinceReview: 'Changed since review',
    reviewed: 'Reviewed',
    markReviewed: 'Mark as reviewed',
    markFailed: 'Could not mark as reviewed',
    unmark: 'Reset',
    unmarked: 'Reset to unseen',
    checked: 'Marked as checked',
    unchecked: 'Check reset',
    seen: 'Seen',
    markSeen: 'Mark as seen',
    seenDone: 'Marked as seen',
    seenOn: 'Seen on',
    seenFailed: 'Could not mark as seen',
    changedSinceSeen: 'Changed since seen',
    changedShort: 'Changed',
    seenNew: 'New – not seen yet',
    confirmSeenTitle: 'Confirm as seen',
    confirmSeenBody: 'Mark this event as seen?',
    confirmChangedTitle: 'Confirm changes',
    confirmChangedBody: 'This event changed since you last saw it. Review the changes and confirm as seen?',
    confirmSeenAction: 'Confirm seen',
    confirmUnseenTitle: 'Mark as unseen',
    confirmUnseenBody: 'Mark this event as unseen again? It will show as open in your list once more.',
    confirmUnseenAction: 'Mark as unseen',
    history: 'History',
    historyTitle: 'History: Seen & Changes',
    historyEmpty: 'No history yet.',
    histSeen: 'Seen',
    histUnseen: 'Reset to unseen',
    histChanged: 'Changed',
    lockedStamp: 'Locked',
    checkedByAt: 'Checked by {who} on {when}',
  },
  preflight: {
    title: 'Block Pre-Flight',
    subtitle: 'Will next week\u2019s Business Central events fit into the rooms we have?',
    prevWeek: 'Previous week',
    nextWeek: 'Next week',
    load: 'Reload',
    manualPlaceholder: 'Event no. e.g. ST26-00027',
    loadByNo: 'By no.',
    rangeUnsupported: 'Business Central rejected the week query. Enter one or more event numbers above to load them individually.',
    events: 'Events',
    overnightGuests: 'Overnight',
    roomsFreePeak: 'Free max / min',
    roomsFreeHint: 'Rooms free across ALL categories — best night of the week / weakest night. The tier table below splits the same rooms by category.',
    resetSimulation: 'Reset',
    demandTitle: 'Demand',
    demandSource: 'Business Central',
    supplyTitle: 'Capacity',
    supplySource: 'EventHub availability',
    loadingShort: 'loading\u2026',
    enriching: 'Loading participants and room wishes\u2026',
    loadingBc: 'Loading events from Business Central\u2026',
    loadingAvailability: 'Loading availability\u2026',
    availabilityUnknown: 'Availability could not be read \u2014 capacity shown as 0.',
    bcUnavailable: 'Business Central could not be reached.',
    diagnose: 'Why?',
    probe: 'Ask BC what it accepts',
    asking: 'Backend is asking',
    weekQueryUnsupported: 'The week could not be queried \u2014 this is not \u201cno events\u201d.',
    bcOnly: 'not in EventHub',
    bcOnlyHint: 'Business Central knows this event, EventHub does not hold it \u2014 nothing is blocked for it here.',
    noBc: 'no BC data',
    noBcHint: 'Business Central returned nothing for this event number, so rating and room wishes are unknown.',
    noNumber: 'no BC no.',
    noNumberHint: 'This EventHub event carries no external id, so it cannot be matched to Business Central.',
    lookbackNote: 'Events are matched by start date over the last {days} days; {hidden} that start outside this week were checked and do not overlap it.',
    weekEmptyBc: 'Business Central reports no events starting in this week.',
    weekEmptyHere: 'EventHub holds no events for this week.',
    probing: 'Asking Business Central\u2026',
    rows: 'rows',
    diagnosing: 'Checking the Business Central connection\u2026',
    diagReachable: 'Business Central itself is reachable \u2014 the failing call is the event query, not the connection.',
    diagUnconfigured: 'This backend stage has no Business Central credentials. Missing:',
    diagAuth: 'Your session was not accepted by the backend \u2014 sign in again.',
    diagUpstream: 'Business Central refused the request:',
    diagUnknown: 'Business Central answered, but not with a healthy status.',
    noEvents: 'No Business Central events start in this week.',
    night: 'Night',
    nights: 'nights',
    simulate: 'Overnight guests',
    unassigned: 'Unassigned',
    unassignedHint: 'Overnight guests whose room tier could not be read. Counted, but not charged against either tier \u2014 folding them in would hide a real shortfall.',
    unmapped: 'unmapped',
    unmappedHint: 'No field of this name in the Business Central row. Shown as unmapped rather than 0, which would read as \u201cnone\u201d.',
    showRaw: 'Show the raw Business Central row',
    ratingTitle: 'Rating, from BC field \u201c{field}\u201d',
    mustDrop: '\u2212{n} to fit',
    applyDrop: 'Apply',
    verdictIdle: 'Nothing loaded yet',
    verdictIdleHint: 'Pick a week and load it to see whether it fits.',
    verdictFits: 'The week fits',
    verdictFitsHint: 'Every night has enough rooms in the requested tier.',
    verdictShort: '{n} rooms short',
    verdictShortHint: 'Tightest night: {night} {date}, {tier}.',
    assumptions: 'One overnight guest is counted as one room \u2014 sharing would only free rooms, so this can under-promise but never over-promise. Capacity is EventHub\u2019s net availability for the property, and an event\u2019s rating applies only to guests who stated no wish of their own.',
    tier: { economy: 'Economy', comfort: 'Comfort' },
    field: {
      minParticipants: 'Min',
      maxParticipants: 'Max',
      participants: 'Participants',
      lecturers: 'Lecturers',
    },
  },
  common: {
    copy: 'Copy',
    saved: 'Saved',
    processing: 'Please wait…',
    errorLoading: 'Error loading',
    previous: 'Previous',
    next: 'Next',
    discardUnsavedChanges: 'Discard unsaved changes?',
    default: 'Default',
    deprecated: 'Legacy',
    activate: 'Activate',
    deactivate: 'Deactivate',
    later: 'Later',
    loading: 'Loading...',
    failed: 'Failed',
    collapse: 'Collapse',
    expandDetails: 'Show details',
    save: 'Save',
    saveAll: 'Save all',
    saving: 'Saving...',
    cancel: 'Cancel',
    delete: 'Delete',
    deleting: 'Deleting...',
    edit: 'Edit',
    noEditPermission: 'No edit permission',
    eventInPast: 'Event is in the past — cannot be edited',
    lockedAfterChecked: 'Function sheet is checked — editing is locked',
    notSet: 'Not set',
    back: 'Back',
    rename: 'Rename',
    change: 'Change',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    refresh: 'Refresh',
    notes: 'Notes',
    justNow: 'just now',
    minutesAgo: 'min ago',
    hoursAgo: 'h ago',
    dayAgo: 'd ago',
    daysAgo: 'd ago',
    export: 'Export',
    import: 'Import',
    close: 'Close',
    download: 'Download',
    remove: 'Remove',
    count: 'Count',
    deletePermanently: 'Delete permanently',
    event: 'Event',
    start: 'Start',
    end: 'End',
    print: 'Print',
    clear: 'Clear',
    copied: 'Copied!',
    reload: 'Reload',
    retry: 'Retry',
    confirm: 'Confirm',
    confirmTitle: 'Confirm',
    discard: 'Discard',
    keepEvent: 'Keep event',
    ok: 'OK',
    add: 'Add',
    optional: 'optional',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    showMore: 'Show More',
    showLess: 'Show Less',
    yes: 'Yes',
    no: 'No',
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    actions: 'Actions',
    details: 'Details',
    showAllData: 'Show All Data',
    hideAllData: 'Hide All Data',
    day: 'Day',
    days: {
      label: 'Days',
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
    },
  },
  datePicker: {
    selectRange: 'Select date range',
    startTime: 'Start Time',
    endTime: 'End Time',
    clickStart: 'Click a start date',
    apply: 'Apply',
  },
  signageEmulator: {
    title: 'Signage Emulator',
    subtitle: 'What the room signs show at a chosen time — from the live signage feed',
    day: 'Day',
    time: 'Time',
    now: 'Now',
    refresh: 'Reload',
    window: 'The feed covers today 00:00 to 72 hours from now. Later times are not in the feed yet.',
    syncedAt: 'Feed as of',
    free: 'Free',
    next: 'Up next',
    noneNext: 'Nothing else booked today',
    noRooms: 'No rooms with digital signage.',
    loadFailed: 'Could not load the signage feed',
    onlyBooked: 'Booked only',
    rooms: 'rooms',
    unknownRoom: 'Not marked as a signage room',
  },
  menu: {
    businessSchool: 'Business School',
    dashboard: 'Dashboard',
    eventBookings: 'Events',
    eventManagement: 'Event Management',
    eventSessions: 'Event Sessions',
    attendees: 'Attendees',
    availabilities: 'Availabilities',
    blockManager: 'Block Manager',
    reservations: 'Room & Space Planning List',
    signageEmulator: 'Signage Emulator',
    roomOccupancy: 'Release Overview Seminar & Event Rooms',
    pmsBoard: 'Reception',
    bookingPlan: 'Booking Plan',
    spaces: 'Spaces',
    menus: 'Menus',
    cateringOrders: 'Catering Orders',
    beo: 'BEO',
    exporter: 'Exporter',
    reports: 'Reports',
    mewsData: 'MEWS Data',
    mewsServices: 'MEWS Services & Products',
    analytics: 'Analytics',
    observability: 'Observability',
    stockManagement: 'Stock Management',
    miceBoard: 'MICE Board',
    miceAnalytics: 'MICE Analytics',
    contacts: 'Contacts',
    propertySetup: 'Property Setup',
    pmsSettings: 'PMS Settings',
    administration: 'Hub Admin',
    rolesPermissions: 'Roles & Permissions',
    archive: 'Archive',
    events: 'Events',
    equipment: 'Equipment',
    masterdataChain: 'Master Data Chain',
    dataManagement: 'Data Management',
    middleware: 'Middleware',
    auditLog: 'Audit Log',
    errorLog: 'Error Log',
    azurePbis: 'Azure PBIs',
    devOps: 'Dev Ops',
    roadmap: 'Roadmap',
    insideEventhub: 'Inside EventHub',
    conflictResolution: 'Conflict Board',
    hotelOptimisation: 'Hotel Optimisation',
    revenueManagement: 'Revenue Management',
    fnbEquipment: 'F&B / Equipment',
    themes: 'Themes',
    rawTables: 'Raw Tables',
  },
  userMenu: {
    profile: 'Profile',
    account: 'Account & security',
    language: 'Language',
    passwordSection: 'Password',
    ssoPasswordHint: 'You sign in with Microsoft (Entra ID). Your password is managed there and can’t be changed here.',
    changePassword: 'Change Password',
    systemStatus: 'System Status',
    about: 'About',
    developedBy: 'Made by',
    logout: 'Logout',
    report: 'Report',
    documentation: 'Documentation',
    myTasks: 'My tasks',
    notifications: 'Notifications',
    tasksNotifications: 'Tasks & Notifications',
    tabTasks: 'Tasks',
    tabNotifications: 'Notifications',
    noTasks: 'No tasks assigned to you',
    noNotifications: 'No notifications',
    notificationsComingSoon: 'Notifications coming soon',
    filterAll: 'All',
    filterOpen: 'Open',
    filterDone: 'Done',
  },
  changePasswordModal: {
    title: 'Change Password',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: 'Enter current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter new password (min. 8 characters)',
    confirmPassword: 'Confirm New Password',
    confirmPasswordPlaceholder: 'Repeat new password',
    minChars: 'At least 8 characters required',
    sameAsOld: 'New password must be different from current password',
    mismatch: 'Passwords do not match',
    cancel: 'Cancel',
    submit: 'Change Password',
    saving: 'Saving...',
    success: 'Password changed successfully!',
    close: 'Close',
    errorIncorrect: 'The current password is incorrect.',
    errorMinLength: 'The new password must be at least 8 characters.',
    errorNotAvailable: 'Password change is not available for this account.',
    errorGeneric: 'Could not change password. Please try again.',
  },
  mewsServices: {
    title: 'MEWS Services & Products',
    services: 'Services',
    products: 'Products',
    rules: 'Rules',
    selectService: 'Select a service to view its products and rules',
    loadingServices: 'Loading services...',
    loadingProducts: 'Loading products...',
    clickToLoadProducts: 'Click to load products',
    searchProducts: 'Search products...',
    activeOnly: 'Active only',
    noProductsFound: 'No products found',
    noRulesFound: 'No rules found for this service',
    productDetails: {
      ordering: 'Ordering',
      capacity: 'Capacity',
      categoryId: 'Category ID',
      accountingCategoryId: 'Accounting Category ID',
      classifications: 'Classifications',
    },
    ruleDetails: {
      created: 'Created',
      updated: 'Updated',
      conditions: 'Conditions',
      rateId: 'Rate ID',
      rateGroupId: 'Rate Group ID',
      businessSegmentId: 'Business Segment ID',
      resourceCategoryId: 'Resource Category ID',
      origin: 'Origin',
      minTimeUnits: 'Min Time Units',
      maxTimeUnits: 'Max Time Units',
    },
  },
  equipment: {
    title: 'Equipment Management',
    equipment: 'Equipment',
    categories: 'Categories',
    newEquipment: 'New Equipment',
    newCategory: 'New Category',
    editEquipment: 'Edit Equipment',
    editCategory: 'Edit Category',
    deleteEquipment: 'Delete Equipment',
    deleteCategory: 'Delete Category',
    allProperties: 'All Properties',
    allCategories: 'All Categories',
    allStatus: 'All Status',
    searchEquipment: 'Search equipment...',
    noEquipmentFound: 'No Equipment Found',
    addEquipment: 'Add Equipment',
    stockQuantity: 'Stock Quantity',
    equipmentCount: 'Equipment Count',
    code: 'Code',
    category: 'Category',
    property: 'Property',
    deleteConfirm: 'Are you sure you want to delete',
    deleteWarning: 'This action cannot be undone.',
    saving: 'Saving...',
    deleting: 'Deleting...',
  },
  adyen: {
    title: 'Adyen — Terminals & POS',
    subtitle: 'Connect card terminals, test them, and take payments on the terminal',
    property: 'Property',
    testConnection: 'Test connection',
    credentials: 'Credentials',
    credentialsHint: 'Stored per property. Secrets are masked.',
    secretSet: 'set',
    secretUnset: 'not set',
    save: 'Save',
    saving: 'Saving …',
    saveFailed: 'Save failed',
    terminals: 'Terminals',
    refresh: 'Refresh',
    loading: 'Loading …',
    noTerminals: 'No terminals found. Check credentials and refresh.',
    colTerminal: 'Terminal',
    colStatus: 'Status',
    colActions: 'Actions',
    unassigned: 'unassigned',
    connect: 'Connect',
    diagnose: 'Diagnose',
    test: 'Test payment',
    posPay: 'Pay on terminal (POS)',
    terminal: 'Terminal',
    amount: 'Amount',
    currency: 'Currency',
    reference: 'Reference',
    referenceHint: 'e.g. invoice no. (optional)',
    charge: 'Charge',
    charging: 'Charging …',
    checking: 'Checking …',
    unconfigured: 'Not configured',
    connected: 'Connected',
    error: 'Error',
    unconfiguredHint: 'Adyen is not configured for this property yet.',
    loadFailed: 'Could not load terminals',
    boarded: 'Terminal ready',
    actionFailed: 'Action failed',
    online: 'Online',
    offline: 'Offline / unreachable',
    testPayment: 'Test payment',
    verdict_approved: 'approved',
    verdict_refused: 'refused',
    verdict_pending: 'pending (continue on terminal)',
    verdict_unknown: 'unknown',
  },
  stripeTerminal: {
    title: 'Stripe Terminal — Readers & POS',
    subtitle: 'Pair Stripe card readers, test them, and take payments on the reader',
    property: 'Property',
    testConnection: 'Test connection',
    credentials: 'Credentials',
    credentialsHint: 'Stored per property. Secrets are masked.',
    secretKey: 'Secret key',
    secretKeyHint: 'sk_test_… = test mode, sk_live_… = live',
    keyFormat: 'Expected a secret key (sk_test_… / sk_live_…), not a publishable key.',
    location: 'Terminal location',
    locationHint: 'tml_… — filters readers; required to pair one',
    secretSet: 'set',
    secretUnset: 'not set',
    save: 'Save',
    saving: 'Saving …',
    saveFailed: 'Save failed',
    readers: 'Readers',
    refresh: 'Refresh',
    loading: 'Loading …',
    noReaders: 'No readers found. Check credentials, or pair one below.',
    colReader: 'Reader',
    colStatus: 'Status',
    colActions: 'Actions',
    unknownStatus: 'unknown',
    status: 'Status',
    test: 'Test payment',
    simulateCard: 'Tap test card',
    cancel: 'Cancel',
    registrationCode: 'Registration code',
    label: 'Label',
    labelHint: 'e.g. Front desk',
    register: 'Pair reader',
    registering: 'Pairing …',
    registered: 'Reader paired',
    registerHint: 'Enter the code shown on the reader. In test mode, simulated-wpe creates a simulated reader — no hardware needed.',
    posPay: 'Pay on reader (POS)',
    reader: 'Reader',
    amount: 'Amount',
    currency: 'Currency',
    reference: 'Reference',
    referenceHint: 'e.g. invoice no. (generated if empty)',
    charge: 'Charge',
    charging: 'Charging …',
    checking: 'Checking …',
    unconfigured: 'Not configured',
    connected: 'Connected',
    error: 'Error',
    modeTest: 'Test',
    modeLive: 'Live',
    unconfiguredHint: 'Stripe Terminal is not configured for this property yet.',
    loadFailed: 'Could not load readers',
    actionFailed: 'Action failed',
    online: 'Online',
    offline: 'Offline',
    testPayment: 'Test payment',
    pollTimeout: 'Still waiting on the reader — check it, or cancel',
    verdict_approved: 'approved',
    verdict_refused: 'refused',
    verdict_canceled: 'canceled',
    verdict_pending: 'waiting for card on the reader',
  },
  eventManagement: {
    streamAll: 'All',
    scopeYear: 'Year',
    scopeAll: 'All',
    emptyTitleAll: 'No events found.',
    tabOverview: 'Overview',
    tabMine: 'My events',
    title: 'Event Management',
    subtitle: 'Planning cockpit for event managers',
    loading: 'Loading events …',
    prevYear: 'Previous year',
    nextYear: 'Next year',
    untitled: 'Untitled',
    noManager: 'No manager',
    unknownManager: 'Unknown',
    eventsShort: 'events',
    paxShort: 'pax',
    daysShort: 'days',
    emptyTitle: 'No events in {year}',
    emptyHint: 'Pick a different stream or year.',
    kpiEvents: 'Events',
    kpiPax: 'Total participants',
    kpiPaxSub: 'Summed across all events',
    kpiDays: 'Event days',
    kpiDaysSub: 'Sum of event days',
    kpiAvgValue: 'Avg value',
    kpiAvgValueSub: 'People × days per event',
    perManagerTitle: 'Events per manager',
    perManagerSub: 'Split by event manager',
    showMoreManagers: 'Show {n} more',
    showFewerManagers: 'Show fewer',
    valueTableTitle: 'Value per event',
    valueTableSub: 'Value = people × days',
    colEvent: 'Event',
    colPax: 'Pax',
    colDays: 'Days',
    colValue: 'Value',
    replanTitle: 'Re-plan for {year}',
    replanSub: 'The strongest events — worth repeating',
    replanEmpty: 'Nothing to plan.',
    replanCalendar: {
      open: 'Open planning calendar',
      title: 'Plan the {year} programme',
      subtitle: "Last year's programme — weekdays aligned",
      year: 'Year',
      month: 'Month',
      events: 'events',
      plannedPax: 'planned participants',
      holiday: 'Holiday',
      load: 'Load',
      empty: 'No seminars or business-school events in the selected year.',
    },
  },
  setupTypes: {
    theatre: 'Theatre (rows)',
    classroom: 'Classroom (parliamentary)',
    u_shape: 'U-shape',
    block: 'Block (conference)',
    round: 'Banquet (round tables)',
    retreat: 'Retreat',
  },
  dashboard: {
    secReleases: 'Releases',
    releasesOpenPage: 'Hotel Optimisation',
    releasesEventSummary: '{n} events with open releases · {r} ready',
    beta: 'Beta — under development, scope may still change',
    toAvailabilities: 'Go to the availabilities page',
    clear: 'Clear',
    secConflicts: 'Conflicts',
    secEvents: 'Events',
    secHotelAvailability: 'Hotel availability',
    secHotelReleases: 'Hotel releases',
    secHotelOptimization: 'Hotel optimisation',
    secMyTasks: 'My tasks',
    secPmsSyncIssues: 'PMS sync issues',
    secSpaceConfirmations: 'Room confirmations',
    secSpacesAvailability: 'Space availability',
    secOperationsToday: 'Operations today',
    secPipeline: 'Pipeline',
    openReception: 'Open reception — arrivals, in-house, departures (new tab)',
    reception: 'Reception',
    openMiceBoard: 'Open MICE board',
    miceBoard: 'MICE board',
    weatherMoodsView: 'View all weather moods',
    weatherMoodsViewAria: 'View weather moods',
    guestsThisWeek: 'Guests this week — to the participants (week view)',
    eventTrend: 'Event trend — to the analytics page',
    greetingMorning: 'Good morning',
    greetingDay: 'Good afternoon',
    greetingEvening: 'Good evening',
    changeBlock: 'Change block',
    changeBlockTitle: 'Adjust the request with current availability',
    release: 'Release',
    reject: 'Reject',
    rejectTitle: 'Reject the release',
    confirmAllRooms: 'Confirm all room bookings for this event',
    openInEvent: 'Open in event',
    openBookingInEvent: 'Open the room booking in the event',
    openInReservations: 'Open in reservations',
    openInReservationsWeek: 'Open in reservations — that week',
    changeRoom: 'Change room',
    changeRoomTitle: 'Switch to a different (better) room',
    confirm: 'Confirm',
    confirmBookingTitle: 'Confirm the room booking',
    openSessionInEvent: 'Open the session in the event',
    assignRoom: 'Assign room',
    chooseRoom: 'Choose room…',
    heroToday: 'Today',
    heroPrevDay: 'Previous day',
    heroNextDay: 'Next day',
    searchShort: 'Search…',
    searchLong: 'Search events, reservations, guests, companies…',
    guestsPerWeek: 'Guests / week',
    wkPrev: 'Prev', wkThis: 'This', wkNext: 'Next',
    wkPrevFull: 'Last week', wkThisFull: 'This week', wkNextFull: 'Next week',
    guestsWord: 'guests',
    eventTrendLabel: 'Event trend',
    trendToday: 'Today',
    trendMinus3: '−3d',
    trendPlus3: '+3d',
    statInHouse: 'In house',
    statArrival: 'Arrivals {day}',
    statDeparture: 'Departures {day}',
    statMewsOnly: 'MEWS only',
    splitHotel: 'Hotel',
    splitDayguest: 'Day',
    mewsEhSub: 'MEWS {mews} · EventHub {eh}',
    snapshotNoData: 'Snapshot without occupancy data',
    synced: 'in sync',
    dayToday: 'today',
    dayPast: 'on this day',
    daySelected: 'on the selected day',
    briefingLoading: 'Loading briefing…',
    briefingQuiet: 'Today is quiet. Use the time for the week ahead.',
    briefingNoOps: 'No operational entry for this day.',
    briefingToday: 'You have {arrivals} arrivals and {events} ongoing events today.',
    briefingSelected: 'On the selected day: {arrivals} arrivals and {events} ongoing events.',
    releaseLoading: 'Loading release requests…',
    releaseNoneOpen: 'No open release requests.',
    releaseNoneWaiting: 'No blocks awaiting release.',
    releaseSubtitle: '{count} blocks · {rooms} rooms to release',
    releaseAllLoaded: 'All requests loaded',
    blockOfTotal: 'Block {index} of {total}',
    inDaysShort: 'in {days}d',
    optLoading: 'Loading room optimisation…',
    optNone: 'No unused rooms · all good',
    sbcLoading: 'Loading open room bookings…',
    sbcAllConfirmed: 'All room bookings are confirmed.',
    sbcAllLoaded: 'All open bookings loaded',
    sbcNoneWaiting: 'No room booking awaiting confirmation.',
    sbcRoomsWaiting: '{count} room awaiting confirmation | {count} rooms awaiting confirmation',
    sbcEventsCount: '{count} event | {count} events',
    sbcSessionsNoRoom: '{count} session without a room | {count} sessions without a room',
    sbcAtLeast: 'at least {value}',
    roomsSuffix: 'rooms',
    daysSuffix: 'days',
    paxSuffix: 'pax',
    roomWord: 'Room',
    sessionsNoRoomHeading: 'Sessions without a room',
    roomRequestsHeading: 'Room requests',
    requestedShort: 'requested',
    newRoom: 'New room',
    assignHint: 'The booking is created as suggested and then appears above for confirmation.',
    changeHint: 'The booking stays open and still needs confirmation afterwards.',
    bookingsTogetherTitle: '{n} individual bookings across {d} days are confirmed together',
    roomCategory: 'Room category',
    availRetry: 'Check again',
    approveAvailabilityUnverifiable: 'Not approved: MEWS returned no availability for this room category. The request stays open — please approve again in a moment.',
    approveWaitAvailability: 'Availability is still loading from MEWS — approval possible afterwards.',
    approveAvailabilityUnknown: 'Availability could not be loaded from MEWS — approval only after a successful check (“Check again”).',
    availNotChecked: 'Availability could not be checked',
    releaseAndCreate: 'Release and create the MEWS block',
    releaseFailedMsg: 'The release could not be completed.',
    rejectFailedMsg: 'The rejection could not be completed.',
    releaseFailed: 'Release failed',
    rejectFailed: 'Rejection failed',
    tasksSubtitle: '{n} open · sorted by due date',
    naLoading: 'Loading issues…',
    naAllSynced: 'Everything in sync with MEWS.',
    naSubtitle: '{n} open items · check now',
    csAllGood: 'All clear',
    csNoRoom: 'No room',
    csLoading: 'Loading conflicts…',
    eclUpcoming: 'Upcoming events',
    eclLoading: 'Loading events…',
    eclNoneNow: 'No events are currently taking place.',
    eclNoneUpcoming: 'No upcoming events.',
    eclNoneNowShort: 'None now',
    eclNoneUpcomingShort: 'None upcoming',
    umdPipelineValue: 'Pipeline value',
    umdActivePipeline: 'Active pipeline',
    umdNoRevenue: 'No revenue',
    umdMissingRevenue: ' · {n} without revenue estimate',
    availLoading: 'Loading availability…',
    hatSubtitle: 'Free hotel rooms · today & 3 days',
    roomsFree: 'rooms free',
    todayNext3: 'Today & next 3 days',
    satSubtitle: 'Free spaces · today & 3 days',
    occOver: 'Over', occFull: 'Full', occTight: 'Tight', occFree: 'Free',
    spaceFreeSingular: 'space free', spaceFreePlural: 'spaces free',
    gsMyEvents: 'My events',
    gsManagerSub: 'Product / event manager',
    gsNoManagerEvents: 'No upcoming events where you are the manager.',
    gsCurrentEvents: 'Current events',
    kindEvents: 'Events', kindEvent: 'Event',
    kindReservations: 'Reservations', kindReservation: 'Reservation',
    kindGuests: 'Guests', kindGuest: 'Guest',
    kindCompanies: 'Companies', kindCompany: 'Company',
    gsNextEvents: 'The next events',
    gsAllEvents: 'All events',
    gsCreateEvent: 'Create new event',
    bavLoadingHistory: 'Loading history …',
    bavNoData: 'No data',
    bavOnline: 'Online',
    bavRequests: '{count} request | {count} requests',
    bavShort: 'Short interruption (< 1 min)',
    bavDown: 'Outage',
    bavAvailable: 'available',
    bavDowntime: '{d} unreachable',
    bavRestarts: '{count} restart | {count} restarts',
    bavIncidents: 'Latest interruptions',
    bavNoOutage: 'no interruption',
    bavCauseRestart: 'Restart (e.g. deploy)',
    bavCauseCrash: 'Crashed, restarted',
    bavCauseSilent: 'no sign of life',
    bavOngoing: 'ongoing',
    bavMeasuredSince: 'Measured since {date}',
    bavExplain: 'The backend checks in every 30 seconds. An interruption is the time no server was running – to the second for restarts. Grey: from before measuring and without requests. Errors of individual functions are on the Observability page.',
    csEventNoRoom: 'Event or session without a room',
    csRoomTooSmall: 'Room too small',
    csGroupLargerThanRoom: 'Group larger than the room',
    toDayguest: 'Day guest',
    csHotelBlockError: 'Hotel block error',
    csBlockSyncFailed: 'Block sync failed',
    csHotelBlockDiff: 'Hotel block mismatch',
    csBlockedVsNights: 'Blocked ≠ overnights',
    availChecking: 'Checking availability…',
    hatHeader: 'Today {n} rooms free',
    satHeader: 'Today {n} spaces free',
    viewAll: 'View all',
    tOpen: 'Open', tOpenSub: 'All active tasks',
    tOverdue: 'Overdue', tOverdueSub: 'Due before today',
    tTodayDue: 'Due today', tTodayDueSub: 'By end of day',
    tWeek: 'This week', tWeekSub: 'Next 7 days',
    tNoDue: 'No due date', tNoDueSub: 'No date set',
    optSubtitle: '{rooms} rooms releasable · {events} events',
    optReleaseNow: 'Release now', optPropose50: 'Suggest −50%', optAdjustSmall: 'Adjust small groups',
    optTier1Sub: '{n} events · 0–30 days', optTier2Sub: '{n} events · 31–60 days', optTier3Sub: '{n} events · <7 pickups',
    eclRunningNow: 'Running now', eclTabCurrent: 'Current', eclTabNext: 'Next',
    eclEntry: '{n} entry', eclEntries: '{n} entries',
    eclSinceYesterday: 'since yesterday', eclSinceDays: '{n}d ago',
    eclSubRunning: '{n} running now', eclSubNext: 'The next {n}',
    umdSubBase: 'Next 3 months · MICE', umdSubtitle: 'Next 3 months · MICE · {n} events',
    umdOpenEvents: '{n} open events', umdRevenueMissing: 'Revenue estimate missing for {n} events',
    csToCheck: 'to check', csCritical: 'critical',
    fromLocalSnapshot: 'From the local availability snapshot.',
    sinceToday: 'since today', sinceYesterday: 'since yesterday', sinceDays: '{n} days ago',
    gsQuickAccess: 'Quick access', gsSearching: 'Searching…', gsBackToQuick: 'Back to quick access',
    gsNoContact: 'No matching contact found for your account.', gsNoUser: 'User could not be determined.',
    gsStreamSeminar: 'Seminar', gsStreamInternal: 'Internal', gsStreamBs: 'Business School',
    sbcCurrent: 'Current',
  },
  eventBookings: {
    pickupErroredTooltip: 'Reservations with a pickup error — no room held',
    packagesTab: 'Package',
    invalidDateRange: 'Arrival must be before departure.',
    contactResolveFailed: 'Contact could not be resolved.',
    event: 'Event',
    addNoticeOngoingTitle: 'Event is running',
    addNoticeOngoingBody: 'This event has already started. Participants can still be added.',
    addNoticeOngoingDayguest: 'Day guests are no problem — they need neither a room nor a block slot.',
    addNoticeOngoingHotel: 'Hotel guests only while the block still holds rooms — otherwise that option is greyed out in the form.',
    addNoticePastTitle: 'Event is over',
    addNoticePastBody: 'This event is in the past.',
    addNoticePastHint: 'Adding afterwards is possible, but it changes reporting and possibly invoices. Please only to correct a record.',
    addNoticeStreamTitle: 'Not possible for this stream',
    addNoticeStreamBody: 'This event stream has no participant form.',
    addNoticeProceed: 'Add anyway',
    customerBillOpen: 'Invoice',
    customerBillOpenHint: 'Open the invoice in MEWS',
    customerUnbilled: '{n} position(s) not on a bill yet',
    customerLinesTitle: 'Charged by EventHub',
    customerLinesEmpty: 'No products booked to the customer',
    customerLinesEmptyHint: 'Set a product\'s charge target to "Customer" in the Products tab to see it here.',
    customerLineNoPrice: 'No price is recorded for this line.',
    customerLineCharged: 'charged',
    customerLineOpen: 'open',
    customerMewsTitle: 'On the PMS account',
    customerNotInMews: 'Customer is not linked to MEWS',
    customerNotInMewsHint: 'Without a MEWS account the PMS can hold nothing for this customer.',
    customerProductsNone: 'Customer products — none yet',
    customerProductsCount: 'Customer products: {ours} from EventHub, {pms} in the PMS',
    hideCancelled: 'Hide cancelled',
    hideCancelledHint: 'Hide cancelled participants from the list. Rows cancelled only in MEWS stay visible.',
    cancelledHiddenCount: '{n} cancelled hidden',
    showCancelledParticipantsHint: 'Show cancelled participants again.',
    stayCheckedIn: 'Checked in',
    stayCheckedOut: 'Checked out',
    stayWaiting: 'Waiting',
    stayNoShow: 'No-show',
    stayHint: {
      checked_in: 'Checked in in MEWS (state: Started).',
      checked_out: 'Checked out in MEWS (state: Processed).',
      waiting: 'Arrival day ({date}) — MEWS reports no check-in yet.',
      no_show: 'Arrival was {date} and MEWS never reported a check-in. Worth checking.',
    },
    noServices: 'No services',
    noServicesHint: 'On site, books no services (keine Leistungen)',
    definiteShort: 'definite',
    vsPreviousPeriod: 'vs previous period',
    blockRoomsShort: 'block rooms',
    ackUnseenTitle: 'Unseen',
    currentShort: 'current',
    pastShort: 'past',
    runningShort: 'running',
    upcomingShort: 'upcoming',
    hotelGuestsKpi: 'Hotel guests',
    hotelGuestsKpiHint: 'Booked hotel guests vs the rooms planned in the room block',
    blockPlannedShort: 'Block',
    blockPlannedHint: 'Rooms planned in the room block',
    overBlockHint: 'More hotel guests than planned in the block',
    hotelFillTitle: '{booked} of {planned} block rooms booked · {open} still free',
    confirmedShort: 'confirmed',
    ofPlanned: 'of',
    participantsFillTitle: '{booked} of {planned} planned participants booked · {open} still open',
    ackSeenShort: 'seen',
    trendSummary: 'Today {today} running events · avg {back}/day last 14 days · avg {ahead}/day next 14 days',
    checksAllOk: 'All good',
    deletedPriceList: 'deleted price list',
    packagesCountLabel: '{count} package | {count} packages',
    packageContents: 'Contents',
    packagePerPerson: 'Price',
    billedZeroPriceShort: '0 € by price list',
    manualPriceResetHint: 'Discard the typed price – the price list prices the line again',
    statusFilterNone: 'No status selected — click a status above.',
    linesTotal: 'Total',
    rulesAllTitle: 'Products triggered by rules',
    manualAllTitle: 'Products added manually',
    moneyCharged: 'charged',
    moneyOpen: 'open',
    ruleChipSingular: 'rule',
    ruleChipPlural: 'rules',
    addLine: 'Add',
    addLineProduct: 'Product',
    addLineProductHint: 'Single products from the catalogue',
    addLinePackage: 'Package',
    addLinePackageHint: 'Predefined bundle of several products',
    statusFilterCharged: 'Charged',
    statusFilterPending: 'Pending',
    statusFilterCancelled: 'Cancelled',
    statusFilterError: 'Error',
    statusCharged: 'Charged',
    statusPending: 'Pending',
    statusCancelled: 'Cancelled',
    statusPlanned: 'Planned',
    statusFailed: 'Failed',
    statusFilterEmpty: 'No lines with this status.',
    statusFilterShowAll: 'Show all',
    eventWithoutSessions: 'Event without sessions',
    convertParticipantTypeShort: 'Change type – rebooks in MEWS',
    detailTabDetails: 'Details',
    detailTabProducts: 'Products',
    detailTabMews: 'MEWS & bills',
    detailTabSystem: 'System',
    forceAllCategoriesConfirmOn: 'Turn this on for this event?',
    forceAllCategoriesConfirmOff: 'Turn this off again for this event?',
    forceAllCategoriesNowOn: 'Cross-category fill is now on for this event.',
    forceAllCategoriesNowOff: 'Cross-category fill is now off for this event.',
    costObject: 'Cost Object',
    roomSetup: 'Room Setup',
    title: 'Events',
    newEvent: 'New Event',
    newInternalEvent: 'New internal event',
    today: 'Today',
    spacesCount: 'Spaces',
    sessionsCount: 'Sessions',
    openBookingPlan: 'Open Booking Plan',
    updatedAnyTime: 'Updated: any time',
    updatedFilterTitle: 'Last changed',
    updatedFilterShort: 'Changed',
    updatedFilterNote: 'When the event was last edited — not when it takes place. The period is chosen with the time filter in the header.',
    updatedFilterHint: 'Filters by last-changed date: shows what was recently edited. The event\u2019s own dates are chosen with the time filter in the header.',
    updatedLast1d: 'Last 24 hours',
    updatedLast2d: 'Last 2 days',
    updatedLast3d: 'Last 3 days',
    updatedLast7d: 'Last 7 days',
    updatedCustomRange: 'Custom range',
    // Managed block modal (PUT/DELETE /api/events/:eventId/blocks)
    editBlock: 'Edit hotel block',
    otherCategory: 'other category',
    otherCategoryCount: '{n} other category',
    crossCategoryHint: 'Different category booked',
    pickupsByCategory: 'Pickups by category',
    manageBlock: 'Manage block',
    selectBlockToEdit: 'Select block to edit',
    editBlockMewsHint: 'Availability is checked first. The current block stays unchanged if MEWS cannot confirm the change.',
    editBlockDbOnlyHint: 'No MEWS block linked — database-only change.',
    editBlockNotInMewsTitle: 'Not created in MEWS',
    editBlockNeedsHealHint: 'This block failed to create in MEWS. Editing dates here only updates the database — it does not retry MEWS. Change the dates if needed and Save, then use "Check & fix blocks" on this event to retry creating the block in MEWS.',
    editBlockSuccess: 'Block updated',
    editBlockDatesRequired: 'Arrival and departure dates are required',
    editBlockDateOrder: 'Arrival must be on or before departure',
    editBlockRoomCount: 'Room count must be zero or positive',
    editBlockMewsError: 'MEWS rejected the change',
    editBlockConfigError: 'Property MEWS settings missing',
    editBlockPeriodHint: 'You can extend, shorten or move the period. Existing reservations keep their own stay dates.',
    addPeriodGuidance: 'To add more beds for only part of the stay: do NOT shorten this block (that replaces it entirely). Instead create separate blocks with non-overlapping periods - e.g. 25 for the 1st-4th, 30 for the 5th-6th, 25 for the 7th-10th.',
    // Create has no reservations behind it yet, so it drops that clause.
    createBlockPeriodHint: 'You can extend, shorten or move the period.',
    capacityConflictTitle: 'Rooms held exceed max participants',
    capacityConflictMsg: 'This event holds {rooms} room(s), but max participants is {max}. The stage change cannot be saved until the two agree.',
    capacityConflictRaiseMax: 'Raise max participants to {rooms}',
    capacityConflictAdjustRooms: 'Adjust rooms instead',
    blockRoomsOverCapacity: 'Takes rooms held to {rooms}, above max participants ({max}). The event cannot move to the next stage until the two agree.',
    editBlockRoomTypeRequired: 'Choose a room category',
    editBlockReplacementRoomsRequired: 'Set at least one room left when changing the category or replacing the period.',
    editBlockAvailabilityShortfall: 'Not enough rooms available',
    editBlockAvailabilityCheckFailed: 'Availability could not be verified. The block was not changed.',
    editBlockCategoryExists: 'This event already has an active block for that room category. Keep periods disjoint: shorten the base block to the unchanged nights, then add the heavier nights separately.',
    editBlockCategoryChangeSummary: '{from} will be closed. {rooms} remaining room(s) move to a new {to} block. {booked} existing reservation(s) stay on {from} with their confirmed category.',
    blockManagedFromHotelTab: 'Changed from the event hotel tab',
    availableRoomsTarget: 'Rooms left',
    roomsLeft: 'rooms left',
    roomsLeftShort: 'LEFT',
    roomsLeftTotalHint: 'Sum of rooms left across active blocks',
    roomsRequestedNoHold: 'rooms requested, no active hold',
    roomsAwaitingApprovalHint: 'rooms requested, awaiting approval',
    approvalAvailabilityLoading: 'Checking availability…',
    approvalAvailabilityUnavailable: 'Availability could not be checked',
    approvalAvailabilityPerNight: 'Free by night',
    approvalAvailabilityBusiestDay: 'free on the busiest night',
    approvalAvailabilityPossible: 'Possible',
    approvalAvailabilityOverCapacity: 'Over capacity · {count} short',
    approvalAvailabilityOverCapacityTitle: '{requested} rooms requested, but only {available} are free on the busiest night. {missing} rooms are short.',
    debitedReservations: 'debited reservations',
    roomsLeftAfterSave: 'rooms left after save',
    debitedRequestedHint: 'Booked rooms / total allocation',
    debitedRequestedShort: 'booked',
    blockedPerNight: 'Blocked',
    releaseBlock: 'Dissolve block',
    releaseBlockMenuHint: 'Held rooms go back to availability; reservations stay',
    releaseBlockConfirmDelete: 'This block has no reservations. It will be deleted in MEWS, and its {free} held rooms go back to availability.',
    releaseBlockConfirmRelease: '{free} free rooms go back to availability. The block stays with its {booked} reservation(s) so they stay linked to it.',
    releaseBlockNothingToRelease: 'All rooms are booked – nothing to release. The block stays for its reservations.',
    blockReleasedFromHotelTab: 'Dissolved from the event hotel tab',
    releaseBlockSuccessDeleted: 'Block deleted. Its rooms are available again.',
    releaseBlockSuccessReleased: '{free} rooms released. The block stays for {booked} reservation(s).',
    releaseBlockSuccessNothing: 'Nothing released – every room in the block is booked.',
    releaseBlockFailed: 'Block could not be dissolved',
    new: 'New',
    newInquiry: 'New event',
    createInquiry: 'Create event',
    descriptionPlaceholder: 'e.g. ADG Leadership Seminar',
    partOnSite: 'On-site',
    partOnline: 'Online',
    partHybrid: 'Hybrid',
    newInternal: 'Internal Booking',
    newEventOption: 'Event',
    // Single-button label on the events page — MICE creation moved to
    // the mice-board page, so the events page only spawns internal events.
    createInternalEvent: 'Create internal event',
    internalEventBannerTitle: 'You are creating an internal event',
    internalEventBannerHint: 'Use this for in-house bookings. MICE inquiries are created from the MICE Board page.',
    customFields: 'Custom Fields',
    addField: 'Add Field',
    noCustomFields: 'No custom fields yet. Click "Add Field" to add one.',
    fieldName: 'Field name',
    fieldValue: 'Value',
    editEvent: 'Edit Event',
    chargeProducts: 'Charge Products',
    chargeToMews: 'Sync to MEWS',
    missingAccountingCategory: 'Missing Accounting Category',
    missingTaxCode: 'Missing Tax Code',
    noCustomerLinked: 'No customer linked to event',
    noConfirmedParticipants: 'No confirmed participants',
    chargeProductsConfirm: 'Charge all products for this event to MEWS?',
    chargeProductsSuccess: 'Products charged successfully',
    chargeProductsError: 'Failed to charge products',
    chargePartial: 'MEWS sync completed with issues',
    chargeNoChanges: 'No MEWS changes were needed',
    // EH-0038: a run that skipped every line used to report chargeNoChanges,
    // which told the operator all was well while nothing reached MEWS.
    chargeAllSkipped: 'Nothing sent to MEWS — every line was skipped',
    chargePartialSkipped: 'Partially sent — some lines were skipped',
    chargeScopeBlockedProduct: 'Not available: charging type "{type}" has no per-person factor. Charge it to the customer, or set the product to PerPerson or PerPersonPerTimeUnit.',
    chargeScopeBlockedPackage: 'Not available: no item in this package has a per-person factor. Charge it to the customer instead.',
    skippedRowsHeading: 'Skipped lines',
    skipReasonNoChargeTarget: 'No charge target selected — the "Charge to" column is set to "—".',
    skipReasonChargingType: 'Charging type "{type}" has no per-person factor and cannot be charged to participants.',
    selectOnePayer: 'Select the payer',
    singlePayerHint: 'Charging type "{type}" is billed once, not per person. Pick exactly one person to pay this line — otherwise it would be billed several times. For the whole event, charge it to the customer instead.',
    noCustomerOnEventHint: 'This event has no customer. Set a customer in the overview to charge lines to the customer.',
    skipReasonPackageAll: 'No item in this package has a per-person factor — none of it can be charged to participants.',
    skipReasonPackagePartial: '{incompatible} of {total} products in this package have no per-person factor and will not be sent to MEWS. NO participants are skipped. Fix: charge the package to the customer, or change those products to PerPerson / PerPersonPerTimeUnit.',
    packageProductsSkippedBadge: '{incompatible}/{total} products skipped',
    unnamedProduct: 'Unnamed product',
    unnamedPackage: 'Unnamed package',
    chargeToMewsAllPending: 'Sync all pending and cancellation changes for this event to MEWS',
    chargeToMewsThisLine: 'Send this line to MEWS',
    chargeToMewsAllShort: 'Sync all',
    chargeResult: 'MEWS sync result',
    charged: 'Charged',
    canceledLabel: 'Canceled',
    lockedAfterMewsCharge: 'Already charged in MEWS. Cancel this row and create a new one to make changes.',
    chargeConfirmTitle: 'Sync to MEWS',
    chargeConfirmMessage: 'The selected products will be charged to the guest account in MEWS. Once charged, these orders cannot be modified anymore.',
    chargeConfirmWarning: 'To make changes after charging, you must cancel the charged item and create a new one.',
    chargeConfirmButton: 'Charge now',
    chargingProducts: 'Charging...',
    accountableProduct: 'Accountable in MEWS',
    nonAccountableProduct: 'Not accountable - no MEWS product ID',
    customOrderHint: 'Will be charged as a custom order in MEWS (no linked MEWS product)',
    chargeable: 'Chargeable',
    notChargeable: 'Not chargeable',
    bills: 'Bills',
    viewBills: 'View bills / invoices',
    reservationProducts: 'Reservation',
    customerProducts: 'Customer',
    mewsReceipts: 'MEWS receipts',
    mewsReceiptsHint: 'Raw data from MEWS',
    openMewsReceipt: 'Open MEWS receipt',
    openOtherBills: "Open the guest's bills",
    mewsProductsTitle: 'MEWS products',
    otherCustomer: 'Other customer',
    otherCustomerWarning: "These positions are on a different customer card — for example the previous guest after a guest swap, a former company after an invoice-recipient change, or a reservation replaced by a type switch (Hotel ↔ day guest). Open in MEWS to reconcile them.",
    billsFor: 'Bills for',
    noBillsFound: 'No bills found for this participant',
    billCreated: 'Created',
    billIssued: 'Issued',
    billDue: 'Due',
    billPaid: 'Paid',
    generating: 'Generating...',
    hidePdf: 'Hide PDF',
    previewPdf: 'Preview PDF',
    openInTab: 'Open in Tab',
    billNotClosed: 'PDF available once bill is closed',
    billStayRoom: 'Room',
    billItems: 'items',
    billOtherStay: 'Stay outside this event',
    billStayCancelled: 'Stay cancelled — bill kept',
    billNoStay: 'No stay on this bill',
    billNoStayTitle: 'This bill holds products but no night. Nothing ties it to a stay.',
    billUnbilledTitle: 'Unbilled items',
    billUnbilledBadge: 'Not on any bill',
    billUnbilledHint: 'Shown in MEWS as "Unbezahlte Posten / Anzahlungen". A charge lands here when no stay bill could be resolved — check the Error Log for chargeProducts:noBillTarget.',
    closeBill: 'Close Bill',
    closingBill: 'Closing...',
    billUnpaidTitle: 'Outstanding Balance',
    billUnpaidError: 'This bill has an outstanding balance and cannot be closed. Please settle the payment in MEWS first.',
    billCloseError: 'Failed to close bill',
    assignTags: 'Assign Tags',
    allTagsAssigned: 'All tags assigned',
    files: 'Files',
    uploadFile: 'Upload File',
    uploading: 'Uploading...',
    noFiles: 'No files attached',
    confirmDeleteFile: 'Are you sure you want to delete this file?',
    noPreview: 'Preview not available for this file type',
    deleteEvent: 'Delete Event',
    deleteEventMenuHint: 'Permanently delete the event and everything linked',
    eventName: 'Event Name',
    startDate: 'Start Date',
    endDate: 'End Date',
    arrivalTime: 'Arrival Time',
    departureTime: 'Departure Time',
    location: 'Location',
    maxAttendees: 'Max Attendees',
    currentAttendees: 'Current Attendees',
    searchEvents: 'Search events...',
    noEventsFound: 'No events found',
    createFirstEvent: 'Create First Event',
    confirmedParticipants: 'Participants confirmed',
    confirmedParticipantsHint: 'Confirmed participants (hotel + day guests) across the events shown. Internal (ADG) online participants are excluded.',
    totalEvents: 'All events',
    eventsInPeriod: 'Events in period',
    tabDetails: 'Details',
    eventsInPeriodHint: 'Events in the selected period',
    filterUnseen: 'Unseen',
    filterUnseenHint: 'Only events you have not seen',
    filterChanged: 'Changed',
    filterChangedHint: 'Events changed since you last saw them',
    acknowledged: 'Seen',
    acknowledgedHint: 'Your seen status for these events',
    ackUnseen: 'unseen',
    ackUnavailable: 'unavailable',
    ackSeen: 'Seen',
    ackChanged: 'Changed',
    hotelShort: 'Hotel',
    errorShort: 'Error',
    erroredPickups: 'Errored bookings',
    spaceBookings: 'Space Bookings',
    definiteEvents: 'Definite Events',
    inquiryEvents: 'Inquiry Events',
    allStatus: 'All Status',
    allStreams: 'All Streams',
    allTypes: 'All Types',
    allBuildings: 'All Buildings',
    allCostCenters: 'All Cost Centers',
    allSalespersons: 'All Salespersons',
    allCustomers: 'All Customers',
    allProductManagers: 'All Product Managers',
    allEventManagers: 'All Event Managers',
    allTags: 'All Tags',
    onlyNew: 'Only upcoming',
    showPast: 'Past',
    showPastHint: 'Also show events that have already ended',
    showCancelled: 'Cancelled',
    showCancelledHint: 'Also show cancelled / lost events',
    onlyNewHint: 'Shows only current and upcoming events (finished ones are hidden)',
    overviewTab: 'Overview',
    basicInfo: 'Basic Information',
    pastEvent: 'Past Event',
    daysUntilEvent: '{n} day to go | {n} days to go',
    pastEventDisabled: 'Not available for past events',
    ongoingEvent: 'Ongoing',
    ongoingEventDisabled: 'Not available for ongoing events',
    onlyMiceInternal: 'Only available for MICE and internal events',
    missingFields: 'Missing Required Fields',
    pleaseComplete: 'Please fix the following before saving:',
    validationRequired: 'required',
    validationDescriptionMin: 'Description must be at least 4 characters',
    validationMinOne: 'must be at least 1',
    validationMaxGteMin: 'must be greater than or equal to min',
    validationOvernightRange: 'must be between {min} and {max}',
    validationDateChangeWithReservations: 'Dates cannot be changed while reservations exist. Please delete all reservations first, then change the dates.',
    validationOvernightSingleDay: 'Single-day event with overnight guests: either enable "Pre-evening arrival" (1 night), set overnight guests to 0, or extend the end date.',
    savingHint: 'This can take a few seconds…',
    noChangesToSave: 'No changes to save',
    savingStageEvent: 'Saving event…',
    savingStageMews: 'Creating room block in MEWS…',
    savingStageSpaces: 'Booking spaces…',
    savingStageAlmostDone: 'Almost done…',
    overnightWarningTitle: 'No Overnight Guests',
    overnightWarningMessage: 'Overnight guests is set to 0. No hotel room blocks will be needed for this event.',
    overnightWarningConfirm: 'OK, save',
    spaceBookingsDroppedTitle: 'Space bookings removed',
    spaceBookingsDroppedMessage: 'The date change removed {count} space booking(s) that could not be moved to the new dates. Please re-add them from the Spaces tab.',
    spaceMoveRefusedTitle: 'Rooms not moved',
    spaceMoveRefusedMessage: 'The event was saved, but its rooms were not moved: at least one room is already taken in the new period. The rooms are still on the old period. Please check them in the Spaces tab.',
    stream: 'Stream',
    timeline: 'Timeline',
    tags: 'Tags',
    addTag: 'Add Tag',
    noTags: 'No tags assigned',
    eventLogs: 'Event History',
    noLogs: 'No activity recorded',
    moreFilters: 'More Filters',
    clearFilters: 'Clear Filters',
    resetFilters: 'Reset Filters',
    fromDate: 'From Date',
    toDate: 'To Date',
    type: 'Type',
    dates: 'Dates',
    pax: 'PAX',
    crowdRelaxed: 'Relaxed',
    crowdMedium: 'Medium',
    crowdBusy: 'Busy',
    lunch: 'Lunch',
    lunchNotSelected: 'not selected',
    inquiry: 'Inquiry',
    qualify: 'Qualify',
    proposal: 'Proposal',
    tentative: 'Tentative',
    definite: 'Definite',
    closedLost: 'Closed Lost',
    cancelled: 'Cancelled',
    meeting: 'Meeting',
    conference: 'Conference',
    wedding: 'Wedding',
    offsite: 'Offsite',
    kickoff: 'Kickoff',
    firmenevent: 'Company event',
    privateParty: 'Private party',
    christmasParty: 'Christmas party',
    teamEvent: 'Team event',
    sonstiges: 'Other',
    // Internal event types (D132/D136) — internal-create dropdown only
    internalTypeEventMeal: 'Event incl. meal',
    internalTypeMeeting: 'Meeting',
    internalTypeWorkshop: 'Workshop',
    internalTypeMeetingWorkshop: 'Meeting / Workshop',
    internalTypeRoomBlock: 'Room block',
    internalTypeSport: 'Sport',
    forecastedRevenue: 'Forecasted revenue',
    listView: 'List View',
    calendarView: 'Calendar View',
    setToQualify: 'Qualify',
    advanceToStage: 'Advance to {stage}',
    moveToStage: 'Move to “{stage}”',
    tentativeViaBoard: 'Tentative needs an option deadline — set it on the MICE board',
    makeProposal: 'Proposal',
    confirmStatusChange: 'Confirm Status Change',
    confirmStatusChangeMsg: 'Change status of "{name}" from {from} to {to}?',
    statusChanged: 'Status changed successfully',
    proposalWarningsTitle: 'Please note before proceeding:',
    warningNoSpaceBooking: 'This event has no space bookings yet.',
    warningNoPmsBlock: 'This event has overnight guests but no hotel room block configured.',
    cancelEvent: 'Cancel Event',
    cancelEventMenuHint: 'Mark the event cancelled; it stays for the record',
    cancelEventTitle: 'Cancel Event',
    cancelEventMsg: 'How should "{name}" be cancelled?',
    cancelByAdg: 'ADG decided not to proceed',
    cancelByCustomer: 'Customer cancelled the event',
    revertToInquiry: 'Revert to Inquiry',
    revert: 'Revert',
    cannotRevertToInquiry: 'This event already has room blocks or participants, so it cannot be moved back to Inquiry. Move it forward, or cancel it instead.',
    cancelReason: 'Reason for cancellation',
    cancelEventLede: 'Linked hotel reservations and MEWS blocks will be cancelled atomically. This is recorded permanently in the audit log.',
    cancelImpactTitle: 'What this will do',
    cancelImpactEvent: 'Event status flips to "cancelled" (or "closed-lost").',
    cancelImpactReservations: 'linked hotel reservation(s) cancelled — live MEWS reservations are cancelled in MEWS as well.',
    cancelImpactBlocks: 'MEWS hotel blocks released (deleted in MEWS, marked canceled in our DB).',
    cancelImpactSpacesPackagesProducts: 'Space bookings, packages, and uncharged products are marked canceled. Already-billed products are preserved.',
    cancelImpactAudit: 'An audit log entry is written with the reason below.',
    sendConfirmationEmail: 'Send confirmation email to guest',
    sendCancellationEmail: 'Send cancellation email to guest',
    chargeCancellationFee: 'Charge room storno (MEWS)',
    feeChargesTitle: 'Storno / no-show fees',
    feeChargedStatus: 'Charged',
    chargeProductStorno: 'Charge storno for products (F&B, equipment, rooms)',
    productStornoFree: 'Before the first storno tier — no product storno fee.',
    productStornoNothing: 'No products to charge.',
    productStornoMissingSettings: 'Storno products are not set in Administration — the cancel will be refused.',
    productStornoUnreadable: '{n} product line(s) without a price — the cancel will be refused.',
    stornoFeeChoice: 'Cancellation fee',
    stornoWithFee: 'With cancellation fee',
    stornoWithFeeHint: 'Room: MEWS cancels with its cancellation fee · Products: storno by the rate\'s cancellation rule',
    stornoWithoutFee: 'Without cancellation fee',
    stornoWithoutFeeHint: 'MEWS cancels without a fee · all products are cancelled',
    stornoRate: 'Rate',
    stornoRule: 'Cancellation rule',
    stornoSince: 'since {at}',
    stornoRoom: 'Room',
    stornoRoomByMews: 'by this rule — MEWS computes the amount',
    stornoProducts: 'Products',
    stornoTotal: 'Products total',
    cancelReasonPlaceholder: 'Please provide a reason for the cancellation...',
    cancelReasonCategory: 'Reason Category',
    cancelReasonDetails: 'Cancellation Details',
    cancelActionHint: 'Select a reason and add details to continue.',
    selectReason: 'Select reason',
    reasonBudget: 'Budget/Cost',
    reasonDate: 'Date Conflict',
    reasonVenue: 'Venue',
    reasonCovid: 'COVID-19',
    reasonOther: 'Other',
    revenue: 'Revenue',
    hotelGuests: 'Hotel Guests',
    setTentative: 'Tentative',
    setTentativeTitle: 'Set to Tentative',
    tentativeMsg: 'Move "{name}" to tentative status?',
    tentativeProposalSent: 'I confirm that the proposal has been sent to the customer',
    tentativeDeadline: 'Customer decision deadline',
    tentativeDeadlineHint: 'Optional — leave empty if no deadline agreed',
    setDefinitive: 'Definitive',
    options: 'Options',
    optionsTitle: 'Event Options — PMS Blocks',
    noBlocksFound: 'No PMS blocks found for this event.',
    blockStatus: 'Status',
    blockRoomCount: 'Room Count',
    moreActions: 'More actions',
    reloadData: 'Reload data',
    viewVenueMap: 'View Venue Map',
    loadingEventData: 'Loading event data...',
    error: 'Error',
    eventNameCol: 'Event Name',
    category: 'Stream',
    daysCol: 'Days',
    status: 'Status',
    roomsBooked: 'Spaces',
    lastUpdated: 'Last Updated',
    // ── Whiteboard (kernboards integration on space bookings) ──
    whiteboard: 'Whiteboard',
    startWhiteboard: 'Start whiteboard',
    openWhiteboard: 'Open whiteboard',
    noWhiteboard: 'No whiteboard linked',
    openInNewTab: 'Open in new tab',
    updateWhiteboardUrl: 'Update URL',
    whiteboardPasteHint: 'Save the board in kernboards, copy the URL from the browser tab, and paste it here:',
    whiteboardUrlInvalid: 'Please paste a valid kernboards URL.',
    whiteboardSaveError: 'Save failed',
    modifiedBy: 'Modified by',
    // ── Rule-fired products in event tabs ──
    rule: 'Rule',
    rulePackage: 'Rule package',
    ruleBundleHint: 'Created by rule — bundled as one MEWS order',
    ruleIndividualHint: 'Created by rule — billed individually',
    rulesWillFire: 'rules will fire',
    ruleWillFireSingular: 'rule will be triggered automatically on pickup',
    rulesWillFirePlural: 'rules will be triggered automatically on pickup',
    rulePreviewHint: 'Will be added automatically when participants arrive or depart',
    rulePreviewClickHint: 'Click to see which products this rule adds',
    reapplyRules: 'Apply rules to existing participants',
    reapplyRulesHint: 'Rules fire on pickup, so a rule added later does not reach participants already on the event. This applies them once, now.',
    reapplyRulesConfirmTitle: 'Apply rules to existing participants?',
    reapplyRulesConfirmBody: 'The rules will run for {count} of {total} participants (confirmed and with a room). Already-charged lines are skipped. New charges are posted to MEWS and cannot be undone there automatically.',
    reapplyRulesNoneEligible: 'No participant on this event is confirmed and has a room yet, so there is nothing to apply.',
    reapplyRulesDone: 'Rules applied to {count} participant(s).',
    reapplyRulesFailed: 'Could not apply the rules: {error}',
    ruleChargedAsPackage: 'charged as a package',
    ruleRateScopeHint: 'Scoped to this rate — the rule only fires on pickups on this rate',
    firesOn: 'Fires on',
    ruleDaily: 'Daily',
    ruleDailyHint: 'Charged per night of stay (no arrival/departure trigger)',
    noRulesActivated: 'No rules activated',
    noRulesActivatedHint: 'No active rules match this event\'s stream and date range',
    triggerArrivalMorning: 'Arrival AM',
    triggerArrivalAfternoon: 'Arrival PM',
    triggerDepartureMorning: 'Departure AM',
    triggerDepartureAfternoon: 'Departure PM',
    entriesPerPage: 'Entries per page',
    pageOf: 'Page {current} of {total}',
    eventsCount: '{count} Events',
    previous: 'Previous',
    next: 'Next',
    attendees: 'Attendees',
    teilnehmerTab: 'Participants',
    teilnehmerAll: 'All',
    teilnehmerDayguest: 'Day Guests',
    teilnehmerExternal: 'External',
    teilnehmerLecturer: 'Lecturers',
    teilnehmerSearch: 'Search participants...',
    teilnehmerOf: '{filtered} of {total} participants',
    teilnehmerName: 'Name',
    teilnehmerEmail: 'Email',
    teilnehmerType: 'Type',
    teilnehmerArrival: 'Arrival',
    teilnehmerDeparture: 'Departure',
    teilnehmerRoom: 'Room',
    teilnehmerStatus: 'Status',
    teilnehmerAdded: 'Added',
    teilnehmerAddedHint: 'When this participant was added',
    retrySync: 'Retry',
    retrySyncSuccess: 'Sync Successful',
    retrySyncFailed: 'Sync Failed',
    retrySyncSuccessDetail: 'The reservation for {name} has been successfully synced to the PMS. The status has been updated.',
    retrySyncFailedDetail: 'The reservation for {name} could not be synced to the PMS.',
    retrySyncHint: 'This can happen if the PMS is temporarily unavailable, the guest profile is missing, or the room type is not configured. Check the error details and try again later, or contact an administrator.',
    retrySyncPastReservation: 'This reservation\'s arrival date is in the past. MEWS can no longer pick up a room from the block for past dates — adjust the arrival date or create the reservation manually in MEWS.',
    teilnehmerTypeOnline: 'Online',
    // Hand-pick list: online participants are never charged (blocksPayerPick).
    onlineNotCharged: 'online – not charged',
    // … and neither are failed hotel pickups nor settled no-shows (EH-0186).
    noRoomNotCharged: 'no room – not charged',
    noShowNotCharged: 'no-show – not charged',
    noBoardNotCharged: 'no services – not charged',
    // Why a hand-picked person on a line not charged yet is not billed (row label, participants list).
    notBilledNoRoom: 'no room',
    notBilledNoShow: 'no-show',
    notBilledNoBoard: 'no services',
    lifecycleCanceled: 'Canceled',
    lifecycleCapacityExceeded: 'Capacity exceeded',
    lifecycleFailed: 'Failed',
    linkedStayBadge: 'Linked stay ({n})',
    linkedStayTooltipBasic: 'This reservation is part of a multi-event stay.',
    linkedStayTooltipIntro: 'This guest also stays for:',
    linkedStayTooltipOutro: 'One MEWS reservation, one check-in, one check-out.',
    linkedStayCancelTitle: 'Part of a linked stay ({n} events)',
    linkedStayCancelHint: 'Cancelling shortens the MEWS reservation by this event\'s nights. The other events\' bookings stay intact.',
    allFields: 'All fields',
    checkInAction: 'Check in',
    syncCancelFromMews: 'Sync',
    syncCancelFromMewsTitle: 'Mark as cancelled in EventHub (MEWS already canceled)',
    syncCancelFromMewsFailed: 'Sync failed',
    roomNoLongerBlocked: 'Room no longer blocked — reservation was cancelled',
    editPriceTitle: 'Edit room price',
    priceCurrent: 'Current',
    priceNew: 'New per-night price',
    priceNewPlaceholder: 'e.g. 145.00',
    pricePerNightHint: 'Applied to each night of the stay.',
    setPrice: 'Set price',
    priceCol: 'Price',
    checkInToday: "Check in today's arrivals",
    checkInTodayTitle: 'Check in all guests arriving today',
    checkInSuccess: 'Checked in',
    checkInFailed: 'Check-in failed',
    checkInPartial: 'Partial check-in',
    checkInNoop: 'Nothing to check in',
    checkInNoopDetail: 'No participants are eligible for check-in right now.',
    alreadyCheckedIn: 'Already checked in',
    checkInCheckedIn: 'Checked in',
    checkInFailedList: 'Failed',
    checkInSkipped: 'Skipped',
    teilnehmerTypeDayguest: 'Day Guest',
    teilnehmerTypeExternal: 'External',
    teilnehmerSummaryCancelled: 'cancelled',
    teilnehmerTypeHotel: 'Hotel',
    // D164/PBI 2922: internal events call the online (never-sent-to-MEWS)
    // participant "Intern (ADG)". Only used when event_stream === 'internal'.
    internalAdgGuest: 'Internal (ADG)',
    teilnehmerTypeLecturer: 'Lecturer',
    teilnehmerEmpty: 'No participants found',
    to: 'to',
    days: 'days',
    fullEvent: 'Full Event',
    fullEventDesc: 'All sessions and event details',
    session: 'Session',
    roomBlocks: 'Room Blocks',
    subBlock: 'Sub-block',
    subBlocks: 'Sub-blocks',
    individualReservations: 'Hotel Guests',
    dayGuests: 'Day Guests',
    noDayGuests: 'No day guests yet',
    externalGuests: 'External',
    noExternalGuests: 'No external guests yet',
    totalRooms: 'Total Rooms',
    noSpaceBookings: 'None',
    noSpaceAssignedAlert: 'No space assigned — none was free for these dates. Add one from the Spaces tab.',
    // EH-0171: Spaces tab, one grey line for the bookings cancelled with the event.
    cancelledSpaceBookingsOne: '1 space booking cancelled ({rooms}) — holds no room',
    cancelledSpaceBookingsMany: '{count} space bookings cancelled ({rooms}) — hold no rooms',
    // D133/D145: rate is mandatory with nothing preselected.
    rateSelectPlaceholder: '— Select a rate —',
    noRatesConfigured: 'No rates configured for this guest type on this property.',
    dayguestRatesUnidentified: 'Day-guest rates could not be identified (MEWS rate sync pending) — all rates are shown.',
    dayguestRateLockedHint: 'Day guests and externals book on the day-guest rate — not changeable.',
    eventCheck: 'Event Check',
    spaceCapacityWarning: 'Too small',
    booked: 'booked',
    // Overview room-block badge. Only 'blocksHeld' means MEWS is actually
    // holding the rooms — the hotel creates the hold on approval, so a block
    // at inquiry or qualify holds nothing and must not read as "booked".
    blocksHeld: 'held',
    blocksHeldPartial: '{held}/{total} held',
    blocksRequested: 'awaiting approval',
    blocksDraft: 'draft — not held',
    blocksClosed: 'released',
    // Shown when the stage change itself went through but the audit row
    // didn't. Says what happened and what it costs — the operator must not
    // retry a change that already applied.
    statusChangedButNotLogged: 'The status was changed, but it could not be recorded in the event history. The change itself went through — do not repeat it. Please report this.',
    syncFailed: 'failed',
    hotelBlockOk: 'Hotel block ok',
    hotelBlockFailed: 'Hotel block needs attention',
    hotelBlockCreated: 'Created',
    hotelBlockConfirmed: 'Confirmed',
    hotelBlockNoAvailability: 'No availability',
    hotelBlockNone: 'No hotel block',
    allHotelStates: 'All hotel states',
    night: 'night',
    pending: 'Pending',
    addSpaceBooking: 'Add Space Booking',
    spaceBookingInquiryHint: 'No space bookings for lost or cancelled events',
    reservation: 'Reservation',
    addReservation: 'Add Reservation',
    addParticipant: 'Add Participant',
    filterOnlyOpenTasks: 'Only events with at least one open task',
    removeFilter: 'Remove filter',
    phEventName: 'e.g. ADG leadership seminar',
    phEventModule: 'e.g. Module 3',
    phCostCenter: 'e.g. 220103',
    exportParticipants: 'Export to Excel',
    exportColName: 'Name',
    exportColType: 'Type',
    exportColLecturer: 'Lecturer',
    exportColInvoiceOwner: 'Invoice owner',
    exportColArrival: 'Arrival',
    exportColDeparture: 'Departure',
    exportColNights: 'Nights',
    exportColRoomCategory: 'Room category',
    exportColRoom: 'Room',
    exportColRate: 'Rate',
    exportColAdults: 'Adults',
    exportColChildren: 'Children',
    exportColStatus: 'Status',
    exportColMewsId: 'MEWS reservation',
    groupEditor: 'Group editor',
    groupEditorHint: 'Edit every participant in one go and add new ones.',
    groupEditorTitle: 'Group editor',
    groupEditorSubtitle: 'Edit existing participants and add new ones. Save everything together.',
    groupEditorEmpty: 'No participants yet — add some.',
    groupEditorAddRow: 'Add new participant',
    groupEditorUpdatedLabel: 'to update',
    groupEditorAddedLabel: 'new',
    groupEditorRowSaved: 'Saved',
    groupEditorRowFailed: 'Failed',
    groupEditorRowSaving: 'Saving…',
    groupEditorRowQueued: 'Queued…',
    groupEditorRateMissing: '{n} without a rate',
    rateRequiredHint: 'A rate is required',
    groupEditorNameRequired: 'Name missing — row was not booked',
    groupEditorTypeLocked: 'Type can only be chosen for new participants. Rebook existing ones in the participant details via ⋯ → “Participant type”.',
    groupEditorAllOk: '{u} updated · {a} newly added.',
    groupEditorReposting: 'Products already charged for {n} participant(s) are being checked and re-posted where needed.',
    groupEditorPartial: '{u} updated · {a} new · {f} failed:',
    newParticipantPlaceholder: 'First and last name',
    creatingParticipant: 'Creating participant...',
    pleaseWait: 'This may take a moment, please wait.',
    searchBooker: 'Search booker in MEWS (min 4 characters)...',
    bookerOptional: 'Booker (optional)',
    searchCompany: 'Select company from MEWS...',
    addRoomBlock: 'Add Room Block',
    dateAndTime: 'Date & Time',
    space: 'Space',
    setup: 'Setup',
    actions: 'Actions',
    customName: 'Custom Name',
    customNamePlaceholder: 'e.g., Workshop Room A',
    customPrice: 'Price',
    spaceDefault: 'default',
    spacePrice: 'Space price',
    spaceTotal: 'Total',
    perDayShort: 'day',
    room: 'Space',
    list: 'List',
    calendar: 'Calendar',
    timelineView: 'Timeline View',
    rooms: 'rooms',
    nights: 'nights',
    guest: 'guest',
    guests: 'guests',
    noRoom: 'No Room',
    spaceNotConfirmedYet: '{n} space booking(s) not confirmed yet',
    noSpace: 'No Space',
    slimSessionHint: 'Pax and setup are taken from the booking below.',
    noRoomBlocks: 'None',
    reservations: 'Reservations',
    mismatch: 'Mismatch',
    synced: 'Synced',
    noReservations: 'No reservations yet',
    mews: 'MEWS',
    syncedWithMews: 'Synced with MEWS',
    notSynced: 'Not synced',
    notSyncedWithMews: 'not linked to MEWS',
    openInMews: 'Open in MEWS',
    openBlockInMewsHint: 'View this block in MEWS Commander',
    deleteReservation: 'Delete Reservation',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    checkedIn: 'Checked In',
    dietary: 'Dietary',
    serviceTime: 'Service Time',
    items: 'Items',
    equipment: 'Equipment',
    quantity: 'Quantity',
    notes: 'Notes',
    noteNoAvailability: 'No availability',
    noteAutoDetachFailure: 'Auto-detach MEWS error',
    participantProductsTotal: 'Products (EventHub)',
    participantProductsOffBill: 'on other bills of this guest ({n})',
    participantMewsOpenOnCancelledStays: 'open on cancelled stays ({n})',
    participantProductsOffBillHint: 'These lines are charged in MEWS but sit on another bill of this guest — usually a reservation that a type change (Hotel ↔ day guest) replaced. They are not included in "Products (EventHub)", because this bill does not pay them.',
    participantProductsPending: 'not yet charged ({n})',
    participantProductsPendingHint: 'These lines were never sent to MEWS. The amount is a projection, not a bill line, so it is not counted in "Products (EventHub)".',
    participantProductsPartialHint: 'Minimum — one counted line has no price.',
    offThisBill: 'other bill',
    participantRoomTotal: 'Room (MEWS)',
    participantRoomTotalHint: 'The reservation\'s room price — the override if set, otherwise the current MEWS rate price. Not the MEWS bill balance.',
    participantGrandTotal: 'Products + room',
    participantRoomNights: '{n} × {price}',
    participantMewsStay: 'MEWS bill (this stay)',
    participantMewsStayPayer: 'to {name}',
    participantMewsStayPayerOther: 'to another account',
    participantMewsStayHint: 'Balance of the MEWS bill(s) this reservation\'s nights are filed on — what MEWS shows as "To pay" for the reservation. Rate-included services count here, so it can exceed Products + room by exactly those.',
    participantMewsMatches: 'Equals Products + room',
    participantMewsInclusive: 'of which rate-included services',
    participantMewsDeltaHint: 'Difference MEWS − EventHub. Rate-included services (breakfast, WLAN …) sit on the MEWS bill but are not EventHub products.',
    participantMewsGuest: 'MEWS balance (guest)',
    participantMewsGuestHint: 'Every open item on the guest\'s MEWS account, across all bills and stays.',
    participantMewsOtherStays: 'incl. other stays',
    participantMewsLoad: 'Load from MEWS',
    participantMewsLoading: 'Loading MEWS figures',
    participantMewsChecking: 'Checking against MEWS…',
    participantChargesReposting: 'Re-posting products…',
    participantMewsAsOf: 'MEWS as of {time}',
    participantMewsReload: 'Reload',
    participantMewsUnchecked: 'MEWS unreachable — figures unchecked',
    participantMewsRetry: 'Try again',
    participantProductsOtherCustomer: 'with another customer ({n})',
    billedPriceHint: 'Billed at {billed} per unit (price list {list}) — the row carried {row}. The price list decides at charge time.',
    billedZeroPrice: '0 € per price list {list} — MEWS holds a free order for this line.',
    allRates: 'all rates',
    chargePreflightLines: 'This will post {n} line(s):',
    chargePreflightWarnings: 'Warnings on these lines',
    chargePreflightPriceCheck: 'Checking price lists…',
    chargePreflightMismatchTitle: 'Price list differs from the shown price for',
    chargePreflightMismatchHint: 'The amount shown is the row\'s own price. At charge time MEWS prices from the price list, so the posted amount differs from what you see here. Fix the price list first, or charge anyway.',
    chargePreflightMismatchLine: '{name}: shown {row} → price list {list}',
    chargePreflightBookingRate: '{rate}: {price} per unit (price list {list})',
    chargeAbsenteesTitle: 'Not charged — not present on the session day',
    chargeAbsenteesGroup: '{lines} · session on {day} · {count} not charged',
    chargeAbsenteeStay: 'stay {arrival} – {departure}',
    chargeAbsentArrivesLater: 'arrives later',
    chargeAbsentLeavesEarlier: 'leaves earlier',
    chargeAbsentOutsideEvent: 'stay outside the event',
    chargeAbsentSessionOutside: 'The session day is outside the event — this line charges nobody.',
    cancelledLinesShort: 'cancelled',
    internalLine: 'internal · no MEWS',
    internalLineHint: 'Internal events are never charged to MEWS. This line is planning only.',
    ruleBundleSubtitle: '(rule, per participant)',
    ruleBundleProducts: '{n} products',
    ruleBundleUnits: '{n} units',
    ruleBundleShow: 'Show lines',
    ruleBundleHide: 'Hide lines',
    chargePartialLegacyHint: 'This line was charged before participant tags existed, so the missing people cannot be topped up here. Add a separate line for exactly them ("Selected participants") — a second line for everyone would charge the others twice.',
    duplicateChargeNamed: '{name} — already charged for: {names} (line from {date}).',
    duplicateChargeInRun: '{name} — charged twice in this run for: {names}.',
    duplicateChargeUntagged: '{name}: this product was already charged on this event (line from {date}, without participant tags — who paid cannot be told).',
    chargePreflightDuplicateTitle: 'Possible double charge',
    chargePreflightDuplicateHint: 'If this line is meant for the people not yet charged, set it to "Selected participants" and pick only them.',
    chargePreflightDuplicateHintPicked: 'For "Selected participants": remove the named people from the selection or delete the line.',
    legacyNotBilled: 'not billed on this line',
    legacyNotBilledHint: 'This line was charged before participant tags existed and MEWS holds no order for this person on it — they joined after the charge. Nothing was cancelled.',
    ruleAuditLineCancelled: 'marked for cancellation — the rule no longer fires for this stay (or the line was replaced)',
    ruleAuditLineUnchanged: 'unchanged',
    ruleAuditTitle: 'Rule check',
    ruleAuditLastRun: 'last run {when}',
    ruleAuditLastRunBeforeCancel: 'last run before cancellation {when}',
    ruleAuditNothing: 'No rule was evaluated for this reservation yet.',
    ruleAuditNoProducts: 'no products',
    ruleAuditFired: 'fired — {count} product line(s)',
    ruleAuditCancelled: 'fired, since cancelled — nothing charged',
    ruleAuditDays: '{fired} of {total} days',
    ruleAuditBoundaryArrival: 'arrival day only',
    ruleAuditBoundaryDeparture: 'departure day only',
    ruleAuditNoDayFired: 'matched, but fired on none of the {days} stay days — its arrival/departure triggers hit no day of this stay',
    ruleAuditError: 'error',
    ruleAuditGate_validity: 'not applied: the rule is not valid on the service date',
    ruleAuditGate_stream: 'not applied: the rule is not configured for this event stream',
    ruleAuditGate_rate: 'not applied: the rule does not list this reservation\'s rate',
    ruleAuditGate_participant_scope: 'not applied: this participant type is outside the rule\'s scope',
    ruleAuditGate_unknown: 'not applied',
    chargedProductsTitle: 'Charged products',
    notYetCharged: 'not yet charged',
    chargedProductsNone: 'No products charged to this participant.',
    source: 'Source',
    totalPrice: 'Total',
    products: 'Products',
    total: 'Total',
    viaPackage: 'via package',
    noEventSelected: 'No event selected',
    loadingSeriesData: 'Loading series data...',
    selectSeries: 'Select a Series',
    chooseSeries: 'Choose a series...',
    notPartOfSeries: 'This event is not part of a series',
    basicInformation: 'Basic Information',
    datesTimes: 'Dates & Times',
    participants: 'Participants',
    sourceSystem: 'Source System',
    sourceData: 'Source Data (BC/External System)',
    eventNameLabel: 'Event Name',
    copyEventLink: 'Copy Link',
    locationLabel: 'Location',
    selectLocation: 'Select location',
    description: 'Description',
    description2: 'Description 2',
    externalId: 'External ID',
    categoryLabel: 'Stream',
    selectCategory: 'Select stream',
    internal: 'Internal',
    eventType: 'Event Type',
    selectType: 'Select type',
    participationType: 'Participation Type',
    selectParticipationType: 'Select type',
    onSite: 'OnSite',
    hybrid: 'Hybrid',
    statusLabel: 'Status',
    startDateLabel: 'Start Date',
    optionalMiceHint: 'optional, mainly for MICE',
    daySlotsTitle: 'Booked per day:',
    selectSetupFirst: 'Choose a setup first',
    groupEditorPickGuest: 'Search or create customer…',
    noEmail: 'No email',
    groupEditorHalfDayUnset: 'No time stored – counts as afternoon for the rules',
    spaceBookingMissing: 'Still missing: {fields}',
    spaceBookingPaxSetupRequired: 'Please enter pax and setup – both are required for the room booking.',
    spaceBookingOutsideEvent: 'The booking must lie within the event dates.',
    endDateLabel: 'End Date',
    futureDatesOnlyHint: 'Start and end date must be on or after {date}.',
    futureDatesOnlyAlert: 'Start and end date must be on or after {date}.',
    endDateAfterStartDate: 'End date must be on or after the start date.',
    startTime: 'Start Time',
    endTime: 'End Time',
    minParticipants: 'Min Participants',
    maxParticipants: 'Max Participants',
    numberOfParticipants: 'Number of Participants',
    lunchTime: 'Lunch',
    clearSelection: 'Clear',
    lunchCrowdEmpty: 'No confirmed guests at this time yet',
    lunchCrowdBusy: 'Already {n} confirmed guests at {time}:00',
    lunchTimeNotSet: 'Lunch time not set',
    lunchOverCapacity: '{limit} or more confirmed guests already seated at {time}:00 – the time was not applied. Please contact the F&B team.',
    lunchConfirmSetTitle: 'Set lunch time?',
    lunchConfirmChangeTitle: 'Change lunch time?',
    lunchConfirmRemoveTitle: 'Remove lunch time?',
    lunchConfirmSet: 'Set this event\'s lunch to {time}.',
    lunchConfirmChange: 'Change lunch from {from} to {to}.',
    lunchConfirmRemove: 'The lunch time ({time}) will be removed – the event will have no lunch time.',
    lunchFullTitle: 'Lunch time not possible',
    lunchFullText: '{n} confirmed guests are already seated at {time}:00 – the limit is {limit}. This time can\'t be assigned. Please contact the F&B team.',
    lunchFullUnset: 'The current lunch time ({time}) will be removed.',
    lunchFullAck: 'Understood',
    lunchCrowdUnknown: 'Occupancy unavailable',
    manageSessions: 'Manage Event Sessions',
    sessionName: 'Session Name',
    sessionDate: 'Session Date',
    sessionUntil: 'Multi-day until',
    sessionSingleDay: 'This day only',
    sessionUntilHint: 'pick a date first',
    sessionDaysCreated: 'creates {n} days',
    sessionRunDays: '{n} days',
    sessionDeleteRunWarning: 'Session "{name}" spans {n} days. All {n} days will be deleted — this cannot be undone.',
    sessionShortenRunBlocked: 'This session runs until {last}. Remove days via delete in the list, where that day\'s room bookings, equipment and catering are checked too.',
    selectDate: 'Select a date',
    spaceOptional: 'Space (Optional)',
    noSpaceSelected: 'No space selected',
    selectSpaceForSession: 'Select a space for this session',
    sessionDescription: 'Description',
    selectSession: 'Select Session',
    spaceBooking: 'Space Booking',
    selectSpaceBooking: 'Select Space Booking',
    selectEquipment: 'Select Equipment',
    selectAttendee: 'Select Attendee',
    allSessions: 'All Sessions',
    registrationStatus: 'Registration Status',
    invited: 'Invited',
    confirmed: 'Confirmed',
    suggested: 'Suggested',
    bookingConfirmedTooltip: 'Firmly booked',
    bookingSuggestedTooltip: 'Not yet confirmed',
    confirmDelete: 'Confirm Delete',
    confirmDeleteSpaceBooking: 'Are you sure you want to delete this space booking?',
    dedupeTitle: 'Remove duplicate space bookings',
    dedupeIntro: 'Multiple identical space-booking rows exist for the same slot. Keep one and delete the rest.',
    dedupeDuplicateCount: 'Duplicate rows',
    dedupeAction: 'Keep {keep} row, delete {remove}.',
    dedupeConfirm: 'Keep 1, delete the rest',
    dedupeDuplicatesHint: 'Click to keep one and delete the duplicates',
    dedupeFailed: 'Dedupe failed',
    attendeeLabel: 'Attendee',
    activityState: 'Activity State',
    releaseStrategy: 'Release Strategy',
    firstTimeUnitStart: 'First Time Unit Start (UTC)',
    lastTimeUnitStart: 'Last Time Unit Start (UTC)',
    released: 'Released (UTC)',
    created: 'Created (UTC)',
    updated: 'Updated (UTC)',
    serviceAndRate: 'Service & Rate',
    serviceId: 'Service ID',
    rateId: 'Rate ID',
    contacts: 'Contacts',
    bookerId: 'Booker ID',
    companyId: 'Company ID',
    travelAgencyId: 'Travel Agency ID',
    additionalInfo: 'Additional Information',
    pickupDistribution: 'Pickup Distribution',
    externalIdentifier: 'External Identifier',
    budget: 'Budget',
    availabilityAdjustments: 'Availability Adjustments',
    noAdjustmentsFound: 'No adjustments found for this block',
    failedLoadMewsBlock: 'Failed to load MEWS block details',
    venueMap: 'Venue Map',
    corporate: 'Corporate',
    social: 'Social',
    businessSchool: 'Business School',
    required: 'required',
    localReservation: 'Local Reservation',
    cancelledInMews: 'Reservation will be cancelled in MEWS',
    deletedFromDb: 'Reservation will be deleted from EventHub database',
    whatWillBeDeleted: 'What will be deleted',
    mewsSyncWarning: 'This reservation is synced with MEWS and will be cancelled in MEWS. The guest will no longer have this reservation.',
    page: 'Page',
    addCateringOrder: 'Add Catering Order',
    addEquipment: 'Add Equipment',
    addAttendee: 'Add Attendee',
    noEquipmentYet: 'No equipment reservations yet. Click "Add Equipment" to get started.',
    roomType: 'Room Type',
    noBlocksOrReservations: 'No blocks or reservations for this day',
    detachFromSeries: 'Detach from Series',
    seriesType: 'Type',
    organizer: 'Organizer',
    department: 'Department',
    selectSpaceForBooking: 'Select a space for this session',
    overnightGuests: 'Overnight',
    overnightGuest: 'Overnight guest',
    overnightGuestsPlural: 'Overnight guests',
    noneBooked: 'None',
    assignContacts: 'Assign contacts',
    devInspectorTitle: 'Show raw JSON',
    devInspectorHint: 'Inspect the raw event record & linked data',
    reloadDataAgoTitle: 'Reload data',
    hotelRooms: 'Hotel Rooms',
    roomCategorySelect: 'Select room category',
    roomTypeComfort: 'Comfort Double Room',
    roomTypeEconomy: 'Economy Single Room',
    requested: 'Requested',
    tightestDay: 'Tightest day',
    shortfallTitle: 'Not enough rooms available',
    shortfallBodyFull: 'Only {available} of {requested} rooms could be held for {category} — {missing} short. Tightest day: {day}.',
    shortfallBodyCategory: 'Only {available} of {requested} rooms could be held for {category} — {missing} short.',
    shortfallBodyDay: 'Only {available} of {requested} rooms could be held — {missing} short. Tightest day: {day}.',
    shortfallBodyCounts: 'Only {available} of {requested} rooms could be held — {missing} short.',
    shortfallBodyGeneric: 'The room block could not be held at its full size.',
    shortfallTechnicalDetail: 'Technical details',
    shortfallHint: 'Choose a different room category, request fewer overnight guests, or adjust the date range.',
    preNight: 'Pre-Night',
    overnightGuestsToBlock: 'Overnight Guests to Block',
    overnightBadgeInfo: '{count} participants + 1 room always reserved for the lecturer (whether or not a lecturer reservation exists yet).',
    healEvent: 'Check & fix blocks',
    autoCreateCustomers: 'Auto-create customers',
    runAgain: 'Run Again',
    healEventMismatch: 'Data mismatch detected — click to check & fix',
    healEventTitle: 'Event Health Check',
    healAllOk: 'Everything looks good — no issues found.',
    healIssuesFound: 'Issues detected — see details below.',
    healNoOpPendingBlocks: 'Nothing was healed. {n} room block(s) do not exist in MEWS yet, and heal will not touch an event\'s room mix while that is true. Have the hotel approve the blocks, or change the room mix in the event itself.',
    healCheck_block_capacity: 'Block Capacity',
    healCheck_block_dates: 'Block Dates',
    healCheck_reservation_overflow: 'Reservation Overflow',
    healCheck_orphaned_blocks: 'Orphaned Blocks',
    healCheck_connection: 'Connection',
    healCheck_pending_lecturers: 'Pending lecturers',
    healCheck_failed_reservations: 'Failed reservations',
    openSession: 'Open session',
    mainSpace: 'Main space',
    setMainSpace: 'Set as main space',
    mainSpaceFailed: 'Could not set the main space.',
    mainSpaceCanceled: 'A cancelled space booking cannot be the main space.',
    mainSpaceIsCurrent: 'Current main space. To move it, mark another space booking as the main space.',
    mainSpaceDefaultCurrent: 'Currently the event\'s main room (default: earliest, largest room).',
    mainSpaceOnSave: 'Will be set as the main room when you save.',
    mainSpaceHint: 'This room appears in the overview, in the function sheet and — as “Raum: …” — on every participant\'s MEWS reservation.',
    mainSpaceDefaultHint: 'Currently the default main room — click to pin it.',
    mainSpaceUnavailable: 'The main space cannot be set yet: the database does not have the field (migration V191 is not applied).',
    mainSpaceOverCapacity: 'Too small for {pax}',
    mainSpaceOverCapacityHint: '{pax} booked participants exceed the main room\'s capacity ({cap}) — {short} seats short.',
    standaloneHold: 'Room hold',
    standaloneHoldHint: 'Booked directly — not part of any session',
    spaceNotRequired: 'This event does not require a seminar room',
    spaceNotRequiredHint: 'The event will no longer be reported as "no room" on the dashboard.',
    spaceNotRequiredBadge: 'No room',
    openTasksHint: '{count} open task(s) on this event',
    perHeadQuantityBadge: 'Check quantity',
    perHeadQuantityBadgeHint: 'Click for the explanation',
    quantityFormula: '{qty} × {people} people = {total}',
    quantityFormulaPerDay: '{qty} × {days} days × {people} people = {total}',
    setQuantityToOne: 'Set quantity to 1',
    chargedToNames: 'Charged to: {names}',
    effectiveQtyPerPerson: '{qty} \u00d7 {count} people = {total}',
    quantityTotalHeader: 'Amount / Total',
    verifyingInMews: 'Checking in MEWS\u2026',
    occupancy: 'Occupancy',
    singleOccupancy: '1 \u2014 single',
    doubleOccupancy: '2 \u2014 double',
    singleRoomOnePerson: 'A single room (EZ) is for one person. Set the occupancy to 1 or choose a DZ.',
    childrenLegacy: 'This reservation also carries {n} child(ren), booked before the field was removed.',
    participantType: 'Participant type',
    forceAllCategories: 'Fill across all room categories',
    forceAllCategoriesHint: 'A room request may spill into the other tier \u2014 requested tier first, then the other. Still all-or-nothing.',
    forceAllCategoriesApplyHint: 'Saved. This applies to the next pickup \u2014 re-run the block check to re-allocate the rooms now.',
    forceAllCategoriesRunHeal: 'Re-run block check',
    forceAllCategoriesSaveFailed: 'The setting could not be saved.',
    convertParticipantTypeWorking: 'Rebooking\u2026',
    convertParticipantTypeWait: 'This takes a few seconds \u2014 please do not close the window.',
    convertStepIdentity: 'Preparing the reservation\u2026',
    convertStepRebooking: 'Cancelling in MEWS and creating the new booking\u2026',
    convertStepReloading: 'Reloading the participant list\u2026',
    convertParticipantType: 'Rebook',
    convertParticipantTypeHint: 'Changing the type rebooks the guest on the other MEWS service: the current reservation is cancelled and a new one created. The old row is kept as an audit record. Charged products that still apply move to the new booking\'s bill; the old type\'s rule products are cancelled and the rules run again for the new type.',
    adultOne: 'adult',
    childOne: 'child',
    rateChangeChargesHint: 'Products already charged keep the price they were billed at \u2014 the new rate applies to the stay only.',
    invoiceOwnerUnnamed: 'set, but the contact could not be resolved',
    invoiceOwnerLocalName: 'stored here as',
    invoiceOwnerNameMismatch: 'Name shown is the MEWS account. Stored here as \u201c{local}\u201d \u2014 worth correcting.',
    invoiceOwnerLoading: 'loading\u2026',
    releaseChargesFailed: 'The charge could not be cancelled in MEWS. Nothing was changed.',
    chargeConfirmedInMews: 'Confirmed in MEWS for all {count} payer(s)',
    chargePartialInMews: 'Only {confirmed} of {expected} payers are charged in MEWS. Missing: {names}',
    // Participants who joined the scope after the line was charged (no MEWS order yet)
    lateParticipantsChip: '{n} not yet charged',
    lateParticipantsTitle: 'Added after the charge, not yet in MEWS: {names}',
    chargeLateParticipants: 'Charge the {count} guest not yet in MEWS | Charge the {count} guests not yet in MEWS',
    notChargedForParticipant: 'not charged for this participant',
    notLiveInMews: 'no longer in MEWS',
    chargeMissingInMews: 'MEWS has no live charge for this line \u2014 it was cancelled there, or never arrived.',
    mewsUnavailableChargeTitle: 'MEWS not reachable \u2014 the charge could not be verified.',
    // EH-0254: a word beside the MEWS-verify icon so the row reads without hovering
    mewsVerifyPartial: 'MEWS: partial',
    mewsVerifyMissing: 'MEWS: missing',
    mewsVerifyUnchecked: 'MEWS: unchecked',
    mewsNotCharged: 'Not charged',
    chargeWarningChip: 'Note',
    // EH-0254: per-column explanations opened by the header info button
    colInfoName: 'The product or package being booked on this line.',
    colInfoType: 'How the line is charged \u2014 per person, per day or once.',
    colInfoQuantity: 'Left: amount per participant. Right: units that reach MEWS (\u00d7 people \u00d7 days).',
    colInfoPrice: 'Unit price. An amber field is a manual override of the price-list price.',
    colInfoChargeTo: 'Who the line is billed to, or "internal" for lines that never reach MEWS.',
    colInfoCalcMode: 'How the amount is calculated \u2014 taken from the product catalog.',
    colInfoStatus: 'Charge state and the MEWS verification result for the line.',
    colInfoValue: 'The line total: price \u00d7 units.',
    removeScopeTitle: 'Remove charged item',
    removeScopeLede: '\u201c{name}\u201d is charged to {count} participants in MEWS. Cancel it for everyone, or only for some of them?',
    removeScopeAll: 'Cancel for everyone ({count})',
    removeScopeSelected: 'Cancel for selected participants\u2026',
    cancelForSelectedTitle: 'Cancel for which participants?',
    cancelForSelectedHint: 'The charge is cancelled in MEWS for the people you pick here. Everyone else stays charged.',
    cancelChargeAction: 'Cancel charge',
    effectiveQtyHint: 'Quantity is per person. MEWS receives {total} units ({qty} each \u00d7 {count} people).',
    chipCountOfTotal: '{count} of {all}',
    chipAbsentHint: 'Billed to the people there on {day}. Not there that day, so not billed: {names}.',
    notPresentBadge: '{count} not present',
    figureIsCharged: 'Charged \u2014 this is what MEWS holds.',
    figureIsProjected: 'Projection \u2014 how this will be billed.',
    sessionDayPeoplePlain: '{count} participants',
    sessionDayPeopleOccupancy: '{people} guests ({count} participants, {rooms} of them with double occupancy)',
    effectiveQtyHintSessionDay: 'Quantity is per person per day. This line belongs to the session on {day}, so it bills that ONE day, to the people there: {present}. MEWS receives {total} units ({qty} each \u00d7 1 day).',
    effectiveQtyHintSessionDayPerPerson: 'Quantity is per person. This line belongs to the session on {day}, so it is billed only to the people there that day: {present}. MEWS receives {total} units ({qty} each).',
    effectiveQtyHintSessionDayPerDay: 'Quantity is per day. This line belongs to the session on {day}, so it bills that ONE day. MEWS receives {total} units.',
    effectiveQtyHintSessionDayOnce: 'Flat fee. This line belongs to the session on {day}, so it is billed once to each payer there that day: {present}. MEWS receives {total} units.',
    effectiveQtyHintDays: 'Quantity is per person per day. MEWS receives {total} packages ({qty} each \u00d7 {days} days \u00d7 {people} people).',
    effectiveQtyHintOccupancy: 'Quantity is per person. MEWS receives {total} units ({qty} each \u00d7 {people} guests \u2014 {count} participants, {rooms} of them with double occupancy).',
    ruleGroupMixedQtyHint: '{range} units per participant (occupancy or a shorter stay). MEWS receives {total} units for {count} participants.',
    occupancyChipHint: 'Double occupancy: {n} guests in the room \u2014 counts {n}\u00d7 on per-person products.',
    personsShort: 'pers.',
    // Second guest of a double room in the participants list, and the row badge (EH-0186).
    plusPersons: '+{count} person | +{count} people',
    doubleOccupancyBadge: '{count} double occupancy | {count} double occupancies',
    doubleOccupancyBadgeHint: 'On per-person products every guest of a room counts. The participants list (👥) shows who.',
    perDayQuantityWarning: 'The quantity is per person and day. Did you mean 1 per person per day?',
    perHeadQuantityWarning: 'The quantity is per person. Did you mean 1 each?',
    spaceNotRequiredReinstateHint: 'Note: a room is not assigned again automatically \u2014 please pick one in the "Rooms" tab.',
    spaceNotRequiredReleaseConfirm: 'This event currently holds {count} room booking(s). Saving it as "requires no room" will release and delete them. Continue?',
    spaceReleaseFailed: '{count} room(s) could not be released — please remove them in the Spaces tab.',
    preEveningArrival: 'Pre-Evening Arrival',
    preNightNotEnabled: 'Pre-evening arrival is not enabled for this event',
    noRate: 'Default',
    salesperson: 'Salesperson',
    salespersonCode: 'Salesperson Code',
    salespersonName: 'Salesperson Name',
    salespersonEmail: 'Salesperson Email',
    salespersonPhone: 'Salesperson Phone',
    salespersonJobTitle: 'Salesperson Job Title',
    costCenter: 'Cost Center',
    customerNo: 'Customer No.',
    customerName: 'Customer Name',
    productManagerNo: 'Product Manager No.',
    productManagerName: 'Product Manager',
    productManager: 'Product Manager',
    contactPerson: 'Contact person',
    contactPersonPlaceholder: 'Select contact person from MEWS…',
    orgResponsibleNo: 'Org Responsible No.',
    orgResponsibleName: 'Org Responsible',
    orgResponsible: 'Org Responsible',
    eventManager: 'Event Manager',
    responsiblePerson: 'Responsible Person',
    selectContact: 'Select contact...',
    bcData: 'Business Central Data',
    venueInfo: 'Venue Information',
    venueContact: 'Venue Contact',
    venueAddress: 'Venue Address',
    venueCity: 'Venue City',
    customer: 'Customer',
    searchSalesperson: 'Search salesperson by name or email...',
    searchEventCustomer: 'Search customer by name or email...',
    salespersonSelected: 'Salesperson selected',
    eventCustomerSelected: 'Customer selected',
    sourceId: 'Source ID',
    sourceModified: 'Source Modified',
    openInBC: 'Open in Business Central',
    primaryContact: 'Primary Contact',
    eventsInSeries: 'Events in this Series',
    addSession: 'Add Session',
    suggestedHint: 'Suggested — the space is not confirmed yet.',
    duplicateSession: 'Duplicate session',
    sessionTabDetails: 'Details',
    sessionTabProducts: 'Products',
    sessionNoProducts: 'No products added to this session yet.',
    duplicate: 'Duplicate',
    duplicating: 'Duplicating…',
    duplicateSessionConfirm: 'A copy of "{name}" will be created. The new name gets "(2)".',
    duplicateKeeps: 'Pax, setup, date & time are carried over',
    duplicateNoRoom: 'No room — assign later',
    yes: 'Yes',
    no: 'No',
    noWebShop: 'No WebShop',
    noSpecificSession: 'No specific session (use event times)',
    timesFromEvent: 'Times will be set from event start/end dates',
    availabilityNotChecked: 'Availability could not be checked — occupied spaces are not marked.',
    selectSpace: 'Select space',
    selectSetupType: 'Select setup type',
    setupInRoom: 'Setup in room {room}',
    sessionRequirement: 'Session requirement',
    roomBookingTitle: 'Room booking {room}',
    roomSetupChange: 'Change setup',
    paxExceedsRoom: '{pax} pax exceed the capacity (max {max}) — booking still possible',
    setupMatchesWish: 'matches the requested setup',
    setupDiffersFromWish: 'differs from the requested setup ({setup})',
    setupWishUnavailable: '{setup} is not available in room {room} — please choose',
    wish: 'Wish',
    sessionPaxSetupRequired: "Please set Pax and Setup — or tick 'No room required'.",
    selectSpaceFirst: 'Select a space first',
    spaceSuggestedTimes: 'This room is already requested {n}× at this time (suggested)',
    manualCreation: 'Manual Creation',
    betaWarning: 'Hotel blocks are normally synced automatically from MEWS. Manual creation is experimental.',
    selectService: 'Select a service',
    selectRate: 'Select a rate',
    selectRoomCategory: 'Select a room category',
    roomCategoryHint: 'Used to block rooms for this group',
    booker: 'Booker (Customer)',
    bookerSelected: 'Booker selected',
    releaseDate: 'Release Date',
    releaseDateHint: 'Date when unreserved rooms in the hotel block are released back to free sale',
    releaseDateBeforeStart: 'Release date must be before the event start date',
    includeNightBefore: 'Include night before event (early arrival)',
    arrival: 'Arrival',
    arrivalDate: 'Arrival Date',
    departure: 'Departure',
    departureDate: 'Departure Date',
    stay: 'Stay',
    checkout: 'Checkout',
    pickupTooltip: 'Data from MEWS API (reservation level). May differ from the MEWS block view, which counts pickups at block level.',
    eventStarts: 'Event starts',
    eventEnds: 'Event ends',
    rate: 'Rate',
    ratePerNight: 'Rate per Night',
    noSessions: 'No sessions configured',
    manageSessionsDesc: 'Create and manage sessions for this event.',
    availabilityBlock: 'Availability Block',
    selectAvailabilityBlock: 'Select an availability block',
    selectBlockHint: 'Select the block to pick up a room from',
    selectBlockFirst: 'Select an availability block first',
    businessSegment: 'Business Segment',
    selectBusinessSegment: 'Select Business Segment',
    cateringOrder: 'Catering Order',
    equipmentReservation: 'Equipment Reservation',
    deleteConfirmMsg: 'Are you sure you want to delete this item? This action cannot be undone.',
    willAlsoDelete: 'This will also delete',
    deleteEventConfirmIntro: 'You are about to permanently delete the event',
    deleteEventWillRemove: 'This will also permanently remove:',
    deleteEventItemSpaceBookings: 'All space bookings',
    deleteEventItemBlocks: 'All hotel blocks (incl. MEWS blocks)',
    deleteEventItemReservations: 'All reservations',
    deleteEventItemAttendees: 'All attendees',
    deleteEventItemSessions: 'All sessions',
    deleteEventItemCheckins: 'All check-ins',
    deleteEventIrreversible: 'This action cannot be undone.',
    deleteEventSuccessTitle: 'Event deleted',
    deleteEventSuccessIntro: 'The event has been deleted successfully.',
    deleteEventCleanedUp: 'Cleaned up:',
    deleteEventItemMewsBlocks: 'MEWS blocks',
    deleteEventItemDbBlocks: 'DB blocks',
    deleteEventFailedTitle: 'Delete failed',
    deleteEventFailedIntro: 'The event could not be deleted.',
    blockAwaitingApproval: 'Awaiting hotel approval',
    // Hotel summary card while no block holds anything (event at inquiry or
    // qualify). It states the ask rather than a utilisation of a block that
    // doesn't exist yet.
    blockIntentHeadline: 'rooms requested',
    blockIntentDraft: 'Not sent to the hotel yet — nothing is held in MEWS.',
    blockIntentRequested: 'Awaiting hotel approval — nothing is held in MEWS until the hotel accepts.',
    roomsRequestedShort: 'requested',
    blockErrorHint: 'Block must be repaired — pickups are failing',
    blockNoAvailability: 'No availability',
    blockNoAvailabilityHint: 'MEWS had no rooms free for some pickups',
    blockNotDecremented: 'Block not reduced',
    blockNotDecrementedHint: "This block's blocked rooms weren't reduced for its pickups, so the event's rooms don't reconcile. Use Heal to fix it.",
    blockHealthy: 'Block created — all good',
    blockRoomsLabel: 'rooms blocked',
    detachedShort: 'detached',
    detachedFromBlockHint: 'Outside the block (detached or linked) — counts toward overnight guests but does not take a block slot',
    detachedOutsideLabel: 'outside the block',
    blockProgressLabel: 'Pickup',
    totalShort: 'total',
    reservationsShort: 'reservations',
    independentReservations: 'independent',
    legacyReservationsTooltip: 'legacy reservations',
    legacyOnBlock: 'still attached',
    legacyDetached: 'old detached',
    blockUtilizationLabel: 'Block utilization',
    freeInBlock: 'free in block',
    blockFull: 'block full',
    blockFullHint: 'Every room in this block is picked up. To add another guest here, enlarge the block or free a room.',
    eventBlocksFullHint: 'Every block on this event is fully picked up. The next hotel guest will be refused — enlarge a block or free a room first. Lecturers, day guests, externals and online participants are not affected.',
    addBlock: 'Add block',
    categoryAlreadyBlocked: 'Already blocked',
    categoryAlreadyBlockedHint: 'An active block holds this category for this period. Change the dates — outside those nights the category is selectable again — or edit the existing block.',
    addBlockSubtitle: 'New room block for this event',
    addBlockCreate: 'Create block',
    addBlockSuccess: 'Block created',
    addBlockSplitSuccess: '{count} blocks created',
    addBlockRoomsRequired: 'Enter at least one room.',
    addBlockRowsRequired: 'Add at least one category.',
    addBlockDuplicateCategory: 'Each category can appear only once in the split.',
    addBlockSplitAdd: 'Add category',
    addBlockSplitHint: 'Split across categories so the whole allotment fits — one block per category.',
    categoryAlreadyInSplit: 'Already in split',
    categoryAlreadyInSplitHint: 'This category is already part of this split.',
    addBlockMewsHint: 'The block is created in MEWS once availability is confirmed.',
    overnightMatchShort: 'matches',
    overnightOverShort: 'over plan',
    overnightPlanShort: 'of',
    overnightPlannedShort: 'planned',
    overnightTargetHint: 'Planned overnight guests on the event',
    overnightMatchHint: 'Reservations match the planned overnight guests',
    overnightUnderHint: 'Fewer reservations than planned overnight guests',
    overnightOverHint: 'More reservations than planned overnight guests',
    missingShort: 'free in block',
    blockApprove: 'Approve',
    blockApproveTitle: 'Approve and create the MEWS block',
    blockApproved: 'Block approved — MEWS reservation created.',
    blockApproveInvalidState: 'Only requested blocks can be approved.',
    blockApproveFailed: 'Approval failed',
    blockApproveHint: 'The requested rooms will be booked in MEWS and held for the event. This can only be undone by rejecting.',
    blockApproveConfirm: 'Approve',
    blockReject: 'Reject',
    blockRejectTitle: 'Reject block release request',
    blockRejectIntro: 'This rejection is terminal — the block stays in our system but no MEWS reservation will be created.',
    blockRejectReason: 'Reason (optional but recommended)',
    blockRejectReasonPlaceholder: 'e.g. Hotel fully booked for those dates',
    blockRejectConfirm: 'Confirm rejection',
    blockRejecting: 'Rejecting…',
    blockRejected: 'Block rejected.',
    blockRejectInvalidState: 'Only requested blocks can be rejected.',
    blockRejectFailed: 'Rejection failed',
    blockReRequest: 'Request again',
    blockReRequestTitle: 'Send this block back to the hotel for approval',
    blockReRequested: 'Block re-requested — awaiting hotel approval.',
    blockReRequestInvalidState: 'Only rejected blocks can be re-requested.',
    blockReRequestFailed: 'Re-request failed',
    blockNotFound: 'Block no longer exists.',
    blockDates: 'Dates',
    deleteResMewsWarning: 'This reservation is synced with MEWS and will be cancelled in MEWS.',
    deleteResLocalInfo: 'This reservation exists only in EventHub and will be deleted.',
    resCancelledInMews: 'Reservation will be cancelled in MEWS',
    resDeletedFromDb: 'Reservation will be deleted from EventHub',
    cancelling: 'Cancelling...',
    cancelReservation: 'Cancel Reservation',
    cancelMewsNote: 'This reservation will also be cancelled in MEWS.',
    cannotBeUndone: 'This action cannot be undone!',
    eventsOn: 'Events on',
    noEventsOnDay: 'No events on this day',
    functionSheetPreview: 'Function Sheet Preview',
    proposalDesign: 'Design',
    proposalChooseDesign: 'Choose a design',
    proposalChooseDesignHint: 'Previewed with this event\'s own data.',
    proposalNoPreview: 'No preview available',
    proposalBetaHint: 'New design — not yet proven with customers. Please review before sending.',
    proposalChangeDesign: 'Change design',
    proposalPreview: 'Proposal Preview',
    proposals: 'Proposals',
    proposalHotelSchlossDesc: 'Elegant venue proposal in Hotel Schloss Montabaur style',
    proposalAdgQuoteDesc: 'Professional ADG quote with event details and pricing',
    exportPdf: 'Export PDF',
    functionSheet: 'Function Sheet',
    functionSheets: 'Function Sheets',
    sessionsTab: 'Sessions',
    spacesTab: 'Spaces',
    alsoBlocks: 'also blocks',
    combinedBlocksHint: 'Combined room – these rooms are blocked too',
    blockedIndirectly: 'blocked',
    indirectBlockedCount: '{n} indirectly blocked rooms',
    blockedIndirectlyHint: 'Not booked directly – blocked via a combined room',
    participantsTab: 'Hotel',
    hotelBlockTab: 'Hotel Block',
    cateringTab: 'Catering',
    equipmentTab: 'Equipment',
    infoTab: 'Info',
    seriesTab: 'Series',
    productsTab: 'Products',
    addPackage: 'Add Package',
    addProduct: 'Add Product',
    assignedPackages: '{count} package | {count} packages',
    individualProducts: 'Products',
    allProductsPackages: 'All Products & Packages',
    wholeEvent: 'Whole Event',
    noPackagesAssigned: 'No packages assigned yet',
    noProductsAssigned: 'No individual products yet',
    pickPackage: 'Pick Package',
    localPackages: 'Local',
    packages: 'Packages',
    loadingMewsPackages: 'Loading MEWS packages...',
    noMewsPackages: 'No MEWS packages found',
    pickProduct: 'Pick Product',
    removePackage: 'Remove Package',
    removeProduct: 'Remove Product',
    hardDeleteWarning: 'This item is not synced to MEWS and will be permanently deleted. This action cannot be undone.',
    softDeleteWarning: 'This item has been charged to MEWS and will be marked as cancelled (soft delete).',
    confirmRemovePackageTitle: 'Remove this package?',
    confirmRemoveProductTitle: 'Remove this product?',
    confirmRemoveDesc: 'will be removed from this event. This action cannot be undone.',
    packageTotal: 'Package Total',
    productsSummary: 'Products Summary',
    totalValue: 'Total Value',
    priceOverride: 'Price',
    unitPrice: 'Unit Price',
    searchPackages: 'Search packages...',
    createNewPackage: 'New Package',
    packageAddedCount: '{count}× added',
    ruleGenerated: 'Generated automatically by a rule',
    ruleGeneratedHint: 'Created by a rule and recalculated on every pickup — not editable here.',
    ruleLineOtherCategoryHint: 'Billed by a rule per participant; the product\'s catalogue category is not an F&B category, so it is listed here with the meals it belongs to.',
    ruleLinesMerged: '{count} participant lines merged',
    rulePerLineQtyHint: 'Per participant, set by the rule',
    chargeToParticipantsFromRule: 'Per participant (rule)',
    addPackageAgainHint: 'Click to add again (e.g. for a second seating)',
    noPackagesFound: 'No packages match your search',
    productsInPackage: 'Products',
    chargingType: 'Charge type',
    pricePerPackage: 'Price per package',
    viewParticipants: 'View participants',
    participantMissing: 'not found',
    chargedParticipantsTitle: 'Charged participants',
    // Calculation detail (D179) — explains a charged line from the backend's
    // frozen charge_resolution_snapshot.
    calcOpen: 'Show calculation',
    calcDetailTitle: 'Calculation detail',
    calcRule: 'Rule',
    calcPricingDate: 'Pricing date',
    calcStateCharged: 'charged',
    calcStateResolved: 'resolved',
    calcNoDetailTitle: 'No calculation stored yet',
    calcNoDetailHint: 'The breakdown is frozen once the line is charged to MEWS.',
    calcPackageFactorHint: 'Package items share one total, so unit prices are distributed proportionally and differ from the catalogue price.',
    calcRecipient: 'Recipient',
    calcRate: 'Rate',
    calcUnitPrice: 'Unit price',
    calcLineTotal: 'Total',
    calcPriceList: 'Price list',
    calcPriceListNotRecorded: 'not recorded',
    calcPriceListManual: 'Manual price',
    calcNotCharged: 'Not charged',
    calcNotChargedHint: 'not in this calculation — most often added after it was frozen',
    sessionDeleteBlockedCharged: 'Session "{name}" cannot be deleted: {count} product line(s) attached to it have already been charged to MEWS for this day. Release or cancel those lines first.',
    sessionDeleteMovesToEvent: 'Will be moved to the event',
    sessionDeleteProductsLine: '{count} product(s)',
    sessionDeletePackagesLine: '{count} package(s)',
    sessionMoveChargedWarning: '{count} product line(s) attached to this session have already been charged to MEWS for its current day. Moving the session changes the day they are billed for, while MEWS keeps the existing orders. Move anyway?',
    calcNotChargedNotPresent: 'not present on the session day \u2014 this line is billed for that one day only',
    calcNotChargedOutside: 'stay does not overlap the event',
    calcFrozenAt: 'Frozen at',
    calcTotal: 'Total',
    calcHeadcount: '{payers} participants \u00b7 {people} people',
    calcHeadcountPayersOnly: '{payers} participants',
    calcPackageItems: '{n} items',
    calcShowItems: 'Show items',
    calcHideItems: 'Hide items',
    calcOccupancyCurrentHint: 'Current occupancy ({n} people) \u2014 the room changed after the calculation; the frozen quantity no longer matches it.',
    calcCustomer: 'Customer',
    eventNotFound: 'Event not found',
    chargeTypeUniform: 'All products share the same charge type:',
    chargeTypeMixed: 'Products have mixed charge types — check before charging',
    // A package charges only when EVERY product in it carries the same valid
    // charge type — otherwise MEWS refuses the whole package.
    chargeTypeMissing: 'At least one product has no charge type. The package cannot be charged until every product has one (set it in product setup).',
    // The four real types stay as their raw MEWS spellings (see chargingTypeBadge),
    // but the ABSENCE of one is our own word, so it translates like any other.
    chargingTypeNone: 'no type',
    chargingTypeNoneInPackage: 'No charging type set — a package cannot be charged until every product in it has one',
    packageMissingChargingType: '{count} product(s) in this package have no charge type — set it in product setup',
    packageInvalidChargingType: 'A product in this package has an invalid charge type',
    packageMixedChargingType: 'Products in this package have different charge types — MEWS needs a single one',
    package: 'Package',
    product: 'Product',
    productCategory: 'Category',
    productCharging: 'Charging',
    chargeTo: 'Charge To',
    calcMode: 'Calculation',
    calcModeOnce: 'Once',
    calcModePerDay: 'Per day',
    calcModePerPerson: 'Per person',
    calcModePerPersonPerDay: 'Per person & day',
    calcModeHint: 'Quantity calculation mode (internal event — no MEWS billing).',
    calcModeEffectiveQtyHint: 'Effective qty = {mode} ({days} days × {people} people)',
    calcModeSaveFailed: 'Could not save calculation mode',
    calcModeFromProductHint: 'Inherited from the product catalog — change it there if needed.',
    cancelInternalTitle: 'Cancel event?',
    cancelInternalLede: 'The event will be set to "cancelled". Linked bookings will also be cancelled.',
    confirmStorno: 'Cancel event',
    internalCancelDefaultReason: 'Internal cancellation',
    chargeToParticipant: 'Participant',
    chargeToCustomer: 'Customer',
    chargeAllParticipants: 'All guests',
    chargeHotelParticipants: 'Participants only (excl. lecturers & dayguests)',
    chargeLecturerParticipants: 'Lecturers only',
    chargeDayguestParticipants: 'Dayguests only',
    // A scope option the line's charging type cannot use says why IN the option (EH-0186).
    chargeScopeBlockedShort: 'per-person price only',
    chargeScopeHotelHint: 'Regular participants — excludes lecturers, dayguests and externals. Most lecturers also stay in the hotel but are NOT charged here (use "Lecturers only").',
    chargeScopeLecturerHint: 'All lecturers — including those attending only as day guests. Billed to the lecturer invoice account, not the customer.',
    chargeScopeDayguestHint: 'Everyone carrying the dayguest badge, including lecturers and externals who are only there for the day. Overlaps with "Lecturers only", so the counts do not add up to "All participants".',
    chargeSelectParticipants: 'Select Participants',
    chargeToChoose: 'Please choose …',
    chargeInternal: 'Internal (no MEWS)',
    chargeInternalHint: 'Booked internally — not charged to MEWS',
    selectParticipants: 'Select Participants to Charge',
    cancelledHidden: '{n} cancelled reservation(s) are hidden — only confirmed participants can be charged.',
    cancelledShort: 'cancelled',
    lecturersIncluded: '{n} lecturer(s) included — lecturers are charged too (to the lecturer invoice account).',
    inclShort: 'incl.',
    participantsSelected: 'selected',
    picksNotBilled: '{count} not billable',
    noParticipants: 'No participants yet',
    customerNotSet: 'Cannot charge to customer — no customer is set for this event. Please set a customer first.',
    noCustomer: 'no customer',
    allServices: 'All Services',
    allCategories: 'All Categories',
    typeCustom: 'Custom',
    typeInternal: 'Internal',
    allCharging: 'All Charging',
    confirmRemovePackage: 'Remove package "{name}" from this event?',
    confirmRemoveProduct: 'Remove product "{name}" from this event?',
    loadError: 'Failed to load data',
    preview: 'Preview',
    sessionFunctionSheetDesc: 'Function sheet for this specific session.',
    viewEvent: 'View Event',
    externalEventReadonly: 'This event is managed by an external system and cannot be edited here.',
    externalEventLocked: 'This event is synced from an external system and cannot be changed',
    eventTimeline: 'Event Timeline',
    adgSeminars: 'ADG Seminars',
    date: 'Date',
    allotted: 'Allotted',
    pickedUp: 'Picked Up',
    available: 'Available',
    noEventsInSeries: 'No events in this series',
    optional: 'Optional',
    reservationInfo: 'Reservation Information',
    reservationId: 'Reservation ID',
    reservationNumber: 'Reservation Number',
    state: 'State',
    origin: 'Origin',
    groupId: 'Group ID',
    availabilityBlockId: 'Availability Block ID',
    guestInfo: 'Guest Information',
    customerId: 'Customer ID',
    guestName: 'Guest Name',
    adults: 'Adults',
    children: 'Children',
    roomAndDates: 'Room & Dates',
    checkIn: 'Check-in (UTC)',
    checkOut: 'Check-out (UTC)',
    requestedCategoryId: 'Requested Category ID',
    roomCategory: 'Room Category',
    categoryMoveTitle: 'Change room category',
    roomOtherCategory: 'Other category',
    roomCategoryChangeTag: 'category change',
    categoryMoveNeedsRoom: 'Pick a room in the new category — otherwise MEWS keeps the old room assigned and the category is only requested.',
    pickRoomInNewCategory: 'That room is not in the new category — please pick another.',
    roomOtherCategoryHint: 'Category change — this room is in:',
    noRoomsAvailable: 'No rooms available',
    categoryMoveIntro: 'The reservation moves to another category in MEWS. Room and category travel in one update — MEWS refuses a room outside the category.',
    roomCategoryChoose: 'Pick category…',
    pickDatesFirstForCategory: 'Pick the dates first',
    rateChoose: 'Pick rate…',
    roomCategoryAdd: 'Add category',
    roomTypesUnavailable: 'No room categories configured for this property.',
    roomsTotal: 'Total',
    assignedSpaceId: 'Assigned Space ID',
    notAssigned: 'Not assigned',
    assignedRoom: 'Assigned Room',
    bookingDetails: 'Booking Details',
    blockInfo: 'Block Information',
    blockId: 'Block ID',
    blockNumber: 'Block Number',
    datesLabel: 'Dates',
    notesLabel: 'Notes',
    resourceCategory: 'Resource Category',
    firstDate: 'First Date',
    lastDate: 'Last Date',
    roomCount: 'Room Count',
    roomsBlocked: 'blocked',
    roomsReleased: 'released',
    businessSegmentId: 'Business Segment ID',
    na: 'N/A',
    noEventSelected2: 'No event selected',
    webinar: 'Webinar',
    seminar: 'Seminar',
    workshop: 'Workshop',
    forum: 'Forum',
    tagung: 'Tagung',
    online: 'Online',
    roomDates: 'Room & Dates',
    checkInUtc: 'Check-in (UTC)',
    checkOutUtc: 'Check-out (UTC)',
    hotelGuest: 'Hotel Guest',
    dayGuest: 'Day Guest',
    external: 'External',
    noBlockForHotelPickup: 'Hotel pickup not available — no room block configured for this event.',
    noHeldBlockForHotelPickup: 'No room block is held yet — the hotel must approve a block (move the event to Qualify) before hotel guests can be added. Day guests can still be added.',
    blockExhaustedForHotelPickup: 'Room block exhausted — no room is left in the MEWS block. Increase the block or cancel a reservation. Day guests can still be added.',
    allRoomsPickedUp: 'All rooms picked up ({used}/{total}). Add a new block or remove a reservation to pick up more.',
    searchCustomer: 'Search customer in MEWS (min 4 chars)...',
    roomPreference: 'Room Preference',
    roomPreferencePlaceholder: 'e.g. Quiet location, upper floor',
    typeOfStay: 'Type of Stay',
    isLecturer: 'Lecturer',
    paymentMethod: 'Payment Method',
    participantsCountBulk: 'Number of participants (bulk)',
    bulkPickupHint: '{n} identical bookings will be created.',
    roomsCount: 'Number of rooms (bulk)',
    invoiceOwner: 'Invoice owner',
    invoiceOwnerSet: 'Set',
    invoiceOwnerNone: 'No separate invoice owner',
    selectInvoiceOwner: 'Select invoice owner from MEWS...',
    selectCustomerShort: 'Select customer…',
    selectInvoiceOwnerShort: 'Select recipient…',
    invoiceOwnerApplyOpen: 'Apply to more participants…',
    invoiceOwnerApplyTitle: 'Apply invoice owner to',
    invoiceOwnerApplyHint: 'Applied to the selected participants when you save.',
    invoiceOwnerApplyOk: 'Invoice owner applied to {n} participants',
    invoiceOwnerApplyPartial: 'Invoice owner partly applied — some failed',
    selectAll: 'All',
    invoiceOwnerHint: 'Optional, independent from guest / booker / company.',
    invoiceOwnerCompany: 'Invoice owner / Company',
    selectInvoiceOwnerCompany: 'Select invoice owner / company from MEWS...',
    alsoSetAsCompany: 'Also set as company (MEWS company + K-number).',
    splitFields: 'Split',
    combineFields: 'Combine',
    splitInvoiceCompanyHint: 'Set invoice owner and company separately',
    combineInvoiceCompanyHint: 'Combine into one field',
    companyInfoOnly: 'Company is for information only (MEWS company + K-number) — it does not pay. The invoice owner is the payer.',
    priceOverwrite: 'Price override',
    priceOverwriteHint: 'Price was manually overridden — differs from the rate default',
    priceColShort: 'Price',
    priceEditTooltip: 'Override or adjust price',
    priceEditTitle: 'Override price',
    priceEditSubtitleAll: 'All participants',
    perNight: 'night',
    priceApplyAll: 'Apply to all',
    priceApplySingle: 'This one only',
    priceApplyAllOk: 'Price applied to {n} reservations.',
    priceApplyAllPartial: '{ok} applied, {fail} failed:',
    priceInvalid: 'Invalid price.',
    priceCurrentMews: 'Currently in MEWS',
    priceCurrentMewsHint: 'Current rate price from MEWS (no override applied)',
    priceUseCurrent: 'use this',
    priceAmount: 'Amount',
    priceReason: 'Reason',
    priceReasonPlaceholder: 'e.g. special arrangement',
    linkStatus: 'Block link',
    linkPickup: 'Pickup',
    linkDetached: 'Detached',
    linkFailed: 'Failed',
    morning: 'Morning',
    afternoon: 'Afternoon',
    failedEditTitle: 'Failed pickup — fix and retry.',
    failedEditHint: 'Correct what caused it (e.g. rate, dates, category) and save. The change is stored locally; then click ↻ in the list to re-attempt the MEWS pickup. Room assignment and invoice owner apply only after the pickup succeeds.',
    // Restriction variant. Retrying is still the mechanism, so ↻ stays — but
    // only AFTER a real change, and "different dates" is usually not the change
    // that works. Naming the room category matters: MEWS restrictions are set
    // per rate AND per category, and the category is the half operators forget.
    failedEditRestrictedTitle: 'Refused by a MEWS restriction — change the rate or room category.',
    failedEditRestrictedHint: 'MEWS blocks this rate together with this room category on these days (closed to arrival, closed for stays, or a minimum/maximum length of stay). This is not a shortage of rooms, so free rooms will not help and simply retrying will fail again. Change the room category or the rate and save, then click ↻ in the list. If nothing works, the restriction has to be checked in MEWS.',
    linkLinked: 'Linked',
    legacyPickupHint: 'Reservation still tied to a block — legacy shape before the detached-only migration',
    legacyDetachedHint: 'Pre-migration detached — last_action=detached_from_block',
    linkPhantom: 'Phantom',
    phantomLinkTooltip: 'This reservation shares a MEWS id with another but the MEWS booking may not actually cover these dates. Verify with reception.',
    phantomLinkCancelTitle: 'Phantom link detected',
    phantomLinkCancelHint: 'This reservation shares a MEWS id with another but the MEWS booking may not actually cover these dates. Verify with reception before cancelling.',
    renderCapHint: 'Showing {shown} of {total} — use the filter or search to narrow the list.',
    renderCapShowAll: 'Show all',
    prevEvent: 'Previous event',
    nextEvent: 'Next event',
    loadingRoomFromMews: 'Loading room from MEWS…',
    roomNotYetAssigned: 'Not yet assigned',
    roomNotYetAssignedTitle: 'MEWS usually assigns rooms at check-in.',
    pickCategoryFirstForRoom: 'Pick a room category first',
    noRoomsInCategory: 'No rooms in this category',
    roomsLoadFailed: 'Could not load rooms',
    roomOccupied: 'occupied',
    roomBlocked: 'block',
    roomOutOfService: 'out of service',
    roomCurrent: 'current',
    reservationNotCreated: 'Not booked',
    reservationNotCreatedTitle: 'MEWS did not create a reservation, so there is no MEWS booking or room number.',
    reservationFailed: 'Reservation failed',
    roomMatchesMews: 'Same as MEWS',
    roomMissingInMews: 'Not set in MEWS',
    matchesMews: 'Matches MEWS',
    mewsDriftTitle: 'MEWS has a different value — showing the MEWS value (overwritten).',
    roomConflictTitle: 'Same room is assigned to {n} other reservation(s) in this period — likely a failed pickup linked multiple rows to one MEWS reservation.',
    mewsUnavailableRoomTitle: 'MEWS unreachable — room status can\'t be verified.',
    roomMewsCanceledTitle: 'Already cancelled in MEWS — local status not yet synced.',
    roomMewsMissingTitle: 'No longer in MEWS — likely cancelled and archived.',
    roomCategoryFromMews: 'From MEWS — no wish / no assignment recorded on our side',
    mewsStatusNotFound: 'not found',
    roomTypePickHint: 'Select',
    companyPartySet: 'Company set',
    roomTypeMismatchTitle: 'MEWS confirmed a different room type than requested',
    roomTypeConfirmed: 'Request confirmed',
    roomTier: 'Category',
    teilnehmerSearchPlaceholder: 'Name, email, company…',
    teilnehmerSearchScope: 'Searches name, email and company',
    productsColHint: 'R = Reservation · C = Customer',
    bulkSelected: '{n} selected',
    bulkCancel: 'Cancel',
    bulkClearSelection: 'Clear selection',
    bulkCancelConfirm: 'Cancel {n} reservations?',
    bulkCancelReason: 'Bulk cancel',
    bulkCancelTitle: 'Cancel {n} reservations',
    bulkCancelPartial: '{ok} cancelled, {fail} failed.',
    duplicateRowTitle: 'Add like this',
    linkedLegInHouse: 'in house',
    linkedLegInHouseTitle: 'Continued from a previous event',
    linkedLegContinues: 'continues',
    linkedLegContinuesTitle: 'Stay continues in the next event',
    updateFailed: 'Update failed',
    updateMissingId: 'Reservation id is missing — update is not possible.',
    // A retry replaces a failed reservation with a new row carrying a new id.
    // Both messages explain why the row changed underneath the operator,
    // instead of leaking the raw "Reservation not found" error.
    reservationReplacedRetried: 'This reservation was replaced by a retry — your change was applied to the current one.',
    reservationReplacedGone: 'This reservation was replaced by a retry and can no longer be found. The list has been refreshed.',
    swapGuest: 'Swap guest',
    swapGuestTitle: 'Swap guest on this reservation',
    swapGuestSubtitle: 'The reservation, folio, dates and room are preserved.',
    swapGuestOld: 'Current guest',
    swapGuestNew: 'New guest',
    swapGuestPreservedTitle: 'Preserved',
    swapGuestPreservedFolio: 'MEWS reservation number + folio',
    swapGuestPreservedDates: 'Arrival, departure, and length of stay',
    swapGuestPreservedRoom: 'Assigned room and rate',
    swapGuestConfirm: 'Confirm swap',
    swapGuestSwapping: 'Swapping…',
    swapGuestFailed: 'Guest swap failed',
    swapGuestMenuHint: 'Replace the guest on the same reservation',
    openInMewsHint: 'View this reservation in MEWS Commander',
    change: 'Change',
    choose: 'Choose',
    noChanges: 'No changes',
    fieldChanged: 'field changed',
    fieldsChanged: 'fields changed',
    invoiceOwnerProducts: 'Items for invoice recipient',
    rateMember: 'Member',
    // Block statuses. `new` and `requested` hold NOTHING in MEWS — the wording
    // has to make that unmissable, or an operator reads a draft as a real hold.
    blockStatusLabel: {
      new: 'Draft — not held',
      requested: 'Awaiting hotel approval',
      created: 'Held',
      confirmed: 'Held',
      definite: 'Held',
      rejected: 'Rejected by hotel',
      no_availability: 'No availability',
      released: 'Released',
      delete_pending: 'Deletion pending',
      pending: 'Pending',
      error: 'Error',
      canceled: 'Cancelled',
      cancelled: 'Cancelled',
    },
    saveBlocked: 'This change was refused: the event\'s room blocks are not ready.',
    statusChangeBlocked: 'This stage change was refused: the event\'s room blocks are not ready.',
    // The stage change was saved, but the room request behind it was not (upsert pmsBlockError).
    roomRequestNotSent: 'The room request did not reach the hotel. The status was still changed — please check the Hotel tab and report this.',
    warningBlocksNotApproved: 'Some room blocks are not yet approved by the hotel — the stage change will be refused.',
    invoice: 'Invoice',
    creditCard: 'Credit Card',
    companyPayment: 'Company Invoice',
    companyName: 'Company',
    selectCustomerFirst: 'Please search and select a customer',
    guestSwapped: 'Guest swapped.',
    guestSwappedProductsStay: 'Guest swapped. Products already charged are still with the previous guest.',
    guestSwappedProductsReposting: 'Guest swapped. Products already charged are being re-posted for the new guest.',
    invoiceOwnerChangedProductsReposting: 'Invoice recipient changed. Products already charged are being re-posted for the new recipient.',
    stayChangedProductsReposting: 'Saved. Products already charged are being checked and re-posted for the changed stay where needed.',
    swapNeedsParty: 'The chosen contact could not be linked — please pick it again.',
    datesOutsideEvent: 'The stay must share at least one day with the event ({from} – {to}). Nothing was saved.',
    datesRequired: 'Start and end date are required',
    fromBlock: 'From Block',
    signageFrom: 'From',
    signageTo: 'To',
    fnbTab: 'F&B',
    signagePreview: 'Signage Preview',
    signageSettings: 'Signage Settings',
    signageLine3: 'Signage Line 3',
    signageLine3Placeholder: 'Third line of signage text...',
    signageLine3DisabledHint: 'Line 3 is hidden when a logo is set',
    signageLogo: 'Logo',
    signageLogoLabel: 'Logo (Contact No.)',
    signageLogoPlaceholder: 'Enter contact number to show logo...',
    signageLogoHint: 'If set, a company logo is displayed and line 3 is hidden',
    beschilderung: 'Signage',
    signage: 'Signage',
    signageNotAvailable: 'Digital signage is not enabled for this room. Enable it in Property Setup → Spaces.',
  },
  spaceAvailability: {
    title: 'Availability',
    confirmedLegend: 'Confirmed',
    suggestedLegend: 'Suggested (bookable)',
    suggestedHint: 'Suggested bookings only – they don’t block, the room is still bookable',
    legendFormat: 'Format',
    legendTotal: 'Total',
    legendGood: 'good availability (>10)',
    legendTight: 'tight (1–10)',
    legendNone: 'nothing free (0)',
    legendOverbooked: 'overbooked',
    today: 'Today',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    day: 'Day',
    available: 'Available',
    occupied: 'Occupied',
    booked: 'Booked',
    maintenance: 'Maintenance',
    room: 'Room',
    capacity: 'Capacity',
    bookings: 'Bookings',
    viewDetails: 'View Details',
    allProperties: 'All Properties',
    all: 'All',
    spaces: 'Spaces',
    rooms: 'Rooms',
    withBookings: 'With Bookings',
    withoutBookings: 'Without Bookings',
    searchSpaces: 'Search spaces...',
    legend: 'Legend',
    spaceTypeFilter: 'Space Type Filter',
    bookingFilter: 'Booking Filter',
    loadingData: 'Loading availability data...',
    loadingCategories: 'Loading room categories...',
    noCategories: 'No room categories found',
    noCategoriesDesc: 'Room category data will appear here when available.',
    stayDetails: 'Stay Details',
    availabilityBlocks: 'Availability Blocks',
    noBlocks: 'No availability blocks for this day',
    reservation: 'Reservation',
    reservations: 'Reservations',
    category: 'Category',
    noReservations: 'No reservations for this day',
    noEvent: 'No Event',
    time: 'Time',
    customer: 'Customer',
    noBookings: 'No Bookings',
    noBookingsDesc: 'No space bookings for this day',
    roomCategory: 'Room Category',
    roomsBlocked: 'rooms blocked',
    bookedSpaces: 'booked',
    clickToOpen: 'Click for details',
    hotelRoomsTotal: 'Available Rooms',
    blockedRooms: 'Blocked Rooms',
    meetingRoomsTotal: 'Available Spaces',
    blockedMeetingRooms: 'Blocked Meeting Rooms',
    blocked: 'Blocked',
    reserved: 'Reserved',
    totalRooms: 'Total',
    overbooked: 'Overbooked',
    external: 'External',
    releasedHint: '{raw} block units are listed below, but MEWS reports only {held} as currently held — the difference is likely released/cancelled.',
    pickup: 'Pickup',
    pickedUp: 'Picked up',
    direct: 'Direct',
    pickupHint: 'Booked against the event\'s room block — the block shrank by one, so this adds no extra occupancy.',
    directHint: 'Direct reservation with no block — reduces inventory on top of any blocks.',
    unknownReservations: 'of which not in EventHub',
    unknownReservationsHint: 'The reservation exists in MEWS but has no matching row in our own tables — booked directly in MEWS Operations, through another channel, or an EventHub walk-in (those are deliberately not mirrored). Not necessarily a problem.',
    clickToVerify: 'Click for details',
    pickupClassification: 'Classification',
    dateRange: 'Date range',
    assignedRoom: 'Room',
    dbRowRaw: 'DB row (raw fields)',
  },
  // EH-0174 — room size on the room picker, the Spaces tab and the checks.
  // "up to" = no seating chosen, so the largest seating is shown.
  spaceCapacity: {
    hybrid: 'Hybrid',
    noHybrid: 'No hybrid',
    hybridRequired: 'Hybrid event – needs a room with hybrid setup',
    hybridFitCount: '{fit} of {total} rooms have a hybrid setup',
    selectedNoHybrid: 'This room has no hybrid setup, but the event is hybrid.',
    setupFitCount: '{fit} of {total} rooms suit {setup}',
    suggestedCount: '{n}× requested',
    upTo: 'up to {n} seats',
    upToTitle: 'Up to {n} seats in the largest seating. The real number depends on the seating.',
    seats: '{n} seats',
    seatsTitle: '{n} seats in {setup}',
    noSetupData: '{setup}: no data',
    noSetupDataTitle: 'No capacity is recorded for {setup} in this room.',
    bestFit: 'Best fit',
    tooSmall: 'Too small',
    tooSmallAnySeatingTitle: 'Too small for {pax} people even in the largest seating ({cap} seats).',
    large: 'Large',
    veryLarge: 'Very large',
    overCapacity: 'Over capacity ({pax}/{cap})',
    // Change-room dialog confirmations. With a seating: that seating's number.
    // Without one: only what is true in every seating.
    promptTooSmallSeating: '{room} has {cap} seats in {setup} – not enough for {pax} people.',
    promptTooBigSeating: '{room} has {cap} seats in {setup} – far more than {pax} people need. {best} ({bestCap} seats) fits better.',
    promptTooSmallAnySeating: '{room} is too small for {pax} people even in its largest seating (up to {cap} seats).',
    promptTooBigAnySeating: '{room} is larger than {pax} people need in every seating – even the smallest ({setup}) has {cap} seats.',
  },
  pickupErrors: {
    PARTICIPANT_IDENTITY_REQUIRED: 'This booking could not be identified and was not saved. Nothing was charged. Please close the form, reopen it and try again — if it keeps happening, report it.',
    BLOCK_NOT_YET_APPROVED: 'Hotel approval still pending — the room block is awaiting hotel approval. Pickup is blocked until the hotel approves the release.',
    BLOCK_FULL: 'No room is held for the requested category yet. If the event is still an inquiry, move it to Qualify and have the hotel approve the block; otherwise the block is full — free a room or pick another category.',
    // Variant of BLOCK_FULL for `details.event_fully_picked_up === true`.
    BLOCK_FULL_EVENT_EXHAUSTED: 'This event\'s room block is fully picked up — no room is left in any block. Choosing another category will not help: enlarge the block, or free a room, to add another guest.',
    BLOCK_REJECTED: 'Hotel rejected this booking — pick a different room or date.',
    BLOCK_RECONCILIATION_REQUIRED: 'This event\'s room block is out of sync with MEWS. Run "Check & repair blocks" on the event, then try again.',
    NO_ROOM_IN_TARGET_CATEGORY: 'No room left in the requested category. Pick a different room category, or free one up first.',
    ROOM_TYPE_UNRESOLVABLE: 'The requested room category doesn\'t exist for this property. Check the property\'s room types.',
    RATE_ID_UNRESOLVABLE: 'The selected rate isn\'t valid for this property. Pick a different rate.',
    DATES_OUTSIDE_EVENT: 'The stay does not share a single day with the event. Arriving earlier or staying longer is fine, but at least one day must fall within the event period. Nothing was saved.',
    // Deliberately does NOT prescribe a remedy. This is the catch-all for an
    // unclassified MEWS write refusal, and the causes it covers have opposite
    // fixes — the classified codes below say what to actually do.
    AUTO_DETACH_FAILED: 'MEWS refused this booking — nothing was created and nothing was charged. The reason from MEWS is shown below. Retrying the same combination will not help.',
    MEWS_UPDATE_FAILED: 'MEWS rejected the change — nothing was saved.',
    CUSTOMER_SWAP_FAILED: 'The guest profile could not be swapped in MEWS. Nothing was saved.',
    GUEST_NO_MEWS_ID: 'This contact has no MEWS profile. Please choose a contact that has one.',
    BILL_ALREADY_ISSUED: 'An invoice was already issued for this stay. Please reverse it in MEWS first (credit note), then repeat the change.',
    GUEST_SWAP_SHARED_CHAIN: 'This stay is linked to other events — the guest cannot be swapped here.',
    INVOICE_OWNER_SHARED_CHAIN: 'This stay is linked to other events — the invoice owner cannot be changed here.',
    BILL_STATE_UNKNOWN: 'MEWS could not be reached, so nothing was changed. Please try again in a moment.',
    // ── Classified causes ────────────────────────────────────────────────────
    rate_restricted_for_dates: 'MEWS refused this booking: reservations are restricted for the selected dates. This is a restriction in MEWS on this rate and room category (closed to arrival, closed for stays, or a minimum/maximum length of stay) — not missing rooms. Free rooms make no difference. Try a different room category or rate, or have the restriction checked in MEWS. Nothing was created and nothing was charged.',
    rate_not_valid: 'MEWS does not accept the selected rate for these dates and this room category ("Rate is not valid"). The rate exists but is not applicable here — pick a different rate, or have it corrected in MEWS. Nothing was created and nothing was charged.',
    rate_not_found: 'The selected rate no longer exists in MEWS. Pick a different rate, or have it restored in MEWS. Nothing was created and nothing was charged.',
  },
  reservations: {
    weekStartLabel: 'Week from',
    weekStartHint: 'First day of the week in this view. KW stays the ISO calendar week (Monday) — it keeps counting as BC and MEWS do.',
    title: 'Room & Space Planning List',
    requestedSetup: 'Requested setup',
    loadingData: 'Loading reservation data...',
    mewsLoading: 'Loading occupancy from MEWS…',
    mewsLoadFailed: 'Could not load the occupancy from MEWS.',
    confirmedShort: 'Confirmed',
    definiteShort: 'Definite',
    inquiryShort: 'Inquiry',
    tentativeShort: 'Option',
    cancelledShort: 'Cancelled',
    eventStatusTooltip: 'Event status',
    bookingsTotal: 'Bookings',
    filterAll: 'All',
    filterWith: 'Booked',
    filterBlocked: 'Blocked',
    blockOverbooked: 'block rooms with no free room',
    showBlockedRooms: 'Rooms held by a block',
    filterWithout: 'Free',
    showAllRooms: 'Show all rooms',
    showWithBookings: 'Rooms with bookings',
    showWithoutBookings: 'Rooms without bookings',
    showEventName: 'Show event name',
    showEventNumber: 'Show event number',
    eventNumberShort: 'No.',
    eventNameShort: 'Name',
    all: 'All',
    spaces: 'Spaces',
    rooms: 'Rooms',
    dayGuests: 'Day Guests',
    printPdf: 'PDF',
    printPdfHint: 'Save or print the current date range as PDF',
    printPreviewTitle: 'Print preview',
    printBookings: 'bookings',
    printEmpty: 'No reservations in the selected date range.',
    printPrintedOn: 'As of',
    printColSpace: 'Space',
    printColRoom: 'Room',
    printColGuest: 'Guest',
    printColEvent: 'Event',
    printColFrom: 'From',
    printColTo: 'To',
    printColArrival: 'Arrival',
    printColDeparture: 'Departure',
    printColPax: 'Pax',
    printColStatus: 'Status',
    event: 'Event',
    eventFilter: 'Event',
    eventFilterHint: 'Filter by event',
    eventsSelected: 'events',
    searchEvents: 'Search event…',
    noEvents: 'No events',
    selected: 'selected',
    reset: 'Reset',
    room: 'Room',
    availableInclBlocks: 'Available incl. blocks',
    dailyOccupancy: 'Rooms free per day',
    dailyOccupancyLegend: 'Reservations / Blocks / Total',
    freeShort: 'Free',
    dailySpaceAvailability: 'Spaces free per day',
    suggestedShort: 'Suggested',
    collapseGroup: 'Collapse',
    categoryMismatchChipHint: 'Counts only reservations that have a room on this tab — unassigned ones, or rooms on another tab, are not counted here.',
    syncFilterApply: 'Show only these reservations',
    syncFilterClear: 'Clear filter',
    syncFilterNone: 'No reservations in this state',
    weeksShort: 'wk',
    shiftWindowHint: 'Shift the window — same length, different span (for stays across the month change)',
    shiftWindowReset: 'Back to the calendar month',
    collapseAll: 'Collapse all',
    expandAll: 'Expand all',
    expandGroup: 'Expand',
    reservationsShort: 'Res.',
    blocksShort: 'Blocks',
    totalShort: 'Total',
    sortByRoomNumber: 'Room number',
    sortByReserved: 'Reservations',
    mewsBusyRetry: 'MEWS is currently processing another change on this reservation. Please wait a few seconds and try again.',
    moveFailed: 'Could not move the booking to the new room. No changes were made — please try again.',
    moveSuperseded: 'This booking was changed elsewhere in the meantime. The view has been refreshed — please check the current state.',
    space: 'Space',
    spaceRoom: 'Space / Room',
    booked: 'Booked',
    doubleBooking: 'Double Booking',
    multipleRequestsHint: '{n} suggested requests for this room at this time (only one gets confirmed)',
    kpiTotalHint: 'All event blockings in the visible date range (hotel reservations are rendered as their own blocks).',
    kpiConfirmedHint: 'Events with status Confirmed or Definite.',
    filterConfirmedBookingsHint: 'Confirmed space bookings. Click to filter; click again to show all.',
    filterConfirmedReservationsHint: 'Confirmed hotel reservations, including checked-in and completed stays. Click to filter; click again to show all.',
    filterPendingReservationsHint: 'Unconfirmed hotel reservations. Click to filter; click again to show all.',
    filterSuggestedBookingsHint: 'Suggested space bookings. Click to filter; click again to show all.',
    kpiInquiryHint: 'Events with status Inquiry — not yet confirmed.',
    kpiDoubleBookingHint: 'Overlapping bookings from two different events on the same non-shareable room. Each overlap counts once.',
    kpiDoubleBookingClickHint: 'Click: show only these bookings.',
    kpiCategoryMismatchHint: 'Hotel reservations where the assigned room category is NOT the one originally requested (downgrade or upgrade).',
    categoryMismatchShort: 'Category ≠ wish',
    categoryMismatchTooltip: 'Wish → assigned',
    kpiCategoryMismatchClickHint: 'Click: show only these reservations.',
    checkinShort: 'Check-in',
    checkoutShort: 'Check-out',
    allSizes: 'All Sizes',
    allRoomTypes: 'All Room Types',
    spaceTypeSeminar: 'Seminar room',
    spaceTypeGroup: 'Group room',
    spaceTypeEvent: 'Event room',
    spaceTypeEventSeminar: 'Event & seminar room',
    spaceTypeBar: 'Bar',
    spaceTypeLounge: 'Lounge',
    allStreams: 'All streams',
    colName: 'Name',
    colStatus: 'Status',
    bookingStatus: 'Booking status',
    pax: 'PAX',
    eventType: 'Event type',
    stream: 'Stream',
    participation: 'Participation',
    eventPeriod: 'Event period',
    participantsMinMax: 'Participants (min/max)',
    estRevenue: 'Estimated revenue',
    contact: 'Contact',
    eventNotes: 'Event notes',
    roomBlock: 'Room block',
    category: 'Category',
    period: 'Period',
    changeBlock: 'Change block',
    arrival: 'Arrival',
    departure: 'Departure',
    moveToOtherCategory: 'Move to another category',
    targetCategory: 'Target category',
    upTo: 'up to',
    noBookingsFound: 'No bookings found for this period.',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    toEvent: 'To Event',
    start: 'Start',
    end: 'End',
    expectedPax: 'Expected PAX',
    setupType: 'Setup Type',
    notes: 'Notes',
    confirmMoveTitle: 'Confirm Room Change',
    confirmMoveDesc: 'Do you really want to move this booking?',
    fromSpace: 'From Room',
    toSpace: 'To Room',
    categoryLabel: 'Category',
    categoryMoveWarn: 'Category change: this moves the reservation to another category in MEWS. Choose whether the stay is repriced at the new rate or the current price is kept.',
    moveReprice: 'Move & reprice',
    moveKeepPrice: 'Move, keep price',
    date: 'Date',
    confirmMove: 'Yes, move',
    confirmResizeTitle: 'Confirm Time Change',
    confirmResizeDesc: 'Do you really want to change the time of this booking?',
    from: 'From',
    to: 'To',
    confirmResize: 'Yes, change',
    viewDay: 'Day',
    viewWeek: 'Week',
    viewMonth: 'Month',
    dropHere: 'Drop Here',
    blocked: 'Occupied',
    sharedBooking: 'Shared',
    goToEvent: 'Open Event',
    hotelReservation: 'Hotel Reservation',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Guests',
    syncedWithMews: 'Synced with MEWS',
    mewsOnly: 'MEWS only (not in DB)',
    changeRoom: 'Change room',
    mewsOnlyNoRoomChange: 'MEWS-only — room cannot be changed here',
    dbOnly: 'DB only (not in MEWS)',
    deleteBooking: 'Delete Booking',
    deleteBookingConfirm: 'Are you sure you want to delete this space booking?',
    deleteBookingWarning: 'This action cannot be undone.',
    deleting: 'Deleting...',
    availableRooms: 'Available Rooms',
    details: 'Details',
    moveHere: 'Move Here',
    noAvailableRooms: 'No available rooms for this time slot.',
    currentRoom: 'Current Room',
    capacity: 'Capacity',
    available: 'Available',
    conflict: 'Occupied',
  },
  cateringOrders: {
    title: 'Catering Orders',
    newOrder: 'New Order',
    editOrder: 'Edit Order',
    deleteOrder: 'Delete Order',
    orderNumber: 'Order Number',
    orderDate: 'Order Date',
    deliveryDate: 'Delivery Date',
    items: 'Items',
    totalAmount: 'Total Amount',
    pending: 'Pending',
    confirmed: 'Confirmed',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
  },
  roomOccupancy: {
    showSpaceNotRequired: 'Show without room',
    spaceNotRequiredHint: 'Events explicitly marked as not needing a seminar room are hidden here by default.',
    title: 'Release Overview Seminar & Event Rooms',
    loading: 'Loading occupancy data...',
    event: 'Events',
    inquiryShort: 'Inquiry',
    cancelledShort: 'Cancelled',
    participants: 'Participants',
    overnightGuests: 'Overnight guests',
    searchEvents: 'Search events...',
    spaceBooking: 'Space Booking',
    hotelReservation: 'Hotel',
    sessionBooking: 'Session',
    noSpace: 'No Space',
    roomRequest: 'Room request',
    eventTime: 'Event Time',
    pmsBlock: 'Blocked/Picked up',
    roomBlocks: 'Room Blocks',
    rooms: 'Rooms',
    reservations: 'Reservations',
    noReservations: 'No reservations yet',
    guest: 'Guest',
    arrival: 'Arrival',
    departure: 'Departure',
    roomType: 'Room Type',
    state: 'Status',
    meetingSpaces: 'Meeting Spaces',
    hotelRooms: 'Hotel Rooms',
    available: 'available',
    booked: 'Booked',
    blocked: 'Blocked',
    pickedUp: 'Picked up',
    noAvailable: 'All spaces are booked',
    total: 'total',
    noBlocks: 'No room blocks on this day',
    noEvents: 'No events in this period',
    assignRoom: 'Assign Room',
    changeRoom: 'Change Room',
    clickToAssign: 'Click to assign room',
    requestedSetup: 'Requested',
    searchRooms: 'Search rooms...',
    noRoomsFound: 'No rooms found',
    checkingAvailability: 'Checking availability...',
    current: 'Current',
    removeBooking: 'Remove Booking',
    suggested: 'Suggested',
    confirmed: 'Confirmed',
    confirmBooking: 'Confirm',
    confirmRoomNamed: 'Fix {room}',
    confirmNeedsEndTime: 'This session has no valid end time, so the room cannot be released. Please open the session, set an end time and save.',
    actionFailed: 'Action failed. Please try again.',
    roomSuggestedHint: 'Room suggested only – not yet fixed (independent of the event status)',
    suggestedRoomFixHint: '{room} is only suggested for this event and not yet fixed. This is independent of the event status – a confirmed event keeps its suggested rooms until they are fixed here.',
    suggestedRoomFixHintGeneric: 'This room is only suggested for this event and not yet fixed – independent of the event status.',
    setToSuggested: 'Set to Suggested',
    sortBy: 'Sort',
    sort_auto: 'Best Fit',
    sortByName: 'Name A-Z',
    sort_size: 'Size',
    sort_usage: 'Usage',
    sortByDate: 'Date',
    sortByPax: 'Pax',
    sortByDuration: 'Duration',
    sortByStream: 'Stream',
    sortByStatus: 'Status',
    sortBySpace: 'Space Booking',
    removeBookingTitle: 'Remove Booking?',
    removeBookingWarning: 'This will remove the room assignment. This action cannot be undone.',
    sizeWarningTitle: 'Room Size Mismatch',
    chooseDifferent: 'Choose different',
    useAnyway: 'Use anyway',
    cancel: 'Cancel',
    theatre: 'Theatre',
    classroom: 'Classroom',
    uShape: 'U-Shape',
    allTypes: 'All Types',
    allBuildings: 'All Buildings',
  },
  beo: {
    title: 'Banquet Event Order',
    createBEO: 'Create BEO',
    eventDetails: 'Event Details',
    setupRequirements: 'Setup Requirements',
    foodAndBeverage: 'Food & Beverage',
    audioVisual: 'Audio & Visual',
    specialRequests: 'Special Requests',
    timeline: 'Timeline',
    notes: 'Notes',
  },
  exporter: {
    title: 'Data Export',
    selectData: 'Select Data',
    selectFormat: 'Select Format',
    exportData: 'Export Data',
    dateRange: 'Date Range',
    from: 'From',
    to: 'To',
    includeArchived: 'Include Archived',
    csv: 'CSV',
    excel: 'Excel',
    pdf: 'PDF',
    json: 'JSON',
  },
  bookingPlan: {
    exportPdf: 'PDF',
    exportPdfHint: 'Save or print this week as a PDF (landscape)',
    weekLabel: 'Week {n}',
    printedOn: 'As of {date}',
    title: 'Booking Plan',
    subtitle: 'Weekly hotel room occupancy overview',
    week: 'Week',
    selectWeek: 'Select week',
    previousWeek: 'Previous week',
    nextWeek: 'Next week',
    thisWeek: 'This Week',
    goToCurrentWeek: 'Go to current week',
    event: 'Event',
    loadingData: 'Loading booking data...',
    noEvents: 'No Events This Week',
    noEventsDescription: 'There are no hotel room bookings for the selected week',
    free: 'Free',
    freeCapacity: 'Free Capacity (Bed Pool)',
    occupiedCapacity: 'Actually Occupied Capacity',
    totalCapacity: 'Available Capacity',
    of: 'of',
    anreise: 'Arrival (ABN)',
    abreise: 'Departure (ANN)',
    calendarTitle: 'Blocks & Reservations Calendar',
    sollBlocked: 'SOLL (Blocked)',
    istReserved: 'IST (Reserved)',
    status: 'Status',
    availabilityAdjustments: 'Availability Adjustments',
    unitCount: 'Unit Count',
    rooms: 'rooms',
    period: 'Period',
    reservations: 'Reservations',
    customer: 'Customer',
    state: 'State',
    email: 'Email',
    loadingCustomers: 'Loading customer details...',
    total: 'Total',
    openInMews: 'Open in MEWS Commander',
  },
  analytics: {
    title: 'Analytics',
    subtitle: 'Event performance and insights',
    eventsByStreamStatus: 'Events by Stream and Status',
    eventsByStreamStatusDesc: 'Number of events grouped by stream and status',
    loadingData: 'Loading analytics data...',
    eventStream: 'Event Stream',
    numberOfEvents: 'Number of Events',
    events: 'events',
    total: 'Total',
    noData: 'No data available',
    noDataDesc: 'Event data will appear here once loaded',
    monthlyTrend: 'Monthly Event Trend',
    monthlyTrendDesc: 'Number of events per month over time',
    hotelTimeline: 'Participants & Blocked Rooms Over Time',
    hotelTimelineDesc: 'Reservations and blocked rooms per month',
    participants: 'Participants',
    blockedRooms: 'Blocked Rooms',
    totalRoomsCapacity: 'Room capacity',
    allStatuses: 'All statuses',
    allGuestTypes: 'All guests',
    hotelGuests: 'Hotel guests',
    dayGuests: 'Day guests',
    statusDistribution: 'Status Distribution',
    statusDistributionDesc: 'Breakdown of events by current status',
    eventHeatmap: 'Event Density',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    month: 'Month',
    year: 'Year',
    allTime: 'All',
    allYears: 'all years',
    loadError: 'Failed to load analytics data',
  },
  stockManagement: {
    title: 'Stock Management',
    subtitle: 'Inventory overview and stock alerts',
    refresh: 'Refresh',
    loading: 'Loading stock data...',
    totalValue: 'Total Stock Value',
    totalProducts: 'Stockable Products',
    lowStockProducts: 'Low Stock',
    outOfStockProducts: 'Out of Stock',
    inventoryOverview: 'Inventory Overview',
    stockByCategory: 'Stock status by product category',
    recentActivity: 'Recent Activity',
    units: 'units',
    noMovements: 'No recent stock movements',
    lowStockAlert: 'Low Stock Alerts',
    items: 'items',
    productName: 'Product',
    category: 'Category',
    stock: 'Stock',
    minimum: 'Min. Level',
    status: 'Status',
    outOfStock: 'Out of Stock',
    low: 'Low',
    healthy: 'Healthy',
    allStockHealthy: 'All stock levels are healthy',
    allStock: 'All Stock',
    searchProducts: 'Search products...',
    onHand: 'On Hand',
    reserved: 'Reserved',
    noProducts: 'No products found',
    noData: 'No stock data available',
    noDataDesc: 'Stock data will appear here once products are added',
    uncategorized: 'Uncategorized',
    available: 'available',
    availableCol: 'Available',
    overbooked: 'Overbooked',
    viewWeek: 'Week',
    viewMonth: 'Month',
    viewQuarter: 'Quarter',
    today: 'Today',
    movReserved: 'Reserved for Event',
    movReleased: 'Released from Event',
    movAdjusted: 'Quantity Adjusted',
    movIn: 'Stock In',
    movOut: 'Stock Out',
    stockOverTime: 'Stock Levels Over Time',
    stockOverTimeDesc: 'Product stock quantities in selected period',
    last7d: '7 Days',
    last30d: '30 Days',
    last90d: '90 Days',
    allTime: 'All',
    settings: 'Settings',
    settingsTitle: 'Stock Settings',
    settingsSubtitle: 'Configure stockable products and inventory locations',
    stockable: 'Stockable',
    filterAll: 'All',
    filterStockable: 'Stockable',
    filterNotStockable: 'Not Stockable',
    noLocations: 'No stock locations configured yet. Add one to start tracking.',
    location: 'Location',
    floor: 'Floor (Building)',
    selectFloor: 'Select floor',
    quantityOnHand: 'Qty On Hand',
    minLevel: 'Min. Level',
    addLocation: 'Add Location',
    enableStockableHint: 'Enable the stockable toggle to configure inventory locations for this product.',
    productsShown: 'products shown',
    modeGlobal: 'Global',
    modeBuilding: 'Per Building',
    modeFloor: 'Per Floor',
    modeGlobalDesc: 'Single stock quantity shared across all locations.',
    modeBuildingDesc: 'Separate stock quantity per building.',
    modeFloorDesc: 'Separate stock quantity per floor, grouped by building.',
  },
  valid: {
    filterAll: 'All (validity)',
    filterLabel: 'Validity',
    notValidShort: 'Not valid',
    since: 'since {date}',
    confirmSetBodySession: 'This session is fully prepared? It is shown as valid to everyone (for multi-day sessions: every day).',
    confirmUnsetBodySession: 'Mark the session as not valid again?',
    isValid: 'Valid',
    notValid: 'Not valid yet',
    byAt: 'Set valid by {who} on {when}',
    confirmSetTitle: 'Mark as valid',
    confirmUnsetTitle: 'Withdraw valid',
    confirmSetBody: 'Your work on this event is done? The event is shown as valid to everyone.',
    confirmUnsetBody: 'Mark the event as not valid again?',
    setAction: 'Set valid',
    unsetAction: 'Withdraw',
    noPermission: 'Only roles with the “Events ▸ Mark as Valid” permission for this event’s stream can set this.',
    saveFailed: 'Could not be saved.',
    historyTitle: 'History: valid',
    historyEmpty: 'Never set.',
    historySet: 'Set valid',
    historyUnset: 'Valid withdrawn',
  },
  businessSchool: {
    title: 'Business School',
    year: 'Year',
    subtitle: 'Events and students of the ADG Business School',
    loading: 'Loading Business School data…',
    loadFailed: 'Data could not be loaded.',
    quarter: 'Quarter',
    kpiEvents: 'Events',
    kpiEventsSub: '{l} lectures · {e} exams',
    kpiStudents: 'Students',
    kpiStudentsSub: '+ {n} lecturer slots',
    kpiRegistrations: 'Registrations',
    kpiPerEvent: 'Ø {n} per event',
    kpiUtilisation: 'Utilisation',
    kpiUtilSub: '{r} of {c} seats',
    kpiHotel: 'With overnight stay',
    kpiHotelSub: '{h} hotel · {d} day guest',
    tabEvents: 'Events',
    tabStudents: 'Students',
    tabProgrammes: 'Programmes',
    searchModules: 'Search module or number…',
    searchStudents: 'Name, e-mail or employer…',
    programme: 'Programme',
    allProgrammes: 'All programmes',
    semester: 'Semester',
    allSemesters: 'All semesters',
    semesterN: 'Semester {n}',
    semesterShort: 'Sem. {n}',
    kindAll: 'All',
    kindLectures: 'Lectures',
    kindExams: 'Exams',
    upcomingOnly: 'Upcoming only',
    noEvents: 'No events in this period',
    noEventsHint: 'Change the period or filters.',
    noStudents: 'No students found',
    exam: 'Exam',
    hybrid: 'hybrid',
    utilTitle: 'Students / max. participants',
    studentsShort: 'Stud.',
    hotelDay: '{h} hotel · {d} day',
    student: 'Student',
    employer: 'Employer',
    modules: 'Modules',
    nextDate: 'Next date',
    studentCount: '{count} student | {count} students',
    noProgramme: 'No programme',
    eventsShort: 'Dates',
    examsShort: 'Exams',
    nextOn: 'Next date: {date}',
    noUpcoming: 'No upcoming date',
  },
  eventRelease: {
    more: '{n} more in Hotel Optimisation',
    search: 'Search event or number…',
    count: '{count} event | {count} events',
    loading: 'Loading releases…',
    emptyTitle: 'No open releases',
    emptyHint: 'Every event is fully released.',
    sideAll: 'All',
    sideHotel: 'Hotel',
    sideRooms: 'Rooms',
    sideSessions: 'Sessions',
    hotelOpen: 'Hotel: {b} blocks · {r} rooms',
    hotelDone: 'Hotel ok',
    roomsOpen: '{count} room open | {count} rooms open',
    roomsDone: 'Rooms ok',
    sessionsOpen: '{count} session without room | {count} sessions without room',
    sessionsDone: 'Sessions ok',
    ready: 'Ready',
    openTotal: '{count} open',
    openEvent: 'Open event',
    today: 'today',
    inDays: 'in {n} d',
  },
  myEvents: {
    countValid: '{n}/{total} signed off',
    countValidSessions: '{n}/{total} sessions signed off',
    personMe: 'My events',
    personSearch: 'Search name or email…',
    personNoMatch: 'No matches',
    viewingOther: 'Events of {name}',
    backToMine: 'Back to mine',
    showSessions: 'Show sessions',
    sessionsLoading: 'Loading sessions…',
    noSessions: 'No sessions',
    sessionUnnamed: 'Unnamed',
    roleAll: 'All',
    rolePm: 'PM',
    roleEm: 'EM',
    rolePmLong: 'Product manager',
    roleEmLong: 'Event manager',
    showCancelled: 'Show cancelled',
    matchedAs: 'Matched via {local} —',
    loading: 'Loading your events…',
    noEmailTitle: 'Your e-mail is unknown',
    noEmailHint: 'Without an e-mail on your user profile we cannot match you to a contact.',
    noPartyTitle: 'No contact found for {local}',
    noPartyHint: "Events are matched via the product or event manager contact. Create yourself as a contact (same part before the {'@'}) and set yourself on the event.",
    countEvents: '{count} event | {count} events',
    countPax: '{n} participants',
    countRunning: '{n} running',
    emptyTitle: 'No events in this period',
    emptyHint: 'Change the period or filter.',
    running: 'Running',
    paxShort: 'pax',
    paxTitle: 'Max. participants',
  },
  availabilityPicker: {
    loading: 'MEWS loading…',
    unknown: 'not loaded',
    loadingLong: 'Loading availability from MEWS — figures follow shortly.',
    unknownLong: 'Availability could not be loaded from MEWS.',
  },
  contactPicker: {
    sectionOptional: 'More details (optional)',
    sectionPersonal: 'Personal',
    sectionNames: 'Legal / contractual name & contact person',
    new: 'New',
    createSubtitle: 'Created directly in MEWS, then selected.',
    createTitleCustomer: 'New customer',
    createTitleCompany: 'New company',
    createFromSearchCustomer: 'Create “{q}” as a new customer',
    createFromSearchCompany: 'Create “{q}” as a new company',
    invoiceableNotApplied: 'Customer created \u2014 but the Debitor (invoiceable) flag was NOT set in MEWS. Please set it there on the customer profile.',
    countryOther: 'Other \u2014 enter code\u2026',
    requiredForInvoicing: 'required for a Debitor',
    invoiceableOffHint: 'Without this the customer cannot be invoiced \u2014 it has to be set in MEWS afterwards.',
    titleCustomer: 'Select Contact',
    subtitleCustomer: 'Search MEWS contacts by name or email',
    titleCompany: 'Select Company',
    subtitleCompany: 'Search MEWS companies by name',
    customers: 'Customers',
    companies: 'Companies',
    searchCustomers: 'Search by name or email...',
    searchCompanies: 'Search by company name...',
    search: 'Search',
    searching: 'Searching...',
    loadingRecent: 'Loading recent entries...',
    noResults: 'No results found. Try a different search.',
    noData: 'No data available.',
    results: 'results',
    cancel: 'Cancel',
    newCustomer: 'Add Contact',
    newCompany: 'New Company',
    createCustomer: 'Create Customer',
    createCompany: 'Create Company',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    companyName: 'Company Name',
    contactPerson: 'Contact Person',
    contact: 'Contact (Email/Phone)',
    creating: 'Creating...',
    created: 'Created successfully',
    createError: 'Error creating entry',
    backToList: 'Back to list',
    required: 'Required',
    sectionIdentity: 'Identity',
    sectionContact: 'Contact',
    sectionAddress: 'Address',
    sectionBusiness: 'Business',
    sectionIdCard: 'Identity Card',
    sectionOptions: 'Options & Notes',
    sectionNotes: 'Notes',
    secondLastName: 'Second Last Name',
    title: 'Title',
    titleMister: 'Mister',
    titleMisses: 'Misses',
    titleMiss: 'Miss',
    sex: 'Sex',
    sexMale: 'Male',
    sexFemale: 'Female',
    sexOther: 'Other',
    birthDate: 'Birth Date',
    nationalityCode: 'Nationality (ISO-2)',
    languageCode: 'Language (ISO-2)',
    addrLine1: 'Street',
    addrLine2: 'Address Line 2',
    addrPostalCode: 'Postal Code',
    addrCity: 'City',
    addrCountryCode: 'Country (ISO-2)',
    addrStateCode: 'State / Region',
    loyaltyCode: 'Loyalty Code',
    taxIdentifier: 'Tax ID',
    billingCode: 'Billing Code',
    idNumber: 'ID Number',
    idType: 'ID Type',
    idIssuance: 'Issued On',
    idExpiration: 'Expires On',
    sendMarketingEmails: 'Send marketing emails',
    sendBillsByEmail: 'Send bills and documents by email',
    invoiceable: 'Create as accounts-receivable (invoiceable)',
    invoiceableHint: 'Required: name, e-mail and full address incl. country code.',
    notes: 'Notes',
    telephone: 'Telephone',
    legalName: 'Legal Name',
    contractualName: 'Contractual Name',
    contactPersonEmail: 'Contact Person Email',
    contactPersonTelephone: 'Contact Person Telephone',
    additionalTaxIdentifier: 'Additional Tax ID',
    accountingCode: 'Accounting Code',
    iata: 'IATA Number',
    degreeOfTrust: 'Degree of Trust',
  },
  // Reduction protection ("do not reduce") — its own section because the badge
  // and the toggle appear both on the hotel-optimisation page and in the event
  // hotel tab. One shared section stops the same sentence being translated
  // twice and drifting apart.
  reductionProtection: {
    badge: 'Do not reduce',
    badgeShort: 'Protected',
    tooltipPlain: 'Rooms on this event must not be released.',
    tooltipBy: 'Set by {by}',
    tooltipAt: 'on {at}',
    tooltipReason: 'Reason: {reason}',
    toggleOn: 'Enable reduction protection',
    toggleOff: 'Remove reduction protection',
    modalTitleOn: 'Protect rooms from release',
    modalTitleOff: 'Remove reduction protection',
    modalBodyOn: 'While protection is on, every release and shrink action refuses this event. Growing it and changing its dates stay possible.',
    modalBodyOff: 'Once removed, this event can be shrunk again and will rejoin bulk release.',
    reasonLabel: 'Reason (optional)',
    reasonPlaceholder: 'e.g. group firmly confirmed',
    confirmOn: 'Enable protection',
    confirmOff: 'Remove protection',
    successOn: 'Reduction protection enabled.',
    successOff: 'Reduction protection removed.',
    failed: 'Could not change reduction protection.',
    blockedTitle: 'Release not possible',
    blockedBody: 'This event is marked "do not reduce". Remove the reduction protection first.',
    excludedFromBulk: 'Protected events are excluded from bulk release.',
    notSelectable: 'Protected — not selectable',
  },
  revenueManagement: {
    title: 'Revenue Management',
    subtitle: 'Pace, pickup-based forecast and the money sitting in unsold blocks.',
    tabPace: 'Pace & pickup',
    tabForecast: 'Forecast',
    tabBlocks: 'Block value',
    refresh: 'Refresh',
    retry: 'Retry',
    loading: 'Loading revenue data…',
    loadFailed: 'Could not load revenue data.',
    loadFailedHint: 'Check your connection and try again — this is not an empty period.',
    daysShort: 'd',
    nights: 'nights',
    nightsShort: 'N',
    roomNightsShort: 'RN',
    staysWord: 'stays',
    blocksWord: 'Blocks',
    todayLabel: 'today',
    vsStly: 'vs LY',
    noData: 'No room nights in this window.',
    noForecast: 'Nothing to forecast in this window.',
    noBlocks: 'No upcoming blocks hold unsold rooms. Nothing to reclaim.',
    noCapacity: 'room count unavailable',
    sourceLabel: 'Revenue source',
    sourceNote: 'Past nights use revenue actually posted in MEWS (order items by consumption date). Future nights are derived from achieved ADR × rooms on the books — a model, not a booking.',
    revenueLoading: 'loading posted revenue from MEWS…',
    revenueUnavailable: 'MEWS revenue is unavailable right now — € figures for past nights are missing, room counts are unaffected.',
    orderItems: 'order items',
    derivedItalicNote: 'Grey italic revenue is derived, not posted.',
    kpiRoomNights: 'Room nights',
    kpiOccupancy: 'Occupancy',
    kpiAdr: 'ADR',
    kpiRevpar: 'RevPAR',
    kpiTrevpar: 'TrevPAR',
    kpiTrevparHint: 'rooms + F&B + other',
    kpiAtRisk: 'Held, unsold',
    occupancyTitle: 'Occupancy per night vs last year',
    occupancyDesc: 'Rooms on the books ÷ sellable rooms. Last year is the same nights 364 days earlier, so weekdays line up.',
    rateTitle: 'ADR and RevPAR per night',
    rateDesc: 'Both in €, so they share one axis. Up to today from posted MEWS revenue; after today derived from achieved ADR.',
    pickupTitle: 'How far ahead people book',
    pickupDesc: 'Room nights in the window by how many days before arrival they were booked. This curve is what the forecast extrapolates.',
    leadDaysAxis: 'Days booked before arrival',
    monthTableTitle: 'By month',
    monthTableDesc: 'Room nights and occupancy against the same month last year. The table view of the chart above.',
    methodLabel: 'Method',
    methodNote: 'Rooms on the books are grown by how much the books historically still grew from the same lead time, plus the share of block holds that history says converts',
    methodCap: 'Capped at sellable rooms. The band is the spread of the historical ratios — not a confidence interval.',
    methodHistory: 'History',
    forecastTitle: 'Forecast rooms per night',
    forecastDesc: 'On the books today against the expected final pickup. The grey line is sellable rooms.',
    forecastTableTitle: 'Forecast by month',
    forecastTableDesc: 'Sample size is how many historical stay dates the month’s pickup ratio rests on — a low number means a weak forecast.',
    capacityLabel: 'sellable rooms',
    adrBasis: 'ADR basis',
    basisAchieved: 'achieved, MEWS',
    basisPriceList: 'price list',
    atRiskTotal: 'Value at risk',
    unsoldNights: 'Unsold room nights',
    displacing: 'On tight nights',
    displacingHint: 'holds over 85% occupancy',
    blockValueTitle: 'What the unsold holds are worth',
    blockValueDesc: 'Rooms a block still holds unsold, priced at its own rate. “Picked up” is out of the original request. Biggest money first.',
    blockPriceNote: '€/night is the block’s room type at its own rate from the price lists. “—” means that combination is not priced; the achieved ADR is used instead.',
    releaseThem: 'Release them in Hotel Optimisation →',
    colMonth: 'Month',
    colRoomNights: 'Room nights',
    colLastYear: 'Last year',
    colOccupancy: 'Occupancy',
    colRevenue: 'Revenue',
    colOtb: 'On the books',
    colForecast: 'Forecast',
    colBand: 'Band',
    colForecastRevenue: 'Forecast revenue',
    colSample: 'Sample',
    colEvent: 'Event',
    colDates: 'Dates',
    colStillHeld: 'Still held',
    colPickedUp: 'Picked up',
    colUnsoldRn: 'Unsold RN',
    colPricePerNight: '€/night',
    colAtRisk: 'At risk',
    colInDays: 'In',
    colPeakOcc: 'Peak occ.',
    seriesThisYear: 'This year',
    seriesLastYear: 'Last year',
    seriesAdr: 'ADR',
    seriesRevpar: 'RevPAR',
    seriesRoomNights: 'Room nights',
    seriesOtb: 'On the books',
    seriesForecast: 'Forecast',
    seriesBandHigh: 'Band high',
    seriesBandLow: 'Band low',
  },
  hotelOptimisation: {
    bulkNoPermission: 'No permission: block management (edit) required',
    title: 'Hotel Optimisation',
    subtitle: 'Reclaim blocked rooms before they go to waste — bulk-release across upcoming events.',
    tabActions: 'Actions',
    tabRelease: 'Hotel release',
    tabSpaceConfirmations: 'Room release',
    tabEventRelease: 'Event release',
    tabForecast: 'Forecast',
    loadFailed: 'Could not load hotel optimisation data.',
    loadFailedHint: 'Check your connection and try again — this is not an empty list.',
    releaseTitle: 'Pending release requests',
    releaseDesc: 'Hotel approval is required before these blocks are created in MEWS. Earliest event first.',
    releaseEmpty: 'No pending release requests.',
    releaseRequested: 'Requested',
    releaseAvailable: 'Available',
    releaseMinAcrossNights: 'min across nights',
    releasePossible: 'Possible',
    releaseNotPossible: 'Over capacity',
    releaseUnknown: 'Unknown',
    releaseRequestSingular: 'request',
    releaseRequestPlural: 'requests',
    releaseApprove: 'Approve',
    releaseReject: 'Reject',
    releaseResize: 'Resize',
    releaseChangeType: 'Change type',
    releaseTooltipOverCap: 'Not enough rooms available — resize or reject',
    releaseTooltipOverCapWarn: 'This category looks over capacity — MEWS may refuse. Resize or change type, or approve to let MEWS decide.',
    releaseResizeOverWarn: 'More than the free rooms shown for this category — MEWS may refuse the block. You can still save.',
    releaseTypeOverWarn: 'This category does not have enough free rooms for the whole block — MEWS may refuse. You can still save.',
    releaseFreeShort: 'free',
    releaseRoomsShort: 'rooms',
    releaseResizeTitle: 'Reduce the number of rooms',
    releaseResizeModalTitle: 'Resize requested block',
    releaseResizeLabel: 'New room count',
    releaseTypeTitle: 'Switch the room category',
    releaseTypeModalTitle: 'Change room category',
    releaseTypeIntro: 'The new category is recorded on the requested block. MEWS will use it when the block is approved.',
    releaseTypeLabel: 'Room category',
    releaseRejectTitle: 'Reject release request',
    forecastTitle: 'Blocks vs Pickups Forecast',
    forecastDesc: 'Confirmed blocks (indigo) · Pickups (green) · Confirmed + pending (grey dashed). Red appears only when totals exceed hotel capacity. Bars = events active that day.',
    kpiPeakBlocked: 'Peak blocked',
    kpiBlockedNights: 'Total room-nights blocked',
    kpiSpreadNights: 'Spread (open)',
    kpiSpreadNote: 'unfilled room-nights',
    kpiUtilisation: 'Utilisation',
    kpiUtilisationNote: 'pickups ÷ blocked',
    barVolumeLabel: 'Events per day',
    totalShort: 'total',
    roomCapacity: 'Hotel capacity',
    dayBreakdownEventsShort: 'events',
    dayBreakdownBlocksShort: 'blocked rooms',
    dayBreakdownReservationsShort: 'reservations',
    dayBreakdownBlocks: 'Rooms blocked',
    dayBreakdownReservations: 'Reservations',
    dayBreakdownEmpty: 'No events match this day.',
    roomsReleasable: 'releasable',
    roomsSuggested: 'suggested',
    roomsHeld: 'held',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    selectedEventsLabel: 'events selected',
    bulkReleaseLabel: 'Release rooms ({n})',
    bulkProposeLabel: 'Apply −50% ({n})',
    bulkRightSizeLabel: 'Right-size to pickups ({n})',
    bulkTitleRelease: 'Release unused rooms',
    bulkTitlePropose: 'Apply −50% reduction',
    bulkTitleRightSize: 'Right-size to actual pickups',
    bulkSubtitle: 'Block room count is reduced — existing pickups are preserved.',
    bulkSummaryEvents: 'Events affected',
    bulkSummaryRooms: 'Rooms released',
    bulkPreviewTitle: 'What will change',
    bulkPreviewNote: 'Block room count: before → after',
    bulkPreviewSkip: 'nothing to release',
    // MEWS-verified release (EH-0039 part 2)
    bulkVerifying: 'Checking available rooms in MEWS…',
    bulkVerifyingNote: 'The release is calculated against what MEWS actually holds, not against our copy.',
    bulkVerifyFailed: 'Verification against MEWS failed',
    bulkVerifyFailedNote: 'Nothing was changed. Without a confirmed MEWS figure no release is offered — please try again later.',
    bulkSkipPartial: 'not verifiable in MEWS',
    bulkSkipNoBlocks: 'no active block',
    bulkSkipUnverified: 'not verified',
    bulkSkipVerifyFailed: 'MEWS not reachable',
    bulkPreviewDrift: 'DB differed',
    bulkHeadsUpVerified: 'Figures come from MEWS, not from our copy. Events that cannot be verified are skipped.',
    bulkPreviewRelease: 'release',
    bulkHeadsUpTitle: 'Heads up',
    bulkHeadsUpMews: 'MEWS is updated first — DB only persists if MEWS accepts.',
    bulkHeadsUpRev: 'Existing pickups are preserved. Only the unused capacity is released.',
    bulkHeadsUpRetry: 'Failures are listed at the end — you can retry just the failed ones.',
    bulkConfirm: 'Confirm release',
    bulkRunning: 'Releasing… {done}/{total}',
    bulkResultSuccessTitle: 'Rooms released',
    bulkResultPartialTitle: 'Completed with errors',
    bulkResultOk: 'succeeded',
    bulkResultFailed: 'failed',
    bulkResultRooms: 'rooms total',
    bulkResultFailureLabel: 'These events failed:',
    bulkResultAllOk: 'Every selected event was right-sized successfully.',
    roomsShort: 'rooms',
    historyButton: 'Shrink history',
    historyTooltip: 'Show last 50 shrink operations',
    historyTitle: 'Shrink history',
    historySubtitle: 'Last 50 bulk-resize operations, newest first.',
    historyEmpty: 'No bulk-resize operations yet.',
    historyEntries: 'entries',
    historyOpenEvent: 'Open event',
    justNow: 'just now',
    errMewsVerifyShort: 'MEWS silently rejected the reduction.',
    errMewsVerifyHint: 'Likely would orphan existing reservations — try smaller steps or inspect the block manually.',
    errMews5xxShort: 'MEWS server error (5xx).',
    errMews5xxHint: 'Temporary MEWS issue — try again in a few minutes.',
    errMewsRejectShort: 'MEWS rejected the change.',
    errSystemShort: 'Unknown error.',
    errShowDetails: 'Details',
    errHideDetails: 'Hide details',
    alreadyOptimised: 'Already optimised',
  },
  noShow: {
    settleOpen: 'Settle…',
    confirmNoShowTitle: 'Settle no-show',
    confirmStornoTitle: 'Settle cancellation',
    settled: 'Products settled (no-show)',
    noShowScope: 'Our products only — the reservation stays in MEWS.',
    stornoScope: 'With fee: products by the cancellation rule + room storno in MEWS. Without: no fee, all products cancelled.',
    stornoWithFee: 'Cancel with fee',
    stornoWithoutFee: 'Cancel without fee',
    saveFailed: 'Decision not saved',
    previewCharge: 'Show fee',
    nothingToCharge: 'No products to charge',
    chargeWillBeRefused: 'Will be refused: storno / no-show products missing in Administration, or a line has no price',
    chargeNoShow: 'Charge no-show (products only)',
    chargeStorno: 'Charge storno & cancel',
    cancelReasonNoShow: 'No-show',
    cancelReasonStorno: 'Storno (no-show board)',
    intro: 'Participants whose arrival day has passed but who did not show up (neither checked in nor cancelled in MEWS). Decide per participant: no-show or cancellation — then review and charge the fee (the products are charged first, then the stay is cancelled).',
    loading: 'Loading participants and MEWS state…',
    empty: 'No open no-shows in this period.',
    future: 'This period is in the future — no-shows only exist after the arrival day.',
    mewsUnchecked: 'MEWS could not be read — the list may include guests who already checked in.',
    notChecked: 'not checked',
    notCheckedHint: 'No MEWS state — no MEWS reservation or MEWS unreachable',
    colGuest: 'Participant', colEvent: 'Event', colType: 'Type', colStay: 'Stay', colMews: 'MEWS', colDecision: 'Decision',
    typeHotel: 'Hotel', typeDayguest: 'Day guest', typeLecturer: 'Lecturer',
    decideNoShow: 'No-show', decideNoShowHint: 'Mark as no-show',
    decideStorno: 'Cancel', decideStornoHint: 'Mark as cancellation',
    withdraw: 'Withdraw decision',
    filterOpen: 'Open', filterAll: 'All',
    you: 'You',
  },
  conflictResolution: {
    tabNoShow: 'No-show',
    title: 'Conflict Board',
    subtitle: 'Detect and resolve data issues across events',
    conflicts: 'conflicts',
    type: 'Type',
    refresh: 'Refresh',
    tabConflicts: 'Conflicts',
    tabWasting: 'Room Wasting',
    tabHotelOptimisation: 'Hotel Optimisation',
    scopeAllUpcoming: 'All upcoming events',
    eventCount: 'Events',
    roomsShort: 'rooms',
    roomsReleasableTitle: 'Total rooms that can be released immediately',
    roomsSuggestedTitle: 'Total rooms suggested for release across these events',
    roomsAtRiskTitle: 'Total rooms held across these small-group events',
    optList1Title: 'Release now',
    optList1Desc: 'Starting within 30 days · ranked by rooms not picked up',
    optList1Empty: 'No imminent over-blocks to release.',
    optList2Title: 'Propose −50%',
    optList2Desc: '31–60 days out · suggest cutting open rooms by half',
    optList2Empty: 'No mid-range over-blocks to reduce.',
    optList3Title: 'Small groups',
    optList3Desc: 'Starting within 90 days · fewer than 7 confirmed pickups',
    optList3Empty: 'No small groups in the next 90 days.',
    notPickedUp: 'Open',
    suggestRelease: 'Release',
    pickups: 'Pickups',
    wastingTitle: 'Room Wasting Leaderboard',
    wastingDesc: 'Ranked by wasted nights × urgency. Closer events with bigger over-blocks lead.',
    noWasting: 'No room wasting detected',
    noWastingDesc: 'Every upcoming event\'s blocked rooms match its participant count.',
    blocked: 'Blocked',
    actual: 'Actual',
    spread: 'Spread',
    days: 'Days',
    wastedRoomNights: 'Wasted nights',
    wastedRoomNightsTooltip: 'Unsold rooms × event duration',
    totalRoomNights: 'Total nights',
    totalRoomNightsTooltip: 'Blocked × event duration — total inventory the event is holding',
    today: 'today',
    inOneDay: 'in 1 day',
    inNDays: 'in {n} days',
    loading: 'Scanning for conflicts...',
    noConflicts: 'No conflicts detected',
    noConflictsDesc: 'All events and sessions look good.',
    periodPast: 'This period is already over',
    periodPastDesc: 'The board only shows ongoing and upcoming events — a finished one can no longer be fixed.',
    pastEvents: 'Past',
    pastShow: 'Also show events that have finished',
    pastHide: 'Show only ongoing and upcoming events',
    triggerNoSpace: 'No room',
    triggerNoSpaceSession: 'No room (session)',
    triggerHotelBlockMissing: 'Hotel block missing',
    triggerHotelBlockDifference: 'Hotel block difference',
    triggerRoomTooSmall: 'Room too small',
    triggerRoomTypeMismatch: 'Room type ≠ guest wish',
    triggerHotelBlockError: 'Hotel block error',
    triggerChargeError: 'Charge error',
    triggerChargeNoOrder: 'Charged with no MEWS order',
    triggerInternalCharged: 'Internal, charged anyway',
    triggerParticipantError: 'Participant error',
    triggerParticipantNoCapacity: 'Participant no capacity',
    triggerUnlinkedFollowup: 'Follow-up not linked',
    triggerInvoiceOwner: 'Invoice owner not applied',
    free: 'free',
    descEventNoSpace: 'This event has no space booking assigned.',
    descSessionNoSpace: 'Session in {event} has no space booking.',
    descNoOvernightGuests: '{maxPax} participants but 0 overnight guests configured.',
    descNoBlock: '{overnight} overnight guests but no PMS room block reserved.',
    descBlockMismatch: '{overnight} overnight guests but {blocked} rooms blocked.',
  },
  fnbEquipment: {
    pmsCharged: 'PMS items',
    pmsChargedHint: 'Charged in the PMS but not sent by EventHub: the till, reception, a guest\'s own breakfast. Counts towards Pax while this view is on.',
    pmsChargedTitle: 'Charged in the PMS (not by EventHub)',
    pmsOnlyFilter: 'PMS only',
    printWithPms: 'PMS items',
    printPmsHint: 'Also print the items already charged in the PMS. Off by default: the kitchen sheet shows demand only, not what is already billed.',
    pmsToggle: 'PMS',
    collapseAll: 'Collapse all',
    expandAll: 'Expand all',
    pmsChargedEmpty: 'The PMS holds no foreign items for this period.',
    pmsChargedAmount: 'Amount',
    pmsLoading: 'Loading PMS items from MEWS …',
    pmsLoadingDay: 'One day — usually a few seconds.',
    pmsLoadingWeek: 'Seven days — this can take half a minute.',
    pmsNoQuantity: 'The PMS gives no reliable quantity for this line — the count exists only inside the billing text.',
    originPms: 'PMS product',
    originExternal: 'Till / external',
    fromPms: 'from PMS',
    title: 'F&B / Equipment',
    subtitle: 'Daily overview for kitchen, IT and housekeeping',
    events: 'events',
    pax: 'to cater for',
    paxHint: 'People catered for on this day, per the configured products and packages',
    uncharged: 'not charged',
    unchargedHide: 'Show only charged lines — as the reporting API sees them',
    chargedOnly: 'Charged only',
    unchargedShow: 'Show lines that are not charged yet',
    allCategories: 'All',
    fnb: 'F&B',
    equipment: 'Equipment',
    service: 'Service',
    other: 'Other',
    products: 'products',
    product: 'Product',
    quantity: 'Quantity',
    noProducts: 'No products on this day',
    noProductsHint: 'Pick a different day or add products to events.',
    total: 'Total',
    preview: 'Preview',
    exportPdf: 'Export PDF',
    thisWeek: 'This week',
    productsTab: 'Products & equipment',
    lunchTab: 'Lunch sittings',
    lunchShowEvents: 'Show events',
    lunchSitting: 'Lunch sitting',
    lunchUnset: 'Not set',
    lunchAtTime: '{time}',
    lunchEmpty: 'No lunch guests this week',
    lunchHint: 'Confirmed guests per day, grouped by each event\'s lunch sitting.',
  },
  auditLog: {
    viewLog: 'Log',
    viewActivity: 'Activity per user',
    activity: {
      week: 'Week', month: 'Month', quarter: 'Quarter',
      searchUser: 'Search users…', usersLabel: 'users',
      kpiActiveUsers: 'Active users', kpiChanges: 'Changes', kpiPerUser: 'Avg. per active user', kpiBusiest: 'Busiest',
      changesShort: 'changes', noPrev: 'no previous period', vsPrev: 'vs. previous period',
      user: 'User', activeDays: 'Active days', activeDaysHint: 'Days with at least one change in the current period',
      mix: 'Kind (current)', mostlyOn: 'Mostly on', lastActive: 'Last active',
      empty: 'No activity in this period',
      footnote: 'Counts audit-log entries (one change = one entry). System changes without a user are not included.',
    },
    title: 'Audit Log',
    subtitle: 'Track all changes and actions across the system',
    entries: 'entries',
    refresh: 'Refresh',
    searchPlaceholder: 'Search logs...',
    allTypes: 'All',
    allActions: 'All Actions',
    allUsers: 'All Users',
    actionCreate: 'Created',
    actionUpdate: 'Updated',
    actionDelete: 'Deleted',
    reset: 'Reset',
    loading: 'Loading audit logs...',
    noEntries: 'No audit log entries found.',
    dateRange: 'Select date range',
  },
  errorLog: {
    title: 'Error Log',
    subtitle: 'Monitor system errors, warnings and issues',
    entries: 'entries',
    refresh: 'Refresh',
    searchPlaceholder: 'Search errors...',
    allTypes: 'All',
    allSeverities: 'All Severities',
    allSources: 'All Sources',
    allStatuses: 'All Statuses',
    resolved: 'Resolved',
    unresolved: 'Unresolved',
    markResolved: 'Mark Resolved',
    markUnresolved: 'Reopen',
    reset: 'Reset',
    loading: 'Loading error logs...',
    noEntries: 'No error log entries found.',
    loadFailed: 'The query failed — this is NOT an all-clear.',
    dateRange: 'Select date range',
  },
  miceBoard: {
    showTerminal: 'Lost & cancelled',
    showTerminalHint: 'Show lost and cancelled events as their own columns',
    searchAllEvents: 'Search all events…',
    statPipelineValue: 'Pipeline value',
    statWithEstimate: '{n} of {total} with estimate',
    statWeighted: 'Weighted forecast',
    statWeightedSub: 'by stage',
    statWeightedHint: 'Estimate × stage win probability: Inquiry 10 %, Qualify 25 %, Proposal 50 %, Tentative 75 %, Definite 100 %',
    statThisMonth: 'Events this month',
    statLostCancelled: 'Lost / Cancelled',
    paxN: '{n} pax',
    roomsN: '{n} rooms',
    daysN: '{n} days',
    staleHint: '{n} days since last change',
    live: 'Live',
    liveHint: 'Happening now',
    pastLabel: 'Past',
    addRevenue: '+ Revenue',
    dropHere: 'Drop here',
    moreActions: 'More actions',
    openEvent: 'Open event',
    showPast: 'Show past',
    hidePast: 'Hide past',
    pastShown: 'Past visible',
    pastHidden: 'Current only',
    addEstimateHint: 'Add expected revenue',
    title: 'MICE Board',
    subtitle: 'Sales pipeline, funnel, and performance metrics',
    createInquiryTitle: 'New MICE Inquiry',
    loading: 'Loading MICE Board data...',
    allStreams: 'All Streams',
    allSales: 'All Salespersons',
    refresh: 'Refresh',
    today: 'Today',
    yearView: 'Year',
    totalEvents: 'Total Events',
    activePipeline: 'Active Pipeline',
    confirmed: 'Confirmed',
    conversionRate: 'Conversion Rate',
    lost: 'Lost',
    cancelledKpi: 'Cancelled',
    avgDaysToClose: 'Avg Days to Close',
    staleEvents: 'Stale Events',
    inDateRange: 'in date range',
    inquiries: 'inquiries',
    tentatives: 'tentatives',
    proposals: 'proposals',
    closedLost: 'closed-lost',
    cancelledEvents: 'cancelled events',
    fromInquiry: 'from inquiry to definite',
    noActivityHint: 'no update in 7+ days',
    salesFunnel: 'Sales Funnel',
    events: 'events',
    pipeline: 'Pipeline',
    noEvents: 'No events',
    lostCancelled: 'Lost & Cancelled',
    lostLast30: 'Lost (30 days)',
    cancelledLast30: 'Cancelled (30 days)',
    lostThisYear: 'Lost (this year)',
    cancelledThisYear: 'Cancelled (this year)',
    cancellationRate: 'Cancellation Rate',
    conversionMetrics: 'Conversion Metrics',
    inquiryToProposal: 'Inquiry → Proposal',
    proposalToDefinite: 'Proposal → Definite',
    overallConversion: 'Overall Conversion',
    noActivity7Days: 'Events Without Activity',
    staleEventsHint: 'These events need follow-up action',
    forecastNext3Months: 'Forecast — Next 3 Months',
    definite: 'Definite',
    tentative: 'Tentative',
    total: 'Total',
    tasks: 'Tasks',
    addTask: 'Add Task',
    taskTitle: 'Task title...',
    priorityLabel: 'Priority',
    priorityLow: 'Low',
    priorityMedium: 'Medium',
    priorityHigh: 'High',
    dueDate: 'Due Date',
    linkedEvent: 'Linked Event',
    assignee: 'Assignee',
    unassigned: 'Unassigned',
    noEvent: 'No event',
    cancel: 'Cancel',
    save: 'Save',
    taskAll: 'All',
    taskOpen: 'Open',
    taskDone: 'Done',
    noTasks: 'No tasks',
    eventName: 'Event Name',
    dates: 'Dates',
    daysInStage: 'Days in Stage',
    lastUpdated: 'Last Updated',
    updated: 'Updated',
    searchEvents: 'Search events...',
    moveToNextStage: 'Move to Next Stage',
    actions: 'Actions',
    configReasons: 'Cancellation Reasons',
    configReasonsHint: 'Manage the reasons shown when cancelling or losing an event',
    noReasons: 'No reasons configured yet',
    newReasonPlaceholder: 'Add new reason...',
  },
  miceAnalytics: {
    lossByMonthTitle: 'Lost & cancelled per month',
    lossByMonthSub: 'By reason — counted in the month the decision was made',
    lossByMonthEmpty: 'Nothing was lost or cancelled this year.',
    lossKindAll: 'All',
    lossUndated: '{n} more with no decision date (no status history) — not in the chart.',
    lossAdgTitle: 'Cancelled by ADG',
    lossAdgSub: 'Cancelled by ADG — by reason, in the month of the decision',
    lossCustomerTitle: 'Customer cancellation',
    lossCustomerSub: 'Cancelled by the customer — by reason, in the month of the decision',
    lostRevenueTitle: 'Lost revenue (forgone)',
    lostRevenueSub: 'Planned revenue of lost & cancelled events — by event date',
    lostRevenueEmpty: 'No lost revenue this year.',
    title: 'MICE Analytics',
    subtitle: 'Performance insights & trends',
    loading: 'Loading analytics...',
    totalEvents: 'Total Events',
    won: 'Won',
    lostCancelled: 'Lost / Cancelled',
    pending: 'Pending',
    inPipeline: 'In Pipeline',
    avgDaysToWin: 'Avg Days to Win',
    daysAvg: 'days average',
    winRate: 'win rate',
    ofTotal: 'of total',
    active: 'active',
    vsLastYear: 'vs last year',
    totalLabel: 'total',
    monthlyTrend: 'Monthly Event Trend',
    conversionFunnel: 'Conversion Funnel',
    lossAnalysis: 'Loss Analysis',
    noLosses: 'No lost or cancelled events this period',
    lostBy: 'Lost by category',
    customerDecision: 'Customer Decision',
    noAvailability: 'No Availability',
    otherReasons: 'Other',
    unspecified: 'Unspecified',
    performanceOverview: 'Performance Overview',
    byEventType: 'By Event Type',
    forecast6Months: '6-Month Forecast',
    definite: 'Definite',
    tentative: 'Tentative',
    avgLeadTime: 'Average Lead Time',
    inquiryToWin: 'Inquiry → Win',
    avgForWon: 'Average for won events',
    inquiryToTentative: 'Inquiry → Tentative',
    avgForTentative: 'Average for tentative events',
    avgPipelineAge: 'Pipeline Age',
    openEvents: 'Currently open events',
    conversionMetrics: 'Conversion Metrics',
    noData: 'No data available',
    seasonality: 'Seasonality',
    lessActive: 'Less active',
    moreActive: 'More active',
  },
  permissions: {
    noStreamRight: 'No permission for this stream (Roles & Permissions)',
  },
  blockManager: {
    title: 'Block Manager',
    subtitle: 'Room blocks per event — held, picked up, releasable',
    property: 'Property',
    today: 'Today',
    week: 'Week',
    month: 'Month',
    quarter: 'Quarter',
    kpiHeld: 'Allocated rooms',
    kpiHeldSub: 'Booked + free · {n} incl. requested',
    kpiPicked: 'Booked',
    kpiPickedSub: '{pct}% of allocated rooms',
    kpiReleasable: 'Free in block',
    kpiReleasableSub: 'Still held, not booked — releasable',
    kpiNeverRelease: 'No release date',
    kpiNeverReleaseSub: 'Rooms are never freed automatically',
    colEvent: 'Event',
    colPeriod: 'Period',
    colRelease: 'Release',
    colTotal: 'Total',
    neverRelease: 'No release',
    neverReleaseHint: 'Without a release date MEWS holds the unbooked rooms indefinitely (NeverRelease).',
    releaseHint: 'Date when unbooked rooms go back into free sale',
    releaseToday: 'today',
    releasePassed: 'done',
    cellTitle: '{picked} booked · {free} free in block · {size} total',
    cellNoBlock: 'No block in this category',
    state_held: 'Held in MEWS',
    state_requested: 'Requested — no MEWS hold yet',
    state_draft: 'Draft — holds no rooms',
    state_failed: 'Failed',
    state_closed: 'Released / cancelled',
    loadFailed: 'Could not load block data',
    emptyTitle: 'No events in this period',
    emptyHint: 'Change the period or pick another property.',
    noCategoriesTitle: 'No room categories',
    noCategoriesHint: 'This property has no active room categories configured.',
    legendCell: 'Booked / Total',
    legendMeaning: '— Total = booked rooms + rooms still free in the block. MEWS takes every booked room out of the block; what stays free can be released. Requested blocks hold nothing yet.',
    legendExample: 'Example 2/3: 3 rooms allocated, 2 booked, 1 free',
  },
  contacts: {
    filterStorno: 'Cancelled',
    filterNoShowDone: 'No-show',
    filterOutstanding: 'Outstanding',
    openInMews: 'Open in MEWS',
    noMewsLink: 'No MEWS profile link for this entry',
    openInEvent: 'Open in event',
    stay: 'Stay',
    address: 'Address',
    debitor: 'Debtor account',
    invoiceable: 'Invoiceable',
    notInvoiceable: 'Not invoiceable',
    findInMews: 'Find in MEWS',
    title: 'Contacts',
    customers: 'Customers',
    companies: 'Companies',
    search: 'Search contacts...',
    searchMews: 'Search in MEWS (min. 3 chars)...',
    searching: 'Searching...',
    loadingMews: 'Loading from MEWS...',
    name: 'Name',
    email: 'Email',
    source: 'Source',
    phone: 'Phone',
    firstName: 'First Name',
    lastName: 'Last Name',
    nationality: 'Nationality',
    loyalty: 'Loyalty Code',
    companyName: 'Company Name',
    contactPerson: 'Contact Person',
    contact: 'Contact',
    taxId: 'Tax ID',
    customerDetail: 'Customer Details',
    companyDetail: 'Company Details',
    noResults: 'No results found',
    empty: 'No contacts yet',
    emptyDesc: 'Contacts will appear here when created through events or synced from MEWS.',
    tryDifferent: 'Try a different search term.',
    mewsHint: 'Search for customers or companies in MEWS',
    mewsHintDesc: 'Type at least 3 characters to search, or browse recent entries.',
    bcComingSoon: 'Business Central integration coming soon.',
    bcCustomers: 'Customers',
    bcCompanies: 'Companies',
    bcContacts: 'Contacts',
    bcVendors: 'Vendors',
    bcNumber: 'No.',
    bcCompanyName: 'Company',
    bcPhone: 'Phone',
    bcCity: 'City',
    bcLoadFailed: 'Failed to load Business Central data.',
    results: 'results',
    searchBc: 'Search Business Central (min. 2 chars)…',
    bcSearchPrompt: 'Nothing in Business Central',
    bcSearchHint: 'Business Central returned no records for this selection.',
    bcFirstPage: 'First {n} — search to narrow down',
    retry: 'Retry',
    // Labels for the source-scoped kind selector. Each source picks the
    // subset that applies to it; the labels match the wording each
    // upstream system uses (MEWS calls people "customers", BC calls
    // them "contacts").
    kind_contacts: 'Contacts',
    kind_companies: 'Companies',
    kind_customers: 'Customers',
    kind_participants: 'Participants',
    participants: 'Participants',
    all: 'All',
    dayguest: 'Day Guest',
    external: 'External',
    // Per-type filter pills (participant_type). `otherHotel` sleeps in a
    // different hotel; internal/external guest are the internal-event kinds.
    otherHotel: 'Other hotel',
    online: 'Online',
    internalGuest: 'Internal (ADG)',
    externalGuest: 'External guest',
    type: 'Type',
    event: 'Event',
    arrival: 'Arrival',
    departure: 'Departure',
    nights: 'Nights',
    rate: 'Rate',
    searchParticipants: 'Search participants...',
    noParticipants: 'No participants found',
    syncFromMews: 'Sync from MEWS',
    syncSuccess: 'Contact synced from MEWS',
    syncFailed: 'Failed to sync contact',
    createSuccess: 'Contact created successfully',
    createFailed: 'Failed to create contact',
  },
  propertySetup: {
    accountModal: {
      address: 'Address',
    },
    title: 'Property Setup',
    subtitle: 'Configure spaces, equipment, menus, rates, and more',
    webhooks: {
      title: 'Webhooks',
      formatTitle: 'Format',
      formatEventHub: 'EventHub (JSON)',
      formatChat: 'Mattermost / Slack',
      formatChatHint: 'This URL looks like a Mattermost / Slack webhook — pick the “Mattermost / Slack” format, otherwise the receiver rejects the message.',
      formatChatExplain: 'Sends a chat message (field “text”). Authentication: none — the key is part of the URL.',
      messageTemplate: 'Message (optional)',
      messageTemplatePlaceholder: 'Empty = default text per trigger, e.g. “Reservation cancelled · #123 (Event #45)”',
      messageTemplateHelp: 'Placeholders:',
      intro: 'Register target URLs (e.g. Business Central) that get called on specific system events — for example, to update the status in the target system when a reservation status changes.',
      add: 'Add webhook',
      deliveryNotice: 'Endpoints are stored. Actual delivery (firing on system events) requires backend activation and is not active yet.',
      selectProperty: 'Please select a property first.',
      empty: 'No webhooks registered yet.',
      unnamed: 'Untitled',
      active: 'Active',
      inactive: 'Inactive',
      activate: 'Activate',
      deactivate: 'Deactivate',
      noEvents: 'No events selected',
      editTitle: 'Edit webhook',
      addTitle: 'New webhook',
      name: 'Name',
      namePlaceholder: 'e.g. Business Central – event status',
      url: 'Target URL',
      urlInvalid: 'Please enter a valid https URL.',
      secret: 'Signing secret (optional)',
      secretPlaceholder: 'HMAC signature header so the receiver can verify us',
      authTitle: 'Authentication to the target system',
      username: 'Username',
      password: 'Password',
      keyValue: 'Key value',
      testConnection: 'Test connection',
      probing: 'Testing…',
      probeNeedsUrl: 'Enter an https URL, then test',
      probeWithAuth: 'with auth',
      probeWithoutAuth: 'without auth',
      probeOk: 'Reachable — authentication is checked and accepted.',
      probeOpen: 'Reachable, but the endpoint also accepts calls WITHOUT authentication.',
      probeAuthRejected: 'Endpoint reachable, but the credentials were rejected.',
      probeNotFound: 'Host answers, but there is no endpoint at this path (404/405) — check the URL.',
      probeEndpointError: 'The endpoint answered with an error.',
      probeUnreachable: 'Not reachable — no answer (DNS, TLS, firewall or timeout).',
      credsNote: 'Credentials are stored encrypted alongside the property\'s other integration settings.',
      events: 'System events that trigger this webhook',
      activeLabel: 'Active (fires once backend delivery is enabled)',
      saveError: 'Save failed.',
      confirmDelete: 'Really delete this webhook?',
      mappingTitle: 'Field & value mapping',
      mappingHint: 'Translate our values into the target system\'s — e.g. status "cancelled" → "0".',
      addMapping: 'Mapping',
      noMapping: 'At least one mapping is required.',
      sourceField: 'Our field (e.g. status)',
      targetField: 'Target field (e.g. Status)',
      ourValue: 'our value (e.g. cancelled)',
      targetValue: 'target value (e.g. 0)',
      addValue: 'Value',
      mappingShort: 'Mapping',
      step1: 'Name & target',
      step2: 'Triggers',
      required: 'Required',
      orHint: 'OR-combined: the webhook fires as soon as ONE of the selected events occurs.',
      needName: 'Name is missing',
      needUrl: 'A valid https target URL is missing',
      needEvents: 'Select at least one trigger',
      needMapping: 'Define at least one complete mapping (field + value pair)',
      logsTitle: 'Logs (last 10)',
      logsEmpty: 'No deliveries yet — backend delivery is not active yet.',
      logTime: 'Time',
      logEvent: 'Event',
      logStatus: 'Status',
      logResult: 'Result',
      settings: 'Settings',
      settingsTitle: 'Delivery settings',
      settingsHint: 'Applies to all webhooks of this property. Poll interval and batch size are process-wide (server config).',
      maxAttempts: 'Max attempts',
      timeoutSec: 'Timeout (sec)',
      backoffBase: 'Retry base (sec)',
      backoffExplain: 'The retry base doubles per attempt (e.g. 30s → 60s → 120s …), capped at 30 min.',
      enabledLabel: 'Delivery activated',
      enabledOn: 'Events are sent to the endpoints.',
      enabledOff: 'All webhooks for this property are paused — nothing is sent.',
      deactivated: 'Deactivated',
    },
    tabs: {
      spaces: 'Spaces',
      products: 'Products',
      rules: 'Product Rules',
      webhooks: 'Webhooks',
      packages: 'Packages',
      series: 'Event Series',
      tags: 'Tags',
      mews: 'MEWS',
      equipment: 'Equipment',
      fnb: 'F&B',
      rates: 'Rates',
      roomTypes: 'Room types',
      storno: 'Storno rules',
      accountingCategories: 'Accounting categories',
      taxCodes: 'Tax codes',
      priceLists: 'Price lists',
      tax: 'Taxes',
      hotelOptimizer: 'Hotel Optimizer',
    },
    viewMap: 'View Map',
    buildingsFloors: 'Buildings & Floors',
    venueMap: 'Venue Map',
    mews: {
      customers: 'Customers',
      customersDesc: 'MEWS Customer Data',
      searchCustomers: 'Search and browse MEWS customer data',
      companies: 'Companies',
      companiesDesc: 'MEWS Company Data',
      searchCompanies: 'Search and browse MEWS company data',
      products: 'Products',
      productsDesc: 'MEWS Products & Services',
      searchProducts: 'Search and browse MEWS products',
      clickToSearch: 'Click to Search',
      searchPlaceholder: 'Enter search term...',
      search: 'Search',
      searching: 'Searching...',
      noResults: 'No Results Found',
      noResultsDesc: 'Try a different search term',
      browseServices: 'Select a service to view its products',
      browseServicesBtn: 'Browse Services',
      selectService: 'Select Service',
      viewProducts: 'View Products',
      invoiceable: 'Invoiceable',
      noProductsForService: 'No products found for this service',
      perTimeUnit: 'Per Time Unit',
      once: 'Once',
      categoryId: 'Category ID',
      external: 'External',
      backToServices: 'Back to Services',
    },
    selectProperty: 'Select Property',
    selectPropertyPrompt: 'Select a Property',
    selectPropertyDescription: 'Choose a property from the dropdown above to configure its settings',
    setDefault: 'Set as Default',
    defaultProperty: 'Default',
    loadingPropertyData: 'Loading property data...',
    properties: 'Properties',
    spaces: 'Spaces',
    rooms: 'Rooms',
    equipment: 'Equipment',
    amenities: 'Amenities',
    rates: 'Rates',
    taxes: 'Taxes',
    users: 'Users',
    roles: 'Roles',
    menus: 'Menus',
    searchEquipment: 'Search equipment…',
    equipmentCountLabel: 'items',
    searchMenuItems: 'Search menu items…',
    menuItemsCountLabel: 'items',
    menuCategories: 'Categories',
    dietaryRestrictions: 'Dietary restrictions',
    noMenuItemsMatch: 'No menu items match your search',
    searchRates: 'Search rates…',
    stornoTitle: 'Storno rules per rate',
    stornoName: 'Rule',
    stornoScope: 'Applies to',
    stornoUnnamed: 'Unnamed',
    stornoInactive: 'inactive',
    stornoPortfolio: 'Portfolio',
    stornoEmpty: 'Not synced yet — run the MEWS sync.',
    stornoSyncedAt: 'last synced {at}',
    stornoCountLabel: 'rules',
    stornoSub: 'Synced from MEWS, like rates and room types. MEWS is the source of truth — change a rule there and re-sync here.',
    stornoRules: 'Rules',
    stornoDeadlineCol: 'Applies from',
    stornoFeeCol: 'Fee',
    stornoBasisCol: 'Charged on',
    stornoCapCol: 'Cap',
    stornoCapValue: 'max. {n} nights',
    stornoNoCap: 'no cap',
    stornoNoFee: 'no fee',
    stornoAnchorOther: 'Counted from {anchor}, not from arrival',
    stornoNoRule: 'No rule configured',
    stornoGroupsTitle: 'Rules per rate group',
    stornoGroupsSub: 'This is how MEWS applies them: every rate belongs to a rate group, and the rule hangs off the group.',
    stornoGroupCol: 'Rate group · rates',
    stornoArrival: 'arrival {time}',
    stornoRatesMore: '+{n} more',
    stornoRatesLess: 'less',
    stornoNoRates: 'no rate in EventHub',
    stornoGroupsEmpty: 'No rules per rate group yet — run the MEWS sync.',
    stornoWithoutRuleTitle: 'Rates without a cancellation rule',
    stornoWithoutRuleSub: 'MEWS holds no cancellation rule for these rates. That points at missing data — it is not a promise of free cancellation.',
    stornoCatalogueTitle: 'MEWS catalogue',
    stornoCatalogueSub: 'The named rule templates in MEWS. They belong to no service, so rules counted from the arrival time have no known clock time.',
    stornoFailed: 'Storno rules could not be loaded. This does NOT mean cancellation is free.',
    ratesCountLabel: 'rates',
    newRate: 'New rate',
    noRatesMatch: 'No rates match your search',
    tagsTab: {
      search: 'Search tags…',
      countLabel: 'tags',
      type: 'Type',
      allTypes: 'All types',
      add: 'Add tag',
      noMatch: 'No tags match your search',
      emptyTitle: 'No tags yet',
      emptyHint: 'Tags help categorize and filter events, sessions, spaces and more.',
      untyped: 'Untyped',
    },
    searchTaxRatesShort: 'Search tax rates…',
    taxRatesCountLabel: 'tax rates',
    noTaxRatesMatch: 'No tax rates match your search',
    taxCodeColumn: 'Tax code',
    percentageColumn: 'Percentage',
    productsTab: {
      colName: 'Name',
      colCategory: 'Category',
      colType: 'Type',
      colTax: 'Tax',
      colAccCat: 'Acc. Cat',
      colCharging: 'Charging',
      colStreams: 'Streams',
      colActive: 'Active',
      newProduct: 'New product',
      editProduct: 'Edit product',
      search: 'Search products…',
      countLabel: 'of {total} products',
      type: 'Type',
      allTypes: 'All types',
      categories: 'Categories',
      add: 'Add',
      emptyTitle: 'No products yet',
      emptyHint: 'Import from MEWS or add one manually.',
      noMatch: 'No products match',
    },
    buildingsShort: 'Buildings',
    spacesCountLabel: 'spaces',
    features: 'Features',
    setupTypes: 'Setup Types',
    newProperty: 'New Property',
    editProperty: 'Edit Property',
    newSpace: 'New Space',
    editSpace: 'Edit Space',
    deleteSpace: 'Delete Space',
    propertyName: 'Property Name',
    address: 'Address',
    city: 'City',
    country: 'Country',
    phone: 'Phone',
    email: 'Email',
    code: 'Code',
    floor: 'Floor',
    theatre: 'Theatre',
    classroom: 'Classroom',
    uShape: 'U-Shape',
    block: 'Block',
    round: 'Round',
    retreat: 'Retreat',
    boardroom: 'Boardroom',
    banquet: 'Banquet',
    reception: 'Reception',
    searchSpaces: 'Search spaces...',
    noSpacesConfigured: 'No spaces configured',
    noSpacesMatch: 'No spaces match your search',
    gridView: 'Grid View',
    tableView: 'Table View',
    gallery: 'Gallery',
    list: 'List',
    splitView: 'Split',
    addSpace: 'Add Space',
    createSpace: 'Create Space',
    noSpacesFound: 'No Spaces Found',
    active: 'Active',
    inactive: 'Inactive',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    name: 'Name',
    description: 'Description',
    capacity: 'Capacity',
    area: 'Area',
    addEquipment: 'Add Equipment',
    noEquipmentFound: 'No Equipment Found',
    createEquipment: 'Create Equipment',
    quantity: 'Quantity',
    addMenuItem: 'Add Menu Item',
    noMenuItemsFound: 'No Menu Items Found',
    createMenuItem: 'Create Menu Item',
    category: 'Category',
    price: 'Price',
    addRate: 'Add Rate',
    noRatesFound: 'No Rates Found',
    createRate: 'Create Rate',
    rateType: 'Rate Type',
    amount: 'Amount',
    addTaxRate: 'Add Tax Rate',
    noTaxRatesFound: 'No Tax Rates Found',
    createTaxRate: 'Create Tax Rate',
    taxCode: 'Tax Code',
    percentage: 'Percentage',
    addUser: 'Add User',
    noUsersFound: 'No Users Found',
    createUser: 'Create User',
    firstName: 'First Name',
    lastName: 'Last Name',
    addRole: 'Add Role',
    noRolesFound: 'No Roles Found',
    createRole: 'Create Role',
    permissions: 'Permissions',
    shareable: 'Shareable',
    autoAssign: 'Auto-Assign',
    digitalSignage: 'Signage',
    status: 'Status',
    actions: 'Actions',
    yes: 'Yes',
    pleaseEnterSpaceName: 'Please enter a space name',
    pleaseSelectRoomType: 'Please select a room type',
    fnb: 'F&B',
    contacts: 'Contacts',
    // Parties
    parties: {
      title: 'Parties',
      customers: 'Customers',
      companies: 'Companies',
      filterAll: 'All',
      searchPlaceholder: 'Search by name, email, ID...',
      searchMewsPlaceholder: 'Search MEWS (min. 3 characters)...',
      search: 'Search',
      searching: 'Searching...',
      loadingRecent: 'Loading recent entries...',
      name: 'Name',
      email: 'Email',
      source: 'Source',
      mewsId: 'MEWS ID',
      bcId: 'BC ID',
      noResults: 'No matches found',
      tryDifferentFilter: 'Try a different search term or filter.',
      noPartiesYet: 'No parties yet',
      noPartiesDesc: 'Parties are created when you link customers or companies to events.',
      mewsNoData: 'No MEWS data loaded',
      mewsNoDataDesc: 'Click the MEWS button to load recent customers or companies.',
      mewsResults: 'results from MEWS',
      sortedByRecent: 'sorted by last changed',
      syncFromMews: 'Sync from MEWS',
      syncSuccess: 'Party updated from MEWS',
      syncFailed: 'Failed to sync from MEWS',
      createSuccess: 'Party created and linked from MEWS',
      createFailed: 'Failed to create or link party from MEWS',
      bcComingSoon: 'BC integration coming soon',
      bcComingSoonDesc: 'Business Central party browsing will be available in a future update.',
      detailCustomerSubtitle: 'MEWS Customer',
      detailCompanySubtitle: 'MEWS Company',
      detailFirstName: 'First Name',
      detailLastName: 'Last Name',
      detailPhone: 'Phone',
      detailNationality: 'Nationality',
      detailLoyalty: 'Loyalty Code',
      detailBirthDate: 'Birth Date',
      detailTitle: 'Title',
      detailCreated: 'Created',
      detailUpdated: 'Last Updated',
      detailCompanyName: 'Company Name',
      detailContactPerson: 'Contact Person',
      detailContact: 'Contact',
      detailExternalId: 'External ID',
      detailNumber: 'Number',
      detailTaxId: 'Tax ID',
      detailInvoicingEmail: 'Invoicing Email',
      detailBillingSection: 'Invoicing & Billing',
      detailInvoiceable: 'Invoiceable',
      detailCreditRating: 'Credit Rating',
      detailActive: 'Status',
      detailBillingCode: 'Billing Code',
      detailInvoiceDue: 'Invoice Due',
      detailClassifications: 'Classifications',
      yes: 'Yes',
      no: 'No',
    },
    // Series
    series: {
      countLabel: 'series',
      searchPlaceholder: 'Search series...',
      newSeries: 'New Series',
      noSeriesFound: 'No series found',
      noSeriesYet: 'No event series yet',
      noSeriesDesc: 'Create series to group related events together',
      createFirst: 'Create first series',
      editSeries: 'Edit Series',
      newSeriesTitle: 'New Event Series',
      type: 'Type',
      organizer: 'Organizer',
      department: 'Department',
      startDate: 'Start Date',
      endDate: 'End Date',
      period: 'Period',
      selectType: 'Select type...',
      bachelor: 'Bachelor',
      seminar: 'Seminar',
      conference: 'Conference',
      workshop: 'Workshop',
      training: 'Training',
      certification: 'Certification',
      completed: 'Completed',
      cancelled: 'Cancelled',
      organizerPlaceholder: 'Organizer name',
      departmentPlaceholder: 'Department',
      descriptionPlaceholder: 'Description of the series...',
      namePlaceholder: 'e.g. Leadership Program 2026',
    },
    // Spaces modal
    spaceModal: {
      basicInfo: 'Basic Information',
      roomDetails: 'Room Details',
      roomType: 'Room Type',
      seating: 'Seating',
      roomTypePlaceholder: 'Seminar room, event room, etc.',
      style: 'Style',
      stylePlaceholder: 'e.g. castle/baroque',
      floorWindows: 'Floor Windows',
      floorWindowsPlaceholder: 'Yes/No/Partial/One side',
      dimensions: 'Dimensions',
      width: 'Width (m)',
      length: 'Length (m)',
      height: 'Height (m)',
      areaSqm: 'Area (m²)',
      setupCapacities: 'Setup Type Capacities',
      maxCapacity: 'Max capacity',
      roundTable: 'Round Table',
      amenities: 'Amenities & Features',
      pricing: 'Pricing',
      pricingMiceNote: 'These prices apply exclusively to MICE Events (Meetings, Incentives, Conferences, Exhibitions). Billing is per day.',
      perDay: 'per day',
      priceNet: 'Price (Net)',
      priceGross: 'Price (Gross)',
      taxPercent: 'Tax (%)',
      netPrice: 'Net price',
      grossPrice: 'Gross price',
      taxPercentage: 'Tax percentage',
      additionalInfo: 'Additional Information',
      notes: 'Notes',
      notesPlaceholder: 'Any additional notes or information',
      statusSection: 'Status',
      combinedSpaces: 'Combined Spaces',
      addCombinedSpace: 'Add Combined Space',
      searchFeatures: 'Search features...',
      coffeePoint: 'Coffee Point in Front of Room',
      digitalSignage: 'Digital Signage',
      terraceAccess: 'Terrace Access',
      stagePossible: 'Stage Possible',
      hybridSetup: 'Hybrid setup possible',
      shareable: 'Shareable',
      autoAssign: 'Auto-Assign',
      noCombinedSpaces: 'No combined spaces selected',
      selectCombinedSpace: 'Select a space to combine with this space:',
      noSpacesAvailable: 'No other active spaces available',
    },
    // Equipment
    equipmentModal: {
      newEquipment: 'New Equipment',
      editEquipment: 'Edit Equipment',
      selectCategory: 'Select Category',
      stockQuantity: 'Stock Quantity',
      addCategory: 'Add Category',
      categories: 'Equipment Categories',
      noCategoriesFound: 'No equipment categories found',
    },
    // F&B / Menus
    menuModal: {
      newMenuItem: 'New Menu Item',
      editMenuItem: 'Edit Menu Item',
      selectCategory: 'Select Category',
      addCategory: 'Add Category',
      addDietaryRestriction: 'Add Dietary Restriction',
      dietaryCode: 'Code *',
      dietaryCodePlaceholder: 'e.g., VEG, GF, NUT_FREE',
      dietaryDescription: 'Description *',
      dietaryDescriptionPlaceholder: 'e.g., Vegetarian, Gluten Free',
      searchMenuItems: 'Search menu items...',
      categories: 'Menu Categories',
      noCategoriesFound: 'No menu categories found',
      dietaryRestrictions: 'Dietary Restrictions',
      noDietaryFound: 'No dietary restrictions found',
    },
    // Rates
    rateModal: {
      newRate: 'New Rate',
      editRate: 'Edit Rate',
      selectCategory: 'Select Category',
      baseAmount: 'Base Amount *',
      unit: 'Unit',
      perDay: 'Per Day',
      perHour: 'Per Hour',
      perPerson: 'Per Person',
      perItem: 'Per Item',
      flatRate: 'Flat Rate',
      addCategory: 'Add Category',
      searchRates: 'Search rates...',
      categories: 'Rate Categories',
      noCategoriesFound: 'No rate categories found',
    },
    rateCheck: {
      title: 'MEWS Rate Check',
      subtitle: 'Check availability, restrictions, pricing, and cancellation terms for a specific stay',
      live: 'Live from MEWS',
      guestKind: 'Guest type',
      hotel: 'Hotel guest',
      dayguest: 'Day guest',
      lecturer: 'Lecturer',
      arrival: 'Arrival',
      departure: 'Departure',
      sameDayEnd: 'End (same day)',
      roomType: 'Room category',
      chooseRoomType: 'Choose a room category',
      noMappedRoomTypes: 'This property has no active room category mapped to MEWS.',
      stream: 'Stream',
      allStreams: 'All streams',
      check: 'Check rates',
      checking: 'Checking…',
      failed: 'Rate check failed',
      propertyRequired: 'Select a property first.',
      datesRequired: 'Select valid arrival and departure dates.',
      checkoutAfterArrival: 'Departure must be after arrival.',
      roomRequired: 'A room category is required for hotel guests and lecturers.',
      of: 'of',
      ratesAvailable: 'rates are bookable for this selection',
      checkedAt: 'Checked:',
      cached: 'Short-lived cache',
      noRates: 'No local rates were found for this property and selection.',
      stornoUnavailableTitle: 'Cancellation terms could not be checked',
      stornoUnavailable: 'MEWS did not grant access to the cancellation policies. This does not mean that cancellation is free.',
      price: 'Price',
      totalUnavailable: 'Total price unavailable',
      nightlyPrices: 'Nightly prices',
      pricingUnavailable: 'MEWS pricing is unavailable for this selection.',
      restrictions: 'Restrictions',
      noRestrictions: 'No matching MEWS restrictions for this period.',
      blocks: 'Blocks',
      exceptionSatisfied: 'Exception satisfied',
      arrivalRestriction: 'Arrival restriction',
      departureRestriction: 'Departure restriction',
      stayRestriction: 'Stay restriction',
      wholePeriod: 'Applies during the checked period',
      minAdvance: 'Minimum advance',
      maxAdvance: 'Maximum advance',
      minStay: 'Minimum stay',
      maxStay: 'Maximum stay',
      minPrice: 'Minimum price',
      maxPrice: 'Maximum price',
      storno: 'Cancellation',
      notVerified: 'Not verified — check directly in MEWS.',
      noStornoPolicies: 'MEWS returned no effective cancellation policy for this stay.',
      maximum: 'Maximum',
      timeUnits: 'time unit(s)',
      fee: 'fee',
      feeAccordingToMews: 'Fee according to MEWS',
      fromBooking: 'from booking',
      beforeArrival: 'before arrival',
      afterArrival: 'after arrival',
      atArrival: 'at arrival',
      fromArrival: 'from arrival',
      from: 'from',
      day: 'day',
      days: 'days',
      hour: 'hour',
      hours: 'hours',
      applicability: {
        available: 'Bookable',
        unmapped: 'Not mapped to MEWS',
        wrongService: 'Wrong MEWS service',
        missingInMews: 'Missing in MEWS',
        inactiveInMews: 'Inactive in MEWS',
        disabledInMews: 'Disabled in MEWS',
        blockOnly: 'Availability blocks only',
        restrictedForDates: 'Restricted for these dates',
      },
      weekdays: {
        monday: 'Mon',
        tuesday: 'Tue',
        wednesday: 'Wed',
        thursday: 'Thu',
        friday: 'Fri',
        saturday: 'Sat',
        sunday: 'Sun',
      },
    },
    // Taxes
    taxModal: {
      newTaxRate: 'New Tax Rate',
      editTaxRate: 'Edit Tax Rate',
      taxCode: 'Tax Code *',
      percentage: 'Percentage *',
      percentagePlaceholder: 'e.g., 8.5',
      searchTaxRates: 'Search tax rates...',
    },
    // Contacts
    contactModal: {
      newContact: 'New Contact',
      editContact: 'Edit Contact',
      firstName: 'First Name *',
      lastName: 'Last Name *',
      jobTitle: 'Job Title',
      searchContacts: 'Search contacts...',
    },
    // Users
    userModal: {
      newUser: 'New User',
      editUser: 'Edit User',
      fullName: 'Full Name *',
      searchUsers: 'Search users...',
    },
    // Packages
    packages: {
      title: 'Packages',
      searchPackages: 'Search packages...',
      searchPlaceholder: 'Search packages...',
      newPackage: 'New Package',
      noPackagesFound: 'No packages found',
      noPackagesYet: 'No packages yet',
      noPackagesDesc: 'Create packages from MEWS products with custom prices',
      createFirst: 'Create first package',
      editPackage: 'Edit Package',
      newPackageTitle: 'New Package',
      countLabel: 'packages',
      allGroups: 'All groups',
      packageName: 'Package name...',
      optionalDesc: 'Optional description...',
      products: 'Products',
      loadingPrices: 'Loading prices...',
      price: 'Price',
      quantity: 'Quantity',
      savePackage: 'Save Package',
      saving: 'Saving...',
      total: 'Total',
      selectProducts: 'Select Products',
      productsLoading: 'Loading products...',
      noProductsLoaded: 'No products loaded yet',
      loadProducts: 'Load Products',
      searchProducts: 'Search product...',
      productsSelected: '{count} product(s) selected',
      addProducts: 'Add {count} product(s)',
      alreadyAdded: 'added',
      noProductsMatch: 'No products found',
      noProductsYetDesc: 'No products yet — select MEWS products below',
      addProduct: 'Add product',
      charging: 'Charging',
      service: 'Service',
      nameRequired: 'Please enter a package name',
      updateError: 'Package could not be updated',
      createError: 'Package could not be created',
      itemsSaveError: 'Package products could not be saved',
      confirmDelete: 'Delete package "{name}"? All associated products will be removed.',
      deleteError: 'Package could not be deleted',
      product: 'Product',
      qty: 'Qty',
      selectPackage: 'Select a package to view its products',
      stream: 'Streams',
      allStreams: 'All Streams',
      noStream: 'No stream',
      allStreamsHint: 'No selection = all streams',
      createdBy: 'Created by',
      updatedBy: 'Updated by',
      createdAt: 'Created',
      updatedAt: 'Updated',
      allServices: 'All Services',
      allCategories: 'All Categories',
      allCharging: 'All Charging',
      category: 'Category',
      noCategory: 'No Category',
      selectCategory: 'Select Category',
    },
    // Common form
    noFeaturesMatch: 'No features match your search',
    noFeaturesFound: 'No features found',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMsg: 'Are you sure you want to delete this item? This action cannot be undone.',
    featureModal: {
      newFeature: 'New Feature',
      editFeature: 'Edit Feature',
    },
  },
  administration: {
    title: 'Administration',
    users: 'Users',
    roles: 'Roles',
    permissions: 'Permissions',
    settings: 'Settings',
    logs: 'Logs',
    backup: 'Backup',
    restore: 'Restore',
    systemHealth: 'System Health',
    newUser: 'New User',
    editUser: 'Edit User',
    firstName: 'First Name',
    lastName: 'Last Name',
    role: 'Role',
    lastLogin: 'Last Login',
  },
  spaceBooking: {
    requested: 'Room requested',
    requestedTooltip: 'Room requested — the hotel still has to pick a space',
    requestSpace: 'Request room',
    requestHint: 'Request without a space — the hotel picks a room and confirms',
    requestCreated: 'Room requested',
    requestFailed: 'Request failed',
    assignSpace: 'Assign space',
    assignFailed: 'Could not assign the space',
    noSpaceYet: 'No space yet (requested)',
    confirmFailed: 'The booking could not be confirmed.',
    confirmPartial: 'Only {done} of {total} days confirmed — the rest stay open.',
    confirmBooking: 'Confirm booking',
    confirmConflict: 'This room is already confirmed for this time. You can\'t confirm a second overlapping booking — cancel or move the other one first.',
    overbookingTitle: 'Space Conflict',
    overbookingMessage: 'This space is already booked during the selected time:',
    overbookingHint: 'You can still proceed, but this will create a double booking.',
    overbookingConfirm: 'Book Anyway',
    unavailableTitle: 'Space Not Available',
    unavailableMessage: 'The selected space cannot be booked for the requested period. It may be occupied by another event or blocked by a combined room conflict.',
  },
  themes: {
    title: 'Themes',
    subtitle: 'Preview every EventHub UI element across themes',
  },
  rolesPermissions: {
    selectAll: 'All',
    toggleWholeSection: 'Grant or revoke every permission in this section',
    specialPermissions: 'Special Permissions',
    specialPermissionsHint: 'Capabilities and gates that are not navigable pages — event streams, function-sheet workflow, Maya, raw tables and API access.',
    toggleWholeColumn: 'Set "{column}" for every row in this section',
    title: 'Administration',
    subtitle: 'Manage users, roles and access control',
    adminOnly: 'Access Denied',
    adminOnlyMsg: 'This page is restricted to administrators only.',
    noPermission: 'You do not have permission to manage users.',
    noSupertokensSession: 'No active SuperTokens session. Sign in with email/password to manage users.',
    usersTab: 'Users',
    rolesTab: 'Roles & Permissions',
    usersCount: 'users',
    addUser: 'Add User',
    loadingUsers: 'Loading users...',
    loadingRoles: 'Loading roles and permissions...',
    noUsers: 'No users found.',
    provider: 'Provider',
    deleteUser: 'Delete user',
    deleteUserPrompt: 'Sure?',
    deleteUserConfirm: 'Yes, delete',
    noAccess: 'No access yet',
    noAccessHint: 'This user has no role yet and cannot access EventHub. Click Edit to assign one.',
    searchUsers: 'Search users…',
    clearSearch: 'Clear search',
    noSearchMatches: 'No users match your search.',
    primaryRoleHint: 'Must be one of: adg-user, adg-admin, adg-superadmin (controls database-level access).',
    outrankedHint: 'This user outranks you. Only an adg-superadmin can edit them.',
    escalationBlocked: 'You cannot assign a role higher than your own.',
    entraRoleHint: 'Roles for Entra ID users are managed in Azure (App roles); not editable here.',
    email: 'Email',
    name: 'Name',
    fullName: 'Full Name',
    fullNamePlaceholder: 'e.g. John Doe',
    rolesLabel: 'Roles',
    joined: 'Joined',
    password: 'Password',
    primaryRole: 'Primary Role',
    defaultRole: 'Default (no role)',
    roleHint: 'Assign a predefined role to the new user',
    changeRole: 'Change',
    additionalRoles: 'Additional Roles',
    selectAdditionalRole: 'Select a role...',
    additionalRolesHint: 'Add extra roles for the user (optional)',
    editUserRoles: 'Edit User Roles',
    saveChanges: 'Save Changes',
    createUser: 'Create User',
    creating: 'Creating...',
    addRole: 'Add Role',
    adding: 'Adding...',
    roleName: 'Role Name',
    roleNameHint: 'Must match the role name in the JWT token',
    description: 'Description',
    descriptionPlaceholder: 'What this role is for...',
    selectRole: 'Select a Role',
    selectRoleMsg: 'Choose a role above to configure its page permissions',
    noDescription: 'No description',
    savePermissions: 'Save Permissions',
    saving: 'Saving...',
    deleteRole: 'Delete Role',
    deleteRoleMsg: 'Are you sure you want to delete {name}? This will remove all associated permissions.',
    deleting: 'Deleting...',
    delete: 'Delete',
    cancel: 'Cancel',
    grantAll: 'Grant All',
    readOnlyAll: 'Read Only All',
    revokeAll: 'Revoke All',
    page: 'Page',
    read: 'Read',
    create: 'Create',
    edit: 'Edit',
  },
  errors: {
    loadFailed: 'Failed to load data. Please try again.',
    saveFailed: 'Failed to save. Please try again.',
    deleteFailed: 'Failed to delete. Please try again.',
    retry: 'Retry',
  },
  apiDocs: {
    subtitle: 'Integration Documentation',
    gettingStarted: 'Getting Started',
    authentication: 'Authentication',
    authDescription: 'All API requests require an API key passed via the x-api-key header.',
    baseUrl: 'Base URL',
    endpoints: 'Endpoints',
    keyBehavior: 'Key Behavior',
    requiredFields: 'Required Fields',
    optionalFields: 'Optional Fields',
    field: 'Field',
    type: 'Type',
    note: 'Note',
    examples: 'Examples',
    createMinimal: 'Create (Minimal)',
    createFull: 'Create (All Fields)',
    update: 'Update',
    response: 'Response',
    copy: 'Copy',
    bsUpsertDescription: 'Create or update a BS stream event. Uses external_id for upsert matching.',
    bsAutoSet: 'is auto-set to "bs" — don\'t send it',
    bsUpsertLogic: 'Upsert logic: same external_id → updates existing event',
    bsPmsBlock: 'PMS block created/updated automatically when overnight_guests > 0',
    bsSpaceBooking: 'Space booking auto-triggered based on max_participants + dates',
    bsResponse: 'Response: action: "created" (201) or action: "updated" (200)',
  },
  reports: {
    title: 'Reports & Feedback',
    subtitle: 'Track bugs, requests, and wishes in one shared ticketing workspace.',
    allTickets: 'All Tickets',
    bugsCount: '{n} bug | {n} bugs',
    myTickets: 'My Tickets',
    openTickets: 'Open Tickets',
    retestTickets: 'Re-Test',
    retestPrompt: 'Was your issue resolved?',
    retestFailed: 'Not Resolved',
    retestSolved: 'Resolved',
    closeTicket: 'Close Ticket',
    retestReasonLabel: 'What still does not work?',
    retestReasonPlaceholder: 'e.g. still broken — step 3 throws a 500 when saving',
    retestReasonSubmit: 'Reopen ticket',
    retestQuestion: 'Is the problem still there?',
    retestQuestionYes: 'Yes – reopen the ticket',
    retestQuestionNo: 'No – just comment',
    commentSendFailed: 'Could not send the comment. Please try again.',
    unknownAuthor: 'Unknown',
    notesDamage: {
      chip: 'damaged',
      title: 'Comment thread damaged',
      kindUnparseable: 'The stored thread is not valid JSON – for example two lists glued together.',
      kindNotAList: 'The stored thread is not a list of comments.',
      kindWrapped: 'One entry holds a whole stored thread as its text. It is hidden from the thread for everyone, because it can contain internal comments.',
      kindDroppedEntries: 'Some stored entries are incomplete and are not shown in the thread.',
      appendRefused: 'New comments and history lines are refused until the thread is repaired in the database.',
      recovered: 'Recovered – view only, nothing is saved ({count})',
      nothingRecovered: 'No comment could be recovered.',
      raw: 'Stored raw text',
      hiddenEntry: 'This entry is damaged and is not shown.',
      writeRefused: 'This comment thread is damaged and cannot take new comments right now. Please contact the EventHub team.',
      retestReasonRefused: 'The ticket was reopened, but the reason could not be saved: the comment thread is damaged. Please contact the EventHub team.',
    },
    retestFailedConfirmed: 'Ticket reopened — the team has been given your feedback.',
    closeTicketConfirmed: 'Ticket closed. Thanks for testing!',
    retestUpdateFailed: 'Could not update the ticket. Please try again.',
    wontFixReasonRequired: 'Add a comment explaining why this ticket is declined before saving.',
    wontFixReasonMustBePublic: 'The reason for declining must be visible to the reporter. Untick “Admin only”.',
    closedTickets: 'Closed',
    resolvedTickets: 'Resolved Tickets',
    createTicket: 'Create Ticket',
    refreshList: 'Refresh list',
    groupByStatus: 'By status',
    groupByTag: 'By tag',
    tags: 'Tags',
    tagInputPlaceholder: 'Type a tag and press Enter…',
    allTags: 'All tags',
    untagged: 'Untagged',
    searchPlaceholder: 'Search by ticket no., title, description, email, or note',
    statusGroupDone: 'Resolved + closed',
    ageJustNow: 'just now',
    ageMinutes: '{n}m ago',
    ageHours: '{n}h ago',
    ageDays: '{n}d ago',
    collapseColumn: 'Collapse column',
    navPrev: 'Previous ticket',
    navNext: 'Next ticket',
    navBlocked: 'Unsaved changes — save or discard them first.',
    moreFilters: 'More filters',
    resetFilters: 'Reset filters',
    filters: 'Filters',
    reporter: 'Reporter',
    created: 'Created',
    updated: 'Updated',
    emptyTitle: 'No tickets match your current filters',
    emptyText: 'Try changing the filters or create a new ticket to get started.',
    detailTitle: 'Ticket Details',
    detailHint: 'Select a ticket to inspect the full conversation and metadata.',
    internalNotes: 'Internal Notes',
    noInternalNotes: 'No notes yet',
    addInternalNote: 'Add note or comment...',
    adminOnlyNoteToggle: 'Admin only',
    adminOnlyNoteBadge: 'Admin only',
    adminOnlyNoteHint: 'Only reports admins can read this comment. It is not mirrored to Azure DevOps.',
    postComment: 'Post comment',
    posting: 'Posting…',
    saveChanges: 'Save Changes',
    createPrompt: 'Describe the issue, request, or idea as clearly as you can.',
    createdBy: 'Created by',
    assignStatus: 'Status',
    assignPriority: 'Priority',
    reportMeta: 'Meta',
    ticket: 'Ticket',
    system: 'System',
    allSystems: 'All systems',
    systemHint: 'Originating system (default: eventhub)',
    systemOther: 'Other…',
    systemPlaceholder: 'system slug',
    assignedTo: 'Assigned To',
    unassigned: 'Unassigned',
    assigneeGroupFrequent: 'Frequently used',
    assigneeGroupAll: 'All users',
    onlyMine: 'Only Mine',
    onlyOpen: 'Only Open',
    total: 'Total',
    unreadUpdates: 'Unread updates',
    unresolved: 'Unresolved',
    mine: 'Mine',
    adminTools: 'Management',
    noSelection: 'No ticket selected',
    saveSuccess: 'Ticket updated successfully.',
    listView: 'List View',
    kanbanView: 'Kanban View',
    insights: {
      typeTrendTitle: 'What kind of reports',
      typeTrendHint: 'Newly created reports per week, broken down by type. A column\'s total is the "Created" line above it.',
      typeTrendEmpty: 'No reports were created in this period.',
      tab: 'Admin Insights',
      title: 'Admin Insights',
      subtitle: 'See workload, speed, and the tickets that need intervention now.',
      basedOnTickets: 'Based on all {count} tickets',
      activeQueue: 'Active queue',
      open: 'Open',
      inProgress: 'In progress',
      blocked: 'Blocked',
      done: 'Done',
      declined: 'Declined',
      active: 'Active',
      unassigned: 'Unassigned',
      critical: 'Critical',
      stale: 'Stale',
      old: 'Aging 14d+',
      queueHealthy: 'No blocked, critical, or unassigned tickets',
      averageActiveAge: 'Average active age',
      averageActiveAgeHint: 'Time since creation for tickets still active',
      doneLast30: 'Done in last 30 days',
      createdLast30: '{count} created in the same period',
      averageResolutionTime: 'Average time to done',
      averageResolutionHint: 'Created to resolved or closed',
      oldestActive: 'Oldest active ticket',
      noActiveTickets: 'No active tickets',
      needsAttention: 'Needs attention',
      needsAttentionHint: 'Prioritized by severity, ownership, inactivity, and age.',
      attentionSummary: '{count} tickets need manager attention',
      noAttentionSummary: 'No blocked, critical, unassigned, stale, or aging tickets need intervention.',
      blockedCount: '{count} blocked',
      criticalCount: '{count} critical',
      unassignedCount: '{count} unassigned',
      staleCount: '{count} inactive 7d+',
      oldCount: '{count} open 14d+',
      startWith: 'Start with',
      allSignals: 'All',
      noAttention: 'No tickets match this signal.',
      openFor: 'Open {duration}',
      inactiveFor: 'No activity for {duration}',
      actionAssign: 'Assign an owner',
      actionStartCritical: 'Start critical work',
      actionCheckCritical: 'Check critical progress',
      actionRequestUpdate: 'Request an update',
      actionReviewOld: 'Review aging ticket',
      actionUnblock: 'Unblock ticket',
      statusOverview: 'Status overview',
      flowTrendTitle: 'Ticket flow',
      flowTrendHint: 'Open backlog, new and resolved tickets per week — exact, from created and resolved dates.',
      flowOpen: 'Open backlog',
      flowCreated: 'Created',
      flowResolved: 'Resolved',
      flowRange8: '8 wks',
      flowRange12: '12 wks',
      flowRange26: '26 wks',
      ageProfile: 'Active queue age',
      ageProfileHint: 'How long current work has already been open.',
      ageBuckets: {
        under1: '< 1d',
        oneTo3: '1–3d',
        fourTo7: '4–7d',
        eightTo14: '8–14d',
        fifteenTo30: '15–30d',
        over30: '30d+',
      },
      teamWorkload: 'Assignee performance & workload',
      teamWorkloadHint: 'Current ownership, recent output, and speed at a glance.',
      highestWorkload: 'Highest workload',
      mostDone30: 'Most done · 30 days',
      fastestCompletion: 'Fastest completion · 30 days',
      needsSupport: 'Assignees needing attention',
      activeCount: '{count} active tickets',
      doneCount: '{count} completed',
      ofAssignees: 'of {count} assigned users',
      person: 'Person',
      currentWorkload: 'Current workload',
      doneLast30Short: 'Done · 30d',
      vsPrevious30: 'vs previous 30d',
      averageResolution30: 'Avg. done time · 30d',
      averageAge: 'Avg. active age',
      averageResolution: 'Avg. time to done',
      oldest: 'Oldest active',
      signals: 'Signals',
      timesAverage: '{value}× avg.',
      signalUnowned: 'Unowned work',
      signalCritical: 'Critical work',
      signalBlocked: 'Blocked work',
      signalNeedsSupport: 'Needs follow-up',
      signalClear: 'Queue clear',
      signalHighLoad: 'High load',
      signalOnTrack: 'On track',
      sortRisk: 'Highest attention first',
      sortActive: 'Most active tickets',
      sortOldest: 'Oldest ticket',
      sortDone: 'Most done in 30 days',
      currentAssigneeCaveat: 'Historical results are attributed to the current assignee because assignment changes are not stored.',
      reporterSignals: 'Reporter signals',
      reporterSignalsHint: 'Who submits reports and how much of their reported workload remains active.',
      submitted: 'Sent',
      unknownReporter: 'Unknown reporter',
      minutesShort: '{count}m',
      hoursShort: '{count}h',
      daysShort: '{count}d',
    },
    noTicketsInColumn: 'No tickets in this column',
    submitTitle: 'Submit a Report',
    reportDetails: 'Report Details',
    newReport: 'New Report',
    createFirst: 'Create First Report',
    loadingReports: 'Loading reports...',
    noReports: 'No reports found',
    type: 'Type',
    priority: 'Priority',
    titleField: 'Title',
    descriptionField: 'Description',
    attachImage: 'Attach image',
    screenshotOptional: 'Screenshot (optional)',
    attachments: 'Attachments',
    attachmentHint: 'Drop images here, click to browse, or paste from clipboard',
    screenshotHint: 'Click, drag & drop, or Ctrl+V to paste',
    screenshotMaxSize: 'PNG, JPG up to 5MB',
    screenshotTooLarge: 'Screenshot must be under 5MB',
    submit: 'Submit Report',
    submitting: 'Submitting...',
    submitSuccess: 'Report submitted successfully! Thank you for your feedback.',
    submitError: 'Failed to submit report. Please try again.',
    titlePlaceholder: 'Brief summary of the issue or request',
    descriptionPlaceholder: 'Please provide detailed information...',
    comments: 'Comments',
    noComments: 'No comments yet',
    addComment: 'Add a comment...',
    send: 'Send',
    bug: 'Bug',
    feature: 'Feature',
    wish: 'Wish',
    other: 'Other',
    bugReport: 'Bug Report',
    featureRequest: 'Feature Request',
    wishIdea: 'Wish / Idea',
    improvement: 'Improvement',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical',
    new: 'New',
    backlog: 'Backlog',
    todo: 'To do',
    inProgress: 'In Progress',
    blocked: 'Blocked',
    devTesting: 'Dev Testing',
    retest: 'To retest',
    resolved: 'Resolved',
    closed: 'Closed',
    wontFix: "Won't Fix",
    editTicket: 'Edit ticket',
    editTicketHint: 'Correct the title, description, type and system.',
    cancelEdit: 'Cancel edit',
    editedNoteSuffix: 'edited',
    editNote: 'Edit comment',
    deleteNote: 'Delete comment',
    deleteNoteConfirm: 'Delete this comment permanently?',
    deleteTicket: 'Delete ticket',
    deleteTicketConfirm: 'Delete ticket {ticket} permanently? This cannot be undone.',
    deleteTicketSuccess: 'Ticket deleted.',
    deleteAttachmentConfirm: 'Delete this attachment permanently?',
    conflictDetected: 'Someone else changed this ticket while it was open. The view has been reloaded — please re-apply your change.',
    invalidTransition: 'A new ticket cannot go straight to "Resolved". Accept it first (Backlog / To do / In progress).',
    editHistoryNote: 'Changed {fields}.',
    bulkSelected: '{count} selected',
    bulkClear: 'Clear selection',
    bulkStatus: 'Set status',
    bulkAssign: 'Assign to',
    bulkType: 'Set type',
    bulkPriority: 'Set priority',
    bulkSystem: 'Set system',
    bulkAddTag: 'Add tag…',
    bulkDelete: 'Delete',
    bulkDeleteConfirm: 'Delete {count} tickets permanently? This cannot be undone.',
    bulkApply: 'Apply',
    bulkApplying: 'Applying…',
    bulkFailed: '{count} of {total} could not be updated.',
    selectAllRows: 'Select all visible',
    url: 'URL',
    browser: 'Browser',
    technicalDetails: 'Technical details',
    showRawBrowserInfo: 'Show raw browser information',
    screenshot: 'Screenshot',
    devops: {
      settings: {
        title: 'Azure DevOps · connection',
        setup: 'Set up the DevOps connection',
        edit: 'Edit the DevOps connection',
        org: 'Organisation',
        project: 'Project',
        pat: 'Personal access token',
        patHint: 'Stays in your browser localStorage only. Choose "Read & Write" to create tickets.',
        identityMap: 'User mapping (EventHub → DevOps)',
        identityMapHint: 'Maps the EventHub assignee (name, id or email) to an Azure DevOps identity. Learned automatically when you promote.',
        identityMapKey: 'Name / id / email',
      },
      promote: 'Promote to DevOps',
      link: 'Link',
      viewData: 'DevOps data',
      liveAssignee: 'DevOps',
      liveAssigneeHint: 'Currently assigned in Azure DevOps (not synced)',
      linkOnCreate: 'Create in Azure DevOps right away',
      linkOnCreateHint: 'After saving, the DevOps window opens to link / create the work item.',
      searchPbi: 'Search PBIs…',
      searchFeatures: 'Search features…',
      searchEpics: 'Search epics…',
      noPbiMatch: 'No matching PBIs.',
      refresh: 'Refresh',
      openInAzure: 'Open in Azure DevOps',
      hierarchy: 'Hierarchy',
      priority: 'Priority',
      ownership: 'Ownership & history',
      assignedTo: 'Assigned to',
      unassigned: 'Unassigned',
      createdBy: 'Created by',
      changedBy: 'Last changed by',
      planning: 'Planning',
      area: 'Area',
      iteration: 'Iteration',
      tags: 'Tags',
      relatedItems: 'Other items in {type} #{id}',
      relatedItemsHint: 'Other direct children of the same parent item',
      noRelatedItems: 'No other items under this parent.',
      children: 'Direct child items',
      showingOf: 'Showing {shown} of {total} items.',
      parent: 'Parent',
      existingPbi: 'Existing PBI',
      newPbi: 'New PBI',
      newPbiTitle: 'PBI title',
      feature: 'Feature',
      existing: 'Existing',
      new: 'New',
      noFeature: '— No feature —',
      newFeatureTitle: 'Feature title',
      noEpic: '— No epic —',
      promoteHint: 'Accept the report first (set status to Backlog, To do or In progress).',
      linked: 'linked ✓ Task #{id}',
      title: 'Promote to Azure DevOps',
      parentPbi: 'Parent PBI',
      parentPbiPlaceholder: 'Select a Product Backlog Item…',
      assignee: 'Assignee',
      searchAssignee: 'Search users…',
      noAssigneeMatch: 'No matches — pick “Custom” for an email.',
      customAssignee: 'Custom (email)…',
      customAssigneePlaceholder: "name{'@'}example.com",
      loading: 'Loading DevOps data…',
      submit: 'Create Task',
      promoted: 'Linked to DevOps Task #{id}.',
      notConfigured: 'No Azure DevOps PAT found — configure it on the Azure board first.',
      syncing: 'Checking DevOps statuses…',
      syncedCount: '{count} updated from DevOps',
      openBoard: 'Open board',
      import: {
        button: 'Import from DevOps',
        title: 'Import from Azure DevOps',
        subtitle: 'Tasks & PBIs assigned to you that have no report yet.',
        loading: 'Loading your DevOps work items…',
        empty: 'Nothing to import — every work item assigned to you already has a report.',
        selectAll: 'Select all',
        allStates: 'All',
        importSelected: 'Import selected ({count})',
        importing: 'Importing…',
        done: '{count} imported',
        assigneeLabel: 'DevOps user',
        assigneeMe: 'Me (default)',
        assignToLabel: 'Assign to',
        assignNone: 'leave unassigned',
        load: 'Load',
        withDetails: 'With comments & attachments',
        withDetailsHint: 'Also copy the DevOps comment thread and file attachments onto each imported report.',
        loadingDetail: 'Loading work item…',
        noParent: 'No parent — this is a top-level item.',
        childItems: 'child work item(s)',
        noComments: 'No comments.',
      },
      pending: {
        title: 'New in Azure DevOps:',
        comment: 'comment',
        comments: 'comments',
        attachment: 'attachment',
        attachments: 'attachments',
        fetch: 'Fetch now',
        fetching: 'Fetching…',
        fetched: 'Fetched from Azure DevOps.',
      },
      connect: {
        intro: 'To create and link tickets, connect your Azure DevOps once with a personal access token (PAT). The token stays only in your browser.',
        step1: 'Open the token page and click',
        newToken: 'New Token',
        step1b: '.',
        step2: 'Under “Expiration”, choose Custom defined and set it about 1 year ahead.',
        step3: 'Under “Scopes”, select at least Work Items → Read & write.',
        step4: 'Copy the token and paste it here.',
        patLabel: 'Personal Access Token',
        patPlaceholder: 'Token with Work Items: Read & write',
        submit: 'Connect',
        connecting: 'Connecting…',
      },
    },
  },
  mewsFinance: {
    event: 'Event',
    chargeProducts: 'Charge Products',
    chargeDescription: 'Charging runs per tab: the tab first lists the lines and their warnings, and nothing is posted until you confirm there.',
    chargeFnb: 'Charge F&B…',
    chargeEquipment: 'Charge equipment…',
    internalEvent: 'Internal events are not charged to MEWS.',
    noProductsRight: 'You are not allowed to charge products on this event.',
    nothingPending: 'Nothing pending on this tab.',
    skipped: 'Skipped',
    chargeErrors: 'Errors',
  },
  propertyRules: {
    streamFilterHint: 'Filter by stream',
    category: 'Category',
    charging: 'Charging',
    price: 'Price',
    ruleEditorDiscardBody: 'Unsaved product and trigger changes will be lost.',
    countLabel: 'rules',
    title: 'Product Rules & Pricing',
    productsSelected: 'products selected',
    packageValue: 'Value',
    packageValueHint: 'Sum of the base prices of all products in this rule',
    noProducts: 'No products',
    unpricedHint: 'without a price — total incomplete',
    mixedCurrencyHint: 'Products in different currencies — cannot be summed',
    lecturer: 'Lecturer',
    lecturerOnly: 'Lecturer only',
    lecturerNone: 'No lecturer',
    triggerMode: 'Triggers',
    pricingMode: 'Pricing',
    howItChargesTitle: 'How charging works',
    howItChargesBody: 'Triggers only fire on arrival and departure days. On every day in between, all products in this rule are charged automatically.',
    priceList: 'Price list',
    newPriceList: 'New list',
    priceListName: 'Price list name',
    cloneFrom: 'Clone prices from',
    startEmpty: 'Start empty',
    addProduct: 'Add product',
    ruleEditorDiscard: 'Discard unsaved changes?',
    ruleEditorSaveFailed: 'Save failed',
    product: 'Product',
    defaultPrice: 'Default price',
    priceAndOverrides: 'Price & overrides',
    timeOverride: 'Active price list',
    timeOverrideHint: 'The displayed price is currently supplied by this price list (effective {date}).',
    rateOverrideHint: 'Rate-specific override from “{list}”, effective {date}.',
    total: 'Total',
    emptyTitle: 'No products yet',
    emptyDesc: 'Add products to configure triggers and pricing groups.',
    searchProducts: 'Search products...',
    noProductsAvailable: 'No more products available',
    mockNotice: 'Note:',
    mockNoticeDesc: 'Data is only kept in memory for now (no backend yet).',
    rule: 'Rule',
    newRule: 'New rule',
    renameRule: 'Rename',
    deleteRule: 'Delete',
    createRule: 'Create',
    ruleName: 'Rule name',
    ruleNamePlaceholder: 'e.g. Default tariff, Summer special...',
    noRules: '— No rules —',
    noRulesTitle: 'No rules yet',
    noRulesDesc: 'Create a new rule to get started.',
    noRulesFound: 'No matching rules',
    searchRules: 'Search rules...',
    allStreams: 'All streams',
    allStatus: 'All statuses',
    stream: 'Stream',
    rate: 'Rate',
    allRates: 'All rates',
    products: 'Products',
    priceLists: 'Price lists',
    deleteRuleConfirm: 'Really delete rule "{name}"? All associated product configurations and prices will be lost.',
    monitor: 'Monitor',
    monitorTitle: 'Rule Monitor',
    monitorSubtitle: 'Input vs. Output — what was sent to MEWS',
    chargesLog: 'Charges log',
    chargesLogTitle: 'Charges log',
    chargesLogSubtitle: 'Recent products charged by rule triggers (all rules)',
    chargesLogEmpty: 'No rule-driven charges yet.',
    chargesLogLimitHint: 'Last 500 entries',
    chargesLogSearchPlaceholder: 'Event, product or rule...',
    chargedAt: 'Time',
    chargeTo: 'Charged to',
    participantsShort: 'pax',
    kpiTotal: 'Total',
    kpiCharges: 'Charges',
    kpiRules: 'Rules',
    kpiEvents: 'Events',
    from: 'From',
    to: 'To',
    exportCsv: 'Export CSV',
    input: 'Input',
    outputMews: 'Output (to MEWS)',
    productLines: 'product lines',
    event: 'Event',
    arrival: 'Arrival',
    departure: 'Departure',
    rateGroup: 'Rate',
    processedAt: 'Processed',
    totalEntries: 'Total entries',
    statusPending: 'Pending',
    statusProcessed: 'Processed',
    statusFailed: 'Failed',
    filterAll: 'All',
    noEntries: 'No entries.',
    errorFromMews: 'MEWS error',
    awaitingProcessing: 'Awaiting processing...',
    noProductLines: 'No product lines.',
    vormittag: 'Morning',
    nachmittag: 'Afternoon',
    triggeredByPackage: 'Triggered by package',
    standaloneProducts: 'Standalone products',
    triggers: {
      anreiseVormittag: 'Arrival morning',
      anreiseNachmittag: 'Arrival afternoon',
      abreiseVormittag: 'Departure morning',
      abreiseNachmittag: 'Departure afternoon',
      tagesgast: 'Day guest',
      uebernachtung: 'Overnight',
    },
    groups: {
      mitglied: 'Member',
      nichtMitglied: 'Non-member',
      studentBest: 'Student BEST',
      studentVodafoneEdeka: 'Student Vodafone/Edeka',
      tagesgast: 'Day guest',
      tagesgastBest: 'Day guest BEST',
      tagesgastVodafone: 'Day guest Vodafone',
    },
  },
  maya: {
    title: 'Maya',
    subtitle: 'AI Assistant',
    greeting: 'Hi! I\'m Maya, your EventHub assistant. How can I help you today?',
    placeholder: 'Ask Maya anything about your events...',
    send: 'Send',
    close: 'Close',
    clear: 'Clear chat',
    thinking: 'Maya is thinking...',
    suggestions: {
      findEvent: 'Find an event',
      upcomingEvents: 'Show upcoming events',
      eventRequirements: 'Check event requirements',
      availableSpaces: 'Available spaces',
    },
    errors: {
      generic: 'Something went wrong. Please try again.',
      noResults: 'No results found for your query.',
    },
  },
  eventHealth: {
    title: 'System check',
    menuHint: 'Check this event against MEWS & linked data',
    introTitle: 'Start the system check?',
    introBody: 'Checks this event’s room blocks, reservations and charges against MEWS. The check is read-only and can take a few seconds.',
    start: 'Start check',
    checking: 'Checking blocks, reservations and charges…',
    allGood: 'Everything is in order',
    degraded: 'Minor discrepancies',
    unhealthy: 'Something is wrong',
    notFound: 'Event not found',
    unknown: 'Unknown',
    errors: 'errors',
    warnings: 'warnings',
    nothingFlagged: 'Nothing flagged.',
    checkedAt: 'Checked',
    checkedItems: 'checked',
    findings: 'Findings',
    recheck: 'Check again',
    healing: 'Repairing…',
    healRan: 'Repair executed',
    noMewsSide: 'no MEWS counterpart',
    mewsNotConfirmed: 'MEWS open',
    amountsChecked: 'amounts verified',
    amountsUnknown: 'without a comparison value',
    mewsUnreachable: 'Parts of the check could not reach MEWS. That does not mean anything is wrong — those points simply were not checked.',
    sectionBlocks: 'Room blocks',
    sectionReservations: 'Reservations',
    sectionSpaces: 'Space bookings',
    sectionCharges: 'Product charges',
  },
  taskModal: {
    onlyAssigneeCloses: 'Only the assignee can close this task.',
    title: 'My tasks',
    openCount: '{n} open',
    overdueSuffix: '{n} overdue',
    newTask: 'New task',
    viewActive: 'Open',
    viewClosed: 'Done',
    viewSent: 'Sent',
    viewSentOpen: 'Sent open',
    viewHistory: 'History',
    formTitlePlaceholder: 'Task title…',
    formDescriptionPlaceholder: 'Description (optional)…',
    assignedTo: 'Assigned to',
    nobody: '— Nobody —',
    userSearchPlaceholder: 'Search name or email…',
    event: 'Event',
    eventSearchPlaceholder: 'Search…',
    eventNone: '— None —',
    noMatches: 'No matches',
    priority: 'Priority',
    due: 'Due',
    creating: 'Creating…',
    createTask: 'Create task',
    emptyActive: 'No open tasks.',
    emptySent: 'No sent tasks.',
    emptySentOpen: 'No open sent tasks.',
    emptyClosed: 'No completed tasks.',
    emptyHistory: 'No history.',
    noDueDate: 'no due date',
    assignedByShort: 'from',
    createdBy: 'Created by',
    createdBySelf: 'me',
    sectionSentOpen: 'Open',
    sectionSentClosed: 'Done',
    overdue: 'overdue',
    markDone: 'Mark as done',
    reopen: 'Reopen',
    fallbackTitle: 'Task',
    noDescription: 'No description.',
    hintActive: 'Clicking a task completes it.',
    hintSent: 'Tasks you created for other people.',
    hintClosed: 'Completed tasks — "Reopen" brings one back.',
    confirmCompleteTitle: 'Mark task as done?',
    confirmCompleteBody: '"{title}" will be closed and leave your open tasks.',
    confirmCompleteCta: 'Done',
    kpiOpen: 'Open',
    kpiOverdue: 'Overdue',
    kpiToday: 'Today',
    kpiWeek: 'This week',
    kpiNoDue: 'No date',
    prioUrgent: 'Urgent',
    prioHigh: 'High',
    prioMedium: 'Medium',
    prioLow: 'Low',
    statusOpen: 'Open',
    statusInProgress: 'In progress',
    statusDone: 'Done',
    statusCancelled: 'Cancelled',
  },
  accessDenied: {
    title: 'No permission',
    body: 'Your role may not {action} here.',
    bodyWithSubject: 'Your role may not {action} "{subject}".',
    action: {
      read: 'read',
      create: 'create',
      edit: 'edit',
      delete: 'delete',
    },
    neededLabel: 'Permission needed',
    askAdmin: 'An administrator can grant this under Administration ▸ Roles & permissions.',
    technicalDetails: 'Technical details',
  },
  mewsNotes: {
    title: 'Note in MEWS',
    hint: 'Shows the notes attached to the reservation in MEWS — the field above is EventHub’s internal note and is never sent.',
    show: 'Show',
    reload: 'Reload',
    resync: 'Send to MEWS',
    syncing: 'Sending…',
    inSync: 'up to date',
    outOfSync: 'differs',
    snapshot: 'Would be sent',
    inMews: 'In MEWS',
    current: 'current',
    none: 'MEWS holds no note for this reservation.',
    readFailed: 'MEWS could not be read:',
    notFound: 'No note data for this reservation.',
    resyncResult: '{pushed} sent · {unchanged} unchanged · {failed} failed',
  },
}
